/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 162);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(22);
var hide = __webpack_require__(13);
var redefine = __webpack_require__(14);
var ctx = __webpack_require__(23);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(366);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(56)('wks');
var uid = __webpack_require__(37);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(25);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(111);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(28);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return BrowserRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return HashRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(159);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "__RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useHistory", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useLocation", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useParams", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "useRouteMatch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(110);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["createBrowserHistory"](_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["createHashHistory"](_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? __WEBPACK_IMPORTED_MODULE_3_history__["createLocation"](to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */](false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */](false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? __WEBPACK_IMPORTED_MODULE_0_react_router__["j" /* matchPath */](currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({}, styleProp, {}, activeStyle) : styleProp;

    var props = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var createDesc = __webpack_require__(36);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(13);
var has = __webpack_require__(16);
var SRC = __webpack_require__(37)('src');
var $toString = __webpack_require__(166);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(22).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(4);
var defined = __webpack_require__(28);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(57);
var defined = __webpack_require__(28);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(58);
var createDesc = __webpack_require__(36);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(111);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(16);
var toObject = __webpack_require__(10);
var IE_PROTO = __webpack_require__(82)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return Accordion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItem", function() { return AccordionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItemButton", function() { return AccordionItemButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItemHeading", function() { return AccordionItemHeadingWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItemPanel", function() { return AccordionItemPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionItemState", function() { return AccordionItemState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetNextUuid", function() { return resetNextUuid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var DisplayName;

(function (DisplayName) {
  DisplayName["Accordion"] = "Accordion";
  DisplayName["AccordionItem"] = "AccordionItem";
  DisplayName["AccordionItemButton"] = "AccordionItemButton";
  DisplayName["AccordionItemHeading"] = "AccordionItemHeading";
  DisplayName["AccordionItemPanel"] = "AccordionItemPanel";
})(DisplayName || (DisplayName = {}));

var DisplayName$1 = DisplayName;

var AccordionStore = function AccordionStore(_ref) {
  var _this = this;

  var _ref$expanded = _ref.expanded,
      _expanded = _ref$expanded === void 0 ? [] : _ref$expanded,
      _ref$allowMultipleExp = _ref.allowMultipleExpanded,
      allowMultipleExpanded = _ref$allowMultipleExp === void 0 ? false : _ref$allowMultipleExp,
      _ref$allowZeroExpande = _ref.allowZeroExpanded,
      allowZeroExpanded = _ref$allowZeroExpande === void 0 ? false : _ref$allowZeroExpande;

  _classCallCheck(this, AccordionStore);

  _defineProperty(this, "expanded", void 0);

  _defineProperty(this, "allowMultipleExpanded", void 0);

  _defineProperty(this, "allowZeroExpanded", void 0);

  _defineProperty(this, "toggleExpanded", function (uuid) {
    if (_this.isItemDisabled(uuid)) {
      return _this;
    }

    var isExpanded = _this.isItemExpanded(uuid);

    if (!isExpanded) {
      return _this.augment({
        expanded: _this.allowMultipleExpanded ? [].concat(_toConsumableArray(_this.expanded), [uuid]) : [uuid]
      });
    } else {
      return _this.augment({
        expanded: _this.expanded.filter(function (expandedUuid) {
          return expandedUuid !== uuid;
        })
      });
    }
  });

  _defineProperty(this, "isItemDisabled", function (uuid) {
    var isExpanded = _this.isItemExpanded(uuid);

    var isOnlyOneExpanded = _this.expanded.length === 1;
    return Boolean(isExpanded && !_this.allowZeroExpanded && isOnlyOneExpanded);
  });

  _defineProperty(this, "isItemExpanded", function (uuid) {
    return _this.expanded.indexOf(uuid) !== -1;
  });

  _defineProperty(this, "getPanelAttributes", function (uuid) {
    var expanded = _this.isItemExpanded(uuid);

    return {
      role: _this.allowMultipleExpanded ? undefined : 'region',
      'aria-hidden': _this.allowMultipleExpanded ? !expanded : undefined,
      'aria-labelledby': _this.getButtonId(uuid),
      id: _this.getPanelId(uuid),
      hidden: expanded ? undefined : true
    };
  });

  _defineProperty(this, "getHeadingAttributes", function (uuid) {
    return {
      role: 'heading'
    };
  });

  _defineProperty(this, "getButtonAttributes", function (uuid) {
    var expanded = _this.isItemExpanded(uuid);

    var disabled = _this.isItemDisabled(uuid);

    return {
      id: _this.getButtonId(uuid),
      'aria-disabled': disabled,
      'aria-expanded': expanded,
      'aria-controls': _this.getPanelId(uuid),
      role: 'button',
      tabIndex: 0
    };
  });

  _defineProperty(this, "getPanelId", function (uuid) {
    return "accordion__panel-".concat(uuid);
  });

  _defineProperty(this, "getButtonId", function (uuid) {
    return "accordion__heading-".concat(uuid);
  });

  _defineProperty(this, "augment", function (args) {
    return new AccordionStore(_objectSpread({
      expanded: _this.expanded,
      allowMultipleExpanded: _this.allowMultipleExpanded,
      allowZeroExpanded: _this.allowZeroExpanded
    }, args));
  });

  this.expanded = _expanded;
  this.allowMultipleExpanded = allowMultipleExpanded;
  this.allowZeroExpanded = allowZeroExpanded;
};

var Context = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);
var Provider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Provider, _React$PureComponent);

  function Provider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", new AccordionStore({
      expanded: _this.props.preExpanded,
      allowMultipleExpanded: _this.props.allowMultipleExpanded,
      allowZeroExpanded: _this.props.allowZeroExpanded
    }));

    _defineProperty(_assertThisInitialized(_this), "toggleExpanded", function (key) {
      _this.setState(function (state) {
        return state.toggleExpanded(key);
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state.expanded);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isItemDisabled", function (key) {
      return _this.state.isItemDisabled(key);
    });

    _defineProperty(_assertThisInitialized(_this), "isItemExpanded", function (key) {
      return _this.state.isItemExpanded(key);
    });

    _defineProperty(_assertThisInitialized(_this), "getPanelAttributes", function (key) {
      return _this.state.getPanelAttributes(key);
    });

    _defineProperty(_assertThisInitialized(_this), "getHeadingAttributes", function (key) {
      return _this.state.getHeadingAttributes(key);
    });

    _defineProperty(_assertThisInitialized(_this), "getButtonAttributes", function (key) {
      return _this.state.getButtonAttributes(key);
    });

    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          allowZeroExpanded = _this$state.allowZeroExpanded,
          allowMultipleExpanded = _this$state.allowMultipleExpanded;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Context.Provider, {
        value: {
          allowMultipleExpanded: allowMultipleExpanded,
          allowZeroExpanded: allowZeroExpanded,
          toggleExpanded: this.toggleExpanded,
          isItemDisabled: this.isItemDisabled,
          isItemExpanded: this.isItemExpanded,
          getPanelAttributes: this.getPanelAttributes,
          getHeadingAttributes: this.getHeadingAttributes,
          getButtonAttributes: this.getButtonAttributes
        }
      }, this.props.children || null);
    }
  }]);

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(Provider, "defaultProps", {
  allowMultipleExpanded: false,
  allowZeroExpanded: false
});

var Consumer =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(Consumer, _React$PureComponent2);

  function Consumer() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, Consumer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Consumer)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "renderChildren", function (container) {
      return container ? _this2.props.children(container) : null;
    });

    return _this2;
  }

  _createClass(Consumer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Context.Consumer, null, this.renderChildren);
    }
  }]);

  return Consumer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Accordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderAccordion", function (accordionContext) {
      var _this$props = _this.props,
          preExpanded = _this$props.preExpanded,
          allowMultipleExpanded = _this$props.allowMultipleExpanded,
          allowZeroExpanded = _this$props.allowZeroExpanded,
          onChange = _this$props.onChange,
          rest = _objectWithoutProperties(_this$props, ["preExpanded", "allowMultipleExpanded", "allowZeroExpanded", "onChange"]);

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({
        "data-accordion-component": "Accordion"
      }, rest));
    });

    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Provider, {
        preExpanded: this.props.preExpanded,
        allowMultipleExpanded: this.props.allowMultipleExpanded,
        allowZeroExpanded: this.props.allowZeroExpanded,
        onChange: this.props.onChange
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer, null, this.renderAccordion));
    }
  }]);

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Accordion, "defaultProps", {
  allowMultipleExpanded: undefined,
  allowZeroExpanded: undefined,
  onChange: undefined,
  className: 'accordion',
  children: undefined
});

_defineProperty(Accordion, "displayName", DisplayName$1.Accordion);

var DEFAULT = 0;
var counter = DEFAULT;
function nextUuid() {
  var current = counter;
  counter = counter + 1;
  return current;
}
function resetNextUuid() {
  counter = DEFAULT;
}

var Context$1 = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);

var Provider$1 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "toggleExpanded", function () {
      _this.props.accordionContext.toggleExpanded(_this.props.uuid);
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (accordionContext) {
      var uuid = _this.props.uuid;
      var expanded = accordionContext.isItemExpanded(uuid);
      var disabled = accordionContext.isItemDisabled(uuid);
      var panelAttributes = accordionContext.getPanelAttributes(uuid);
      var headingAttributes = accordionContext.getHeadingAttributes(uuid);
      var buttonAttributes = accordionContext.getButtonAttributes(uuid);
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Context$1.Provider, {
        value: {
          uuid: uuid,
          expanded: expanded,
          disabled: disabled,
          toggleExpanded: _this.toggleExpanded,
          panelAttributes: panelAttributes,
          headingAttributes: headingAttributes,
          buttonAttributes: buttonAttributes
        },
        children: _this.props.children
      });
    });

    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer, null, this.renderChildren);
    }
  }]);

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ProviderWrapper = function ProviderWrapper(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer, null, function (accordionContext) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Provider$1, _extends({}, props, {
      accordionContext: accordionContext
    }));
  });
};
var Consumer$1 =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Consumer, _React$PureComponent);

  function Consumer() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, Consumer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Consumer)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "renderChildren", function (container) {
      return container ? _this2.props.children(container) : null;
    });

    return _this2;
  }

  _createClass(Consumer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Context$1.Consumer, null, this.renderChildren);
    }
  }]);

  return Consumer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var defaultProps = {
  className: 'accordion__item'
};

var AccordionItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccordionItem, _React$Component);

  function AccordionItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "instanceUuid", nextUuid());

    return _this;
  }

  _createClass(AccordionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$uuid = _this$props.uuid,
          uuid = _this$props$uuid === void 0 ? this.instanceUuid : _this$props$uuid,
          rest = _objectWithoutProperties(_this$props, ["uuid"]);

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProviderWrapper, {
        uuid: uuid
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({
        "data-accordion-component": "AccordionItem"
      }, rest)));
    }
  }]);

  return AccordionItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(AccordionItem, "defaultProps", defaultProps);

_defineProperty(AccordionItem, "displayName", DisplayName$1.AccordionItem);

function getClosestAccordion(el) {
  return el && (el.matches('[data-accordion-component="Accordion"]') ? el : getClosestAccordion(el.parentElement));
}
function getSiblingButtons(item) {
  var parentAccordion = getClosestAccordion(item);
  return parentAccordion && Array.from(parentAccordion.querySelectorAll('[data-accordion-component="AccordionItemButton"]'));
}
function focusFirstSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var first = siblings[0];

  if (first) {
    first.focus();
  }
}
function focusLastSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var last = siblings[siblings.length - 1];

  if (last) {
    last.focus();
  }
}
function focusNextSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var currentIndex = siblings.indexOf(item);

  if (currentIndex !== -1) {
    var next = siblings[currentIndex + 1];

    if (next) {
      next.focus();
    }
  }
}
function focusPreviousSiblingOf(item) {
  var siblings = getSiblingButtons(item) || [];
  var currentIndex = siblings.indexOf(item);

  if (currentIndex !== -1) {
    var previous = siblings[currentIndex - 1];

    if (previous) {
      previous.focus();
    }
  }
}

var keycodes = {
  DOWN: '40',
  END: '35',
  ENTER: '13',
  HOME: '36',
  LEFT: '37',
  RIGHT: '39',
  SPACE: '32',
  UP: '38'
};

var defaultProps$1 = {
  className: 'accordion__button'
};
var AccordionItemButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AccordionItemButton, _React$PureComponent);

  function AccordionItemButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItemButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (evt) {
      var keyCode = evt.which.toString();

      if (keyCode === keycodes.ENTER || keyCode === keycodes.SPACE) {
        evt.preventDefault();

        _this.props.toggleExpanded();
      }
      /* The following block is ignored from test coverage because at time
       * time of writing Jest/react-testing-library can not assert 'focus'
       * functionality.
       */
      // istanbul ignore next


      if (evt.target instanceof HTMLElement) {
        switch (keyCode) {
          case keycodes.HOME:
            {
              evt.preventDefault();
              focusFirstSiblingOf(evt.target);
              break;
            }

          case keycodes.END:
            {
              evt.preventDefault();
              focusLastSiblingOf(evt.target);
              break;
            }

          case keycodes.LEFT:
          case keycodes.UP:
            {
              evt.preventDefault();
              focusPreviousSiblingOf(evt.target);
              break;
            }

          case keycodes.RIGHT:
          case keycodes.DOWN:
            {
              evt.preventDefault();
              focusNextSiblingOf(evt.target);
              break;
            }

          default:

        }
      }
    });

    return _this;
  }

  _createClass(AccordionItemButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          toggleExpanded = _this$props.toggleExpanded,
          rest = _objectWithoutProperties(_this$props, ["toggleExpanded"]);

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({}, rest, {
        // tslint:disable-next-line react-a11y-event-has-role
        onClick: toggleExpanded,
        onKeyDown: this.handleKeyPress,
        "data-accordion-component": "AccordionItemButton"
      }));
    }
  }]);

  return AccordionItemButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(AccordionItemButton, "defaultProps", defaultProps$1);

var AccordionItemButtonWrapper = function AccordionItemButtonWrapper(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer$1, null, function (itemContext) {
    var toggleExpanded = itemContext.toggleExpanded,
        buttonAttributes = itemContext.buttonAttributes;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AccordionItemButton, _extends({
      toggleExpanded: toggleExpanded
    }, props, buttonAttributes));
  });
};

AccordionItemButtonWrapper.displayName = DisplayName$1.AccordionItemButton;

var defaultProps$2 = {
  className: 'accordion__heading',
  'aria-level': 3
};
var SPEC_ERROR = "AccordionItemButton may contain only one child element, which must be an instance of AccordionItemButton.\n\nFrom the WAI-ARIA spec (https://www.w3.org/TR/wai-aria-practices-1.1/#accordion):\n\n\u201CThe button element is the only element inside the heading element. That is, if there are other visually persistent elements, they are not included inside the heading element.\u201D\n\n";
var AccordionItemHeading =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AccordionItemHeading, _React$PureComponent);

  function AccordionItemHeading() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItemHeading);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemHeading)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "setRef", function (ref) {
      _this.ref = ref;
    });

    return _this;
  }

  _createClass(AccordionItemHeading, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      AccordionItemHeading.VALIDATE(this.ref);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      AccordionItemHeading.VALIDATE(this.ref);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({
        "data-accordion-component": "AccordionItemHeading"
      }, this.props, {
        ref: this.setRef
      }));
    }
  }], [{
    key: "VALIDATE",
    value: function VALIDATE(ref) {
      if (ref === undefined) {
        throw new Error('ref is undefined');
      }

      if (!(ref.childElementCount === 1 && ref.firstElementChild && ref.firstElementChild.getAttribute('data-accordion-component') === 'AccordionItemButton')) {
        throw new Error(SPEC_ERROR);
      }
    }
  }]);

  return AccordionItemHeading;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

_defineProperty(AccordionItemHeading, "defaultProps", defaultProps$2);

var AccordionItemHeadingWrapper = function AccordionItemHeadingWrapper(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer$1, null, function (itemContext) {
    var headingAttributes = itemContext.headingAttributes;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AccordionItemHeading, _extends({}, props, headingAttributes));
  });
};

AccordionItemHeadingWrapper.displayName = DisplayName$1.AccordionItemHeading;

var defaultProps$3 = {
  className: 'accordion__panel'
};

var AccordionItemPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccordionItemPanel, _React$Component);

  function AccordionItemPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItemPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (_ref) {
      var panelAttributes = _ref.panelAttributes;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({
        "data-accordion-component": "AccordionItemPanel"
      }, _this.props, panelAttributes));
    });

    return _this;
  }

  _createClass(AccordionItemPanel, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer$1, null, this.renderChildren);
    }
  }]);

  return AccordionItemPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(AccordionItemPanel, "defaultProps", defaultProps$3);

_defineProperty(AccordionItemPanel, "displayName", DisplayName$1.AccordionItemPanel);

var AccordionItemState =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccordionItemState, _React$Component);

  function AccordionItemState() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItemState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemState)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (itemContext) {
      var expanded = itemContext.expanded,
          disabled = itemContext.disabled;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, _this.props.children({
        expanded: expanded,
        disabled: disabled
      }));
    });

    return _this;
  }

  _createClass(AccordionItemState, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Consumer$1, null, this.renderChildren);
    }
  }]);

  return AccordionItemState;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FadeIn["default"];
  }
});

var _FadeIn = _interopRequireDefault(__webpack_require__(433));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(11);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(4);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(22);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(23);
var IObject = __webpack_require__(57);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var asc = __webpack_require__(98);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(8)) {
  var LIBRARY = __webpack_require__(33);
  var global = __webpack_require__(3);
  var fails = __webpack_require__(4);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(73);
  var $buffer = __webpack_require__(106);
  var ctx = __webpack_require__(23);
  var anInstance = __webpack_require__(43);
  var propertyDesc = __webpack_require__(36);
  var hide = __webpack_require__(13);
  var redefineAll = __webpack_require__(45);
  var toInteger = __webpack_require__(25);
  var toLength = __webpack_require__(7);
  var toIndex = __webpack_require__(139);
  var toAbsoluteIndex = __webpack_require__(39);
  var toPrimitive = __webpack_require__(27);
  var has = __webpack_require__(16);
  var classof = __webpack_require__(49);
  var isObject = __webpack_require__(5);
  var toObject = __webpack_require__(10);
  var isArrayIter = __webpack_require__(95);
  var create = __webpack_require__(40);
  var getPrototypeOf = __webpack_require__(19);
  var gOPN = __webpack_require__(41).f;
  var getIterFn = __webpack_require__(97);
  var uid = __webpack_require__(37);
  var wks = __webpack_require__(6);
  var createArrayMethod = __webpack_require__(30);
  var createArrayIncludes = __webpack_require__(63);
  var speciesConstructor = __webpack_require__(60);
  var ArrayIterators = __webpack_require__(100);
  var Iterators = __webpack_require__(51);
  var $iterDetect = __webpack_require__(68);
  var setSpecies = __webpack_require__(42);
  var arrayFill = __webpack_require__(99);
  var arrayCopyWithin = __webpack_require__(128);
  var $DP = __webpack_require__(9);
  var $GOPD = __webpack_require__(18);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(134);
var $export = __webpack_require__(0);
var shared = __webpack_require__(56)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(137))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(37)('meta');
var isObject = __webpack_require__(5);
var has = __webpack_require__(16);
var setDesc = __webpack_require__(9).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(4)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(6)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(113);
var enumBugKeys = __webpack_require__(83);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(25);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(114);
var enumBugKeys = __webpack_require__(83);
var IE_PROTO = __webpack_require__(82)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(80)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(84).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(113);
var hiddenKeys = __webpack_require__(83).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(8);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var call = __webpack_require__(126);
var isArrayIter = __webpack_require__(95);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(7);
var getIterFn = __webpack_require__(97);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(14);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(9).f;
var has = __webpack_require__(16);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(24);
var TAG = __webpack_require__(6)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(28);
var fails = __webpack_require__(4);
var spaces = __webpack_require__(86);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(372)();
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _coreIcon = __webpack_require__(409);

var _coreIcon2 = _interopRequireDefault(_coreIcon);

var _financeIcon = __webpack_require__(410);

var _financeIcon2 = _interopRequireDefault(_financeIcon);

var _operationsIcon = __webpack_require__(411);

var _operationsIcon2 = _interopRequireDefault(_operationsIcon);

var _patientIcon = __webpack_require__(412);

var _patientIcon2 = _interopRequireDefault(_patientIcon);

var _staffIcon = __webpack_require__(413);

var _staffIcon2 = _interopRequireDefault(_staffIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    icon: _coreIcon2.default,
    number: "1",
    questions: ["111", "112", "113", "114", "115", "116", "121", "122", "123", "124"],
    secId: "core",
    subSections: ["11", "12"],
    summary1: "Does telehealth fit your practice?",
    summary2: "How does leadership feel about it?",
    title: "Core Readiness"
}, {
    icon: _financeIcon2.default,
    number: "2",
    questions: ["211", "212", "213", "214", "215"],
    secId: "finance",
    subSections: ["21"],
    summary1: "Can you afford telehealth?",
    summary2: "Can you afford not to offer it?",
    title: "Financial Considerations"
}, {
    icon: _operationsIcon2.default,
    number: "3",
    questions: ["311", "312", "313", "314", "321", "322", "323", "324", "325", "331", "332", "333", "334", "341", "342", "343", "344", "351", "352", "353", "354", "361", "362", "363"],
    secId: "operations",
    subSections: ["31", "32", "33", "34", "35", "36"],
    summary1: "Are you prepared for telehealth?",
    summary2: "What do you need to get started?",
    title: "Operations"
}, {
    icon: _staffIcon2.default,
    number: "4",
    questions: ["411", "412", "413", "421", "422", "423", "424"],
    secId: "staff",
    subSections: ["41", "42"],
    summary1: "How do staff feel about telehealth?",
    summary2: "Are they willing and engaged?",
    title: "Staff Engagement"
}, {
    icon: _patientIcon2.default,
    number: "5",
    questions: ["511", "512", "513", "514", "515", "521", "522", "523"],
    secId: "patient",
    subSections: ["51", "52"],
    summary1: "Is telehealth right for your patients?",
    summary2: "Is this what they want?",
    title: "Patient Readiness"
}];

/***/ }),
/* 55 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(33) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(24);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(11);
var SPECIES = __webpack_require__(6)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    number: "a",
    questions: ["111", "112", "113", "114", "115", "116"],
    secId: "core",
    subSecId: "11",
    title: "Need for Telehealth"
}, {
    number: "b",
    questions: ["121", "122", "123", "124"],
    secId: "core",
    subSecId: "12",
    title: "Organizational Leadership Buy-In"
}, {
    number: "a",
    questions: ["211", "212", "213", "214", "215"],
    secId: "finance",
    subSecId: "21",
    title: undefined
}, {
    number: "a",
    questions: ["311", "312", "313", "314"],
    secId: "operations",
    subSecId: "31",
    title: "Telehealth Roles"
}, {
    number: "b",
    questions: ["321", "322", "323", "324", "325"],
    secId: "operations",
    subSecId: "32",
    title: "Scheduling and Workflow"
}, {
    number: "c",
    questions: ["331", "332", "333", "334"],
    secId: "operations",
    subSecId: "33",
    title: "Operational Requirements"
}, {
    number: "d",
    questions: ["341", "342", "343", "344"],
    secId: "operations",
    subSecId: "34",
    title: "Assessment Approach"
}, {
    number: "e",
    questions: ["351", "352", "353", "354"],
    secId: "operations",
    subSecId: "35",
    title: "Technology"
}, {
    number: "f",
    questions: ["361", "362", "363"],
    secId: "operations",
    subSecId: "36",
    title: "Physical Space"
}, {
    number: "a",
    questions: ["411", "412", "413"],
    secId: "staff",
    subSecId: "41",
    title: "Education and Awareness"
}, {
    number: "b",
    questions: ["421", "422", "423", "424"],
    secId: "staff",
    subSecId: "42",
    title: "Innovators and Champions"
}, {
    number: "a",
    questions: ["511", "512", "513", "514", "515"],
    secId: "patient",
    subSecId: "51",
    title: "Patient Engagement"
}, {
    number: "b",
    questions: ["521", "522", "523"],
    secId: "patient",
    subSecId: "52",
    title: "Health Literacy"
}];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(39);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(24);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(25);
var defined = __webpack_require__(28);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(5);
var cof = __webpack_require__(24);
var MATCH = __webpack_require__(6)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(6)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(49);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(130);
var redefine = __webpack_require__(14);
var hide = __webpack_require__(13);
var fails = __webpack_require__(4);
var defined = __webpack_require__(28);
var wks = __webpack_require__(6);
var regexpExec = __webpack_require__(101);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var redefineAll = __webpack_require__(45);
var meta = __webpack_require__(34);
var forOf = __webpack_require__(44);
var anInstance = __webpack_require__(43);
var isObject = __webpack_require__(5);
var fails = __webpack_require__(4);
var $iterDetect = __webpack_require__(68);
var setToStringTag = __webpack_require__(48);
var inheritIfRequired = __webpack_require__(87);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(13);
var uid = __webpack_require__(37);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(33) || !__webpack_require__(4)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(3)[K];
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var ctx = __webpack_require__(23);
var forOf = __webpack_require__(44);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NextBtn = function NextBtn(_ref) {
    var nextLabel = _ref.nextLabel,
        nextLink = _ref.nextLink;

    return _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'btn question-btn', to: nextLink },
        _react2.default.createElement(
            'p',
            null,
            nextLabel
        ),
        _react2.default.createElement(
            'svg',
            { className: 'next', width: '30px', height: '14px', viewBox: '0 0 30 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement('path', { d: 'M1,6 L17,6 L17,1.61803399 C17,1.06574924 17.4477153,0.618033989 18,0.618033989 C18.1552451,0.618033989 18.3083582,0.654179081 18.4472136,0.723606798 L29.2111456,6.10557281 C29.7051241,6.35256206 29.9053485,6.9532351 29.6583592,7.4472136 C29.5615955,7.640741 29.404673,7.79766349 29.2111456,7.89442719 L18.4472136,13.2763932 C17.9532351,13.5233825 17.3525621,13.3231581 17.1055728,12.8291796 C17.0361451,12.6903242 17,12.5372111 17,12.381966 L17,8 L1,8 C0.44771525,8 6.76353751e-17,7.55228475 0,7 C-6.76353751e-17,6.44771525 0.44771525,6 1,6 Z' })
        )
    );
};

exports.default = NextBtn;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(22);
var LIBRARY = __webpack_require__(33);
var wksExt = __webpack_require__(112);
var defineProperty = __webpack_require__(9).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(56)('keys');
var uid = __webpack_require__(37);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(5);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(23)(Function.call, __webpack_require__(18).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var setPrototypeOf = __webpack_require__(85).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(25);
var defined = __webpack_require__(28);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(51);
var $iterCreate = __webpack_require__(92);
var setToStringTag = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(19);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(40);
var descriptor = __webpack_require__(36);
var setToStringTag = __webpack_require__(48);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(67);
var defined = __webpack_require__(28);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(6)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(51);
var ITERATOR = __webpack_require__(6)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(9);
var createDesc = __webpack_require__(36);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(49);
var ITERATOR = __webpack_require__(6)('iterator');
var Iterators = __webpack_require__(51);
module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(255);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(7);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(35);
var step = __webpack_require__(129);
var Iterators = __webpack_require__(51);
var toIObject = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(91)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(59);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(66)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var invoke = __webpack_require__(119);
var html = __webpack_require__(84);
var cel = __webpack_require__(80);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(24)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(103).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(24)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(11);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(8);
var LIBRARY = __webpack_require__(33);
var $typed = __webpack_require__(73);
var hide = __webpack_require__(13);
var redefineAll = __webpack_require__(45);
var fails = __webpack_require__(4);
var anInstance = __webpack_require__(43);
var toInteger = __webpack_require__(25);
var toLength = __webpack_require__(7);
var toIndex = __webpack_require__(139);
var gOPN = __webpack_require__(41).f;
var dP = __webpack_require__(9).f;
var arrayFill = __webpack_require__(99);
var setToStringTag = __webpack_require__(48);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(375);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBrowserHistory", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHashHistory", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLocation", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locationsAreEqual", function() { return locationsAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePath", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPath", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(110);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */](location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */](a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(80)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(6);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(16);
var toIObject = __webpack_require__(17);
var arrayIndexOf = __webpack_require__(63)(false);
var IE_PROTO = __webpack_require__(82)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17);
var gOPN = __webpack_require__(41).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(8);
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(64);
var pIE = __webpack_require__(58);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(57);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(4)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(11);
var isObject = __webpack_require__(5);
var invoke = __webpack_require__(119);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(3).parseInt;
var $trim = __webpack_require__(50).trim;
var ws = __webpack_require__(86);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(3).parseFloat;
var $trim = __webpack_require__(50).trim;

module.exports = 1 / $parseFloat(__webpack_require__(86) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(24);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(5);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(89);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var IObject = __webpack_require__(57);
var toLength = __webpack_require__(7);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(7);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(101);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(9).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(59)
});


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(105);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(135);
var validate = __webpack_require__(46);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(72)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(9).f;
var create = __webpack_require__(40);
var redefineAll = __webpack_require__(45);
var ctx = __webpack_require__(23);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var $iterDefine = __webpack_require__(91);
var step = __webpack_require__(129);
var setSpecies = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(8);
var fastKey = __webpack_require__(34).fastKey;
var validate = __webpack_require__(46);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(135);
var validate = __webpack_require__(46);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(72)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var each = __webpack_require__(30)(0);
var redefine = __webpack_require__(14);
var meta = __webpack_require__(34);
var assign = __webpack_require__(116);
var weak = __webpack_require__(138);
var isObject = __webpack_require__(5);
var validate = __webpack_require__(46);
var NATIVE_WEAK_MAP = __webpack_require__(46);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(72)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(45);
var getWeak = __webpack_require__(34).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(5);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var createArrayMethod = __webpack_require__(30);
var $has = __webpack_require__(16);
var validate = __webpack_require__(46);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(25);
var toLength = __webpack_require__(7);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(41);
var gOPS = __webpack_require__(64);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(3).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(65);
var isObject = __webpack_require__(5);
var toLength = __webpack_require__(7);
var ctx = __webpack_require__(23);
var IS_CONCAT_SPREADABLE = __webpack_require__(6)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(7);
var repeat = __webpack_require__(88);
var defined = __webpack_require__(28);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(8);
var getKeys = __webpack_require__(38);
var toIObject = __webpack_require__(17);
var isEnum = __webpack_require__(58).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(49);
var from = __webpack_require__(145);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(44);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(148);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"](WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */]({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default.a(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */]({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default.a(Connect, WrappedComponent);
  };
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(108);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(389);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(388);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */](value) || __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */](value) != objectTag) {
    return false;
  }
  var proto = __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */](value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(382);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(158);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(107);


function verifyPlainObject(value, displayName, methodName) {
  if (!__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */](value)) {
    __WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */](methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Prompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StaticRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return context; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generatePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return useHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return useLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return useParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return useRouteMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */]();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["createMemoryHistory"](_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = __WEBPACK_IMPORTED_MODULE_3_history__["createLocation"](computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = __WEBPACK_IMPORTED_MODULE_3_history__["createLocation"](prevProps.to);

        if (!__WEBPACK_IMPORTED_MODULE_3_history__["locationsAreEqual"](prevLocation, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : __WEBPACK_IMPORTED_MODULE_3_history__["createPath"](location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, __WEBPACK_IMPORTED_MODULE_3_history__["createLocation"](location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, __WEBPACK_IMPORTED_MODULE_3_history__["createLocation"](location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */]({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default.a(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PdfBtn = function PdfBtn(_ref) {
    var btnText = _ref.btnText,
        link = _ref.link;

    return _react2.default.createElement(
        'a',
        {
            onClick: function onClick() {
                gtag('event', 'Download all guidance', {
                    'event_category': 'download'
                });
            },
            className: 'btn pdf-btn no-print',
            target: '_blank',
            href: link
        },
        btnText,
        _react2.default.createElement(
            'svg',
            { className: 'pdf-icon', viewBox: '0 0 30 33', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { d: 'M7.93748466,16.9027677 C7.93748466,16.0144628 7.30564417,15.4843067 6.1906135,15.4843067 C5.73576687,15.4843067 5.42760736,15.5271289 5.26601227,15.5700708 L5.26601227,18.4225045 C5.45705521,18.4648475 5.69190184,18.4793412 6.01398773,18.4793412 C7.20361963,18.4793412 7.93748466,17.8918693 7.93748466,16.9027677 Z' }),
                _react2.default.createElement('path', { d: 'M14.8389571,15.5129347 C14.3392638,15.5129347 14.0170552,15.5558766 13.8255215,15.5988784 L13.8255215,21.9187677 C14.0166871,21.9624283 14.3250307,21.9624283 14.6040491,21.9624283 C16.6296319,21.9762632 17.9509202,20.8876225 17.9509202,18.5801379 C17.9657669,16.5730073 16.7616564,15.5129347 14.8389571,15.5129347 Z' }),
                _react2.default.createElement('path', { d: 'M28.0629448,11.799686 L27.2515337,11.799686 L27.2515337,7.97767514 C27.2515337,7.95383848 27.2476687,7.92982214 27.2444172,7.90568603 C27.2431288,7.75392196 27.193681,7.60485299 27.0872393,7.48674773 L20.5720859,0.22123775 C20.5701227,0.219381125 20.5682209,0.218722323 20.5668712,0.216686025 C20.5280368,0.174343013 20.4827607,0.139127042 20.434908,0.108642468 C20.4207362,0.0993593466 20.4064417,0.0915735027 20.3915951,0.0835480944 C20.3501227,0.0614482759 20.306135,0.0431215971 20.2608589,0.0298856624 C20.248589,0.0265317604 20.237546,0.0216206897 20.2252761,0.0185063521 C20.1760736,0.00712704174 20.1249693,0 20.0731902,0 L4.06134969,0 C3.33018405,0 2.73619632,0.580524501 2.73619632,1.2937078 L2.73619632,11.7993866 L1.92496933,11.7993866 C0.879018405,11.7993866 0.0309202454,12.6269619 0.0309202454,13.6484047 L0.0309202454,23.2636225 C0.0309202454,24.2843466 0.879018405,25.112461 1.92496933,25.112461 L2.73625767,25.112461 L2.73625767,31.6943739 C2.73625767,32.4074973 3.3302454,32.9880817 4.06141104,32.9880817 L25.9264417,32.9880817 C26.6569325,32.9880817 27.2515951,32.4075572 27.2515951,31.6943739 L27.2515951,25.112461 L28.0630061,25.112461 C29.1086503,25.112461 29.9569325,24.2843466 29.9569325,23.2636225 L29.9569325,13.6487042 C29.9569325,12.6273212 29.108589,11.799686 28.0629448,11.799686 Z M4.06134969,1.29394737 L19.4106135,1.29394737 L19.4106135,7.91269328 C19.4106135,8.27006352 19.7076074,8.55951724 20.0731902,8.55951724 L25.9263804,8.55951724 L25.9263804,11.8001053 L4.06134969,11.8001053 L4.06134969,1.29394737 Z M20.328773,18.5077296 C20.328773,20.3569274 19.6390184,21.6319492 18.6833742,22.4205953 C17.6422086,23.266078 16.0563804,23.6671688 14.1192025,23.6671688 C12.9596933,23.6671688 12.1377914,23.5954791 11.5792638,23.5240889 L11.5792638,14.0363793 C12.4012883,13.9076733 13.4736196,13.8359837 14.6040491,13.8359837 C16.4820859,13.8359837 17.7008589,14.1658639 18.6555215,14.8676679 C19.6826994,15.6130127 20.328773,16.8022704 20.328773,18.5077296 Z M3.04907975,23.5670907 L3.04907975,14.0363793 C3.73871166,13.9223466 4.70809816,13.8359837 6.07337423,13.8359837 C7.45319018,13.8359837 8.43699387,14.0939946 9.09736196,14.6102559 C9.72877301,15.0972305 10.1534969,15.899951 10.1534969,16.8458711 C10.1534969,17.7920907 9.83141104,18.5945717 9.24374233,19.1388022 C8.48042945,19.8412051 7.35018405,20.1567114 6.02858896,20.1567114 C5.73546012,20.1567114 5.47030675,20.1421579 5.26570552,20.1134102 L5.26570552,23.5673303 L3.04907975,23.5673303 L3.04907975,23.5670907 Z M25.9264417,31.3441906 L4.06134969,31.3441906 L4.06134969,25.112461 L25.9264417,25.112461 L25.9264417,31.3441906 L25.9264417,31.3441906 Z M27.8465031,15.6990762 L24.0434969,15.6990762 L24.0434969,17.9061234 L27.5964417,17.9061234 L27.5964417,19.6833321 L24.0434969,19.6833321 L24.0434969,23.5671506 L21.7985276,23.5671506 L21.7985276,13.9076733 L27.8465031,13.9076733 L27.8465031,15.6990762 Z' })
            )
        )
    );
};

exports.default = PdfBtn;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreBar = function ScoreBar(_ref) {
    var extraText = _ref.extraText,
        score = _ref.score;

    var findProps = function findProps(score) {
        if (score <= 50) {
            return {
                word: "Area for Improvement",
                description: "The practice is in the beginning stages and/or has not considered many of the aspects related to the concept.",
                className: "low-score"
            };
        } else if (score <= 75) {
            return {
                word: "Almost Ready",
                description: "The practice has considered some aspects related to the concept.",
                className: "medium-score"
            };
        } else {
            return {
                word: "Ready",
                description: "The practice has considered many aspects related to the concept.",
                className: "high-score"
            };
        }
    };

    var barProps = findProps(score);

    return _react2.default.createElement(
        "div",
        { className: "score-container" },
        _react2.default.createElement(
            "h4",
            { className: "bold" },
            extraText,
            _react2.default.createElement(
                "span",
                { className: barProps.className },
                barProps.word
            )
        ),
        _react2.default.createElement(
            "p",
            { className: "bottom-margin--sm no-print-margin" },
            barProps.description
        ),
        _react2.default.createElement(
            "div",
            { className: "progress score-bar no-print", role: "progressbar", tabIndex: "0", "aria-valuenow": "" + score, "aria-valuemin": "0", "aria-valuetext": barProps.word, "aria-valuemax": "100" },
            _react2.default.createElement("div", { className: "progress-meter " + barProps.className, style: { width: score + '%' } })
        )
    );
};

exports.default = ScoreBar;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
module.exports = __webpack_require__(365);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(164);

__webpack_require__(361);

__webpack_require__(362);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(170);
__webpack_require__(171);
__webpack_require__(172);
__webpack_require__(173);
__webpack_require__(174);
__webpack_require__(175);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(178);
__webpack_require__(179);
__webpack_require__(180);
__webpack_require__(181);
__webpack_require__(182);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);
__webpack_require__(186);
__webpack_require__(187);
__webpack_require__(188);
__webpack_require__(189);
__webpack_require__(190);
__webpack_require__(191);
__webpack_require__(192);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(195);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(198);
__webpack_require__(199);
__webpack_require__(200);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
__webpack_require__(204);
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(209);
__webpack_require__(210);
__webpack_require__(211);
__webpack_require__(212);
__webpack_require__(213);
__webpack_require__(214);
__webpack_require__(215);
__webpack_require__(216);
__webpack_require__(217);
__webpack_require__(218);
__webpack_require__(219);
__webpack_require__(220);
__webpack_require__(221);
__webpack_require__(222);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(225);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(228);
__webpack_require__(229);
__webpack_require__(230);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(253);
__webpack_require__(254);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(100);
__webpack_require__(269);
__webpack_require__(130);
__webpack_require__(270);
__webpack_require__(131);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(134);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(276);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
module.exports = __webpack_require__(22);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(14);
var META = __webpack_require__(34).KEY;
var $fails = __webpack_require__(4);
var shared = __webpack_require__(56);
var setToStringTag = __webpack_require__(48);
var uid = __webpack_require__(37);
var wks = __webpack_require__(6);
var wksExt = __webpack_require__(112);
var wksDefine = __webpack_require__(81);
var enumKeys = __webpack_require__(167);
var isArray = __webpack_require__(65);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(10);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(36);
var _create = __webpack_require__(40);
var gOPNExt = __webpack_require__(115);
var $GOPD = __webpack_require__(18);
var $GOPS = __webpack_require__(64);
var $DP = __webpack_require__(9);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(41).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(58).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(33)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56)('native-function-to-string', Function.toString);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(64);
var pIE = __webpack_require__(58);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(40) });


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(9).f });


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperties: __webpack_require__(114) });


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(17);
var $getOwnPropertyDescriptor = __webpack_require__(18).f;

__webpack_require__(29)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(10);
var $getPrototypeOf = __webpack_require__(19);

__webpack_require__(29)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(10);
var $keys = __webpack_require__(38);

__webpack_require__(29)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(29)('getOwnPropertyNames', function () {
  return __webpack_require__(115).f;
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(34).onFreeze;

__webpack_require__(29)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(34).onFreeze;

__webpack_require__(29)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(5);
var meta = __webpack_require__(34).onFreeze;

__webpack_require__(29)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(5);

__webpack_require__(29)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(5);

__webpack_require__(29)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(5);

__webpack_require__(29)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(116) });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(117) });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(85).set });


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(49);
var test = {};
test[__webpack_require__(6)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(14)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(118) });


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(9).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(19);
var HAS_INSTANCE = __webpack_require__(6)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(9).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(120);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(121);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var has = __webpack_require__(16);
var cof = __webpack_require__(24);
var inheritIfRequired = __webpack_require__(87);
var toPrimitive = __webpack_require__(27);
var fails = __webpack_require__(4);
var gOPN = __webpack_require__(41).f;
var gOPD = __webpack_require__(18).f;
var dP = __webpack_require__(9).f;
var $trim = __webpack_require__(50).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(40)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(8) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(14)(global, NUMBER, $Number);
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(25);
var aNumberValue = __webpack_require__(122);
var repeat = __webpack_require__(88);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(4)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(4);
var aNumberValue = __webpack_require__(122);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(3).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(123) });


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(123);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(121);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(120);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(124);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(89);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(90);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(125) });


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(124) });


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(89) });


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(90);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(4)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(90);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(39);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(7);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(50)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(66)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(91)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(66)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(7);
var context = __webpack_require__(93);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(94)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(93);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(94)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(88)
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(7);
var context = __webpack_require__(93);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(94)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(15)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(15)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(15)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(15)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(15)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(15)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(15)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(15)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(15)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(15)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(15)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(15)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(15)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(27);

$export($export.P + $export.F * __webpack_require__(4)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(244);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(4);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(14)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(13)(proto, TO_PRIMITIVE, __webpack_require__(247));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(27);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(65) });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(23);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var call = __webpack_require__(126);
var isArrayIter = __webpack_require__(95);
var toLength = __webpack_require__(7);
var createProperty = __webpack_require__(96);
var getIterFn = __webpack_require__(97);

$export($export.S + $export.F * !__webpack_require__(68)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(96);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(4)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(57) != Object || !__webpack_require__(26)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(84);
var cof = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(7);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(4)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var toObject = __webpack_require__(10);
var fails = __webpack_require__(4);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(26)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(30)(0);
var STRICT = __webpack_require__(26)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var isArray = __webpack_require__(65);
var SPECIES = __webpack_require__(6)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(30)(1);

$export($export.P + $export.F * !__webpack_require__(26)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(30)(2);

$export($export.P + $export.F * !__webpack_require__(26)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(30)(3);

$export($export.P + $export.F * !__webpack_require__(26)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(30)(4);

$export($export.P + $export.F * !__webpack_require__(26)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(127);

$export($export.P + $export.F * !__webpack_require__(26)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(127);

$export($export.P + $export.F * !__webpack_require__(26)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(63)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(26)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(17);
var toInteger = __webpack_require__(25);
var toLength = __webpack_require__(7);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(26)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(128) });

__webpack_require__(35)('copyWithin');


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(99) });

__webpack_require__(35)('fill');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(30)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(35)(KEY);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(30)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(35)(KEY);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42)('Array');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var inheritIfRequired = __webpack_require__(87);
var dP = __webpack_require__(9).f;
var gOPN = __webpack_require__(41).f;
var isRegExp = __webpack_require__(67);
var $flags = __webpack_require__(59);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(4)(function () {
  re2[__webpack_require__(6)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(14)(global, 'RegExp', $RegExp);
}

__webpack_require__(42)('RegExp');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(131);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(59);
var DESCRIPTORS = __webpack_require__(8);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(14)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(4)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toLength = __webpack_require__(7);
var advanceStringIndex = __webpack_require__(102);
var regExpExec = __webpack_require__(69);

// @@match logic
__webpack_require__(70)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var toInteger = __webpack_require__(25);
var advanceStringIndex = __webpack_require__(102);
var regExpExec = __webpack_require__(69);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(70)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var sameValue = __webpack_require__(117);
var regExpExec = __webpack_require__(69);

// @@search logic
__webpack_require__(70)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(67);
var anObject = __webpack_require__(2);
var speciesConstructor = __webpack_require__(60);
var advanceStringIndex = __webpack_require__(102);
var toLength = __webpack_require__(7);
var callRegExpExec = __webpack_require__(69);
var regexpExec = __webpack_require__(101);
var fails = __webpack_require__(4);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(70)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var global = __webpack_require__(3);
var ctx = __webpack_require__(23);
var classof = __webpack_require__(49);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(11);
var anInstance = __webpack_require__(43);
var forOf = __webpack_require__(44);
var speciesConstructor = __webpack_require__(60);
var task = __webpack_require__(103).set;
var microtask = __webpack_require__(104)();
var newPromiseCapabilityModule = __webpack_require__(105);
var perform = __webpack_require__(132);
var userAgent = __webpack_require__(71);
var promiseResolve = __webpack_require__(133);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(45)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(48)($Promise, PROMISE);
__webpack_require__(42)(PROMISE);
Wrapper = __webpack_require__(22)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(68)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(138);
var validate = __webpack_require__(46);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(72)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(73);
var buffer = __webpack_require__(106);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(39);
var toLength = __webpack_require__(7);
var isObject = __webpack_require__(5);
var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
var speciesConstructor = __webpack_require__(60);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(42)(ARRAY_BUFFER);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(73).ABV, {
  DataView: __webpack_require__(106).DataView
});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(3).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(4)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(40);
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(5);
var fails = __webpack_require__(4);
var bind = __webpack_require__(118);
var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(9);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(27);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(4)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(18).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(92)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(5);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(18);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(19);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(140) });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(9);
var gOPD = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(19);
var has = __webpack_require__(16);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(36);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(5);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(85);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(63)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(35)('includes');


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(141);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var aFunction = __webpack_require__(11);
var arraySpeciesCreate = __webpack_require__(98);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(35)('flatMap');


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(141);
var toObject = __webpack_require__(10);
var toLength = __webpack_require__(7);
var toInteger = __webpack_require__(25);
var arraySpeciesCreate = __webpack_require__(98);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(35)('flatten');


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(66)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(142);
var userAgent = __webpack_require__(71);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(142);
var userAgent = __webpack_require__(71);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(50)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(50)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(28);
var toLength = __webpack_require__(7);
var isRegExp = __webpack_require__(67);
var getFlags = __webpack_require__(59);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(92)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81)('asyncIterator');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(81)('observable');


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(140);
var toIObject = __webpack_require__(17);
var gOPD = __webpack_require__(18);
var createProperty = __webpack_require__(96);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(143)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(143)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(9);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(8) && $export($export.P + __webpack_require__(74), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var aFunction = __webpack_require__(11);
var $defineProperty = __webpack_require__(9);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(8) && $export($export.P + __webpack_require__(74), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(74), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(19);
var getOwnPropertyDescriptor = __webpack_require__(18).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(8) && $export($export.P + __webpack_require__(74), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(144)('Map') });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(144)('Set') });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(75)('Map');


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(75)('Set');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(75)('WeakMap');


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(75)('WeakSet');


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(76)('Map');


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(76)('Set');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(76)('WeakMap');


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(76)('WeakSet');


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(3) });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(3) });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(24);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(146);
var fround = __webpack_require__(125);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(146) });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(22);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(60);
var promiseResolve = __webpack_require__(133);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(105);
var perform = __webpack_require__(132);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(136);
var from = __webpack_require__(145);
var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(19);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(32);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(11);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(104)();
var process = __webpack_require__(3).process;
var isNode = __webpack_require__(24)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(3);
var core = __webpack_require__(22);
var microtask = __webpack_require__(104)();
var OBSERVABLE = __webpack_require__(6)('observable');
var aFunction = __webpack_require__(11);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(43);
var redefineAll = __webpack_require__(45);
var hide = __webpack_require__(13);
var forOf = __webpack_require__(44);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(42)('Observable');


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(3);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(71);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(103);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(100);
var getKeys = __webpack_require__(38);
var redefine = __webpack_require__(14);
var global = __webpack_require__(3);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(51);
var wks = __webpack_require__(6);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(363);
module.exports = __webpack_require__(22).RegExp.escape;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(364)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(367);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(47);

var _AppRouter = __webpack_require__(400);

var _AppRouter2 = _interopRequireDefault(_AppRouter);

var _configureStore = __webpack_require__(449);

var _configureStore2 = _interopRequireDefault(_configureStore);

__webpack_require__(454);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)();

var App = _react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(_AppRouter2.default, null)
);

_reactDom2.default.render(App, document.getElementById('app'));

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(147),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.11.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(368);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),n=__webpack_require__(147),q=__webpack_require__(369);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),dc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ed={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},fd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=fd[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ed[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},xd=0;for(;xd<td.length;xd++){var yd=td[xd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===dc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<dc.length;h++)F(dc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<dc.length;d++)F(dc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=
b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),
a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){Sj();if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,m=k.focusNode;k=k.focusOffset;
try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=null;me={focusedElem:g,selectionRange:h};
Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,Y);break;case 4:aj(Y.alternate,
Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),l=p.textContent.length,
g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===
typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var cc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var dd=t.stateNode;if(t.effectTag&4)if(null===cc)dd.componentDidMount();else{var hk=t.elementType===t.type?cc.memoizedProps:mg(t.type,cc.memoizedProps);dd.componentDidUpdate(hk,cc.memoizedState,dd.__reactInternalSnapshotBeforeUpdate)}var Eh=
t.updateQueue;null!==Eh&&Kg(t,Eh,dd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===cc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;
case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var wd=Y.ref;if(null!==wd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof wd?wd(t):wd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(jj=null);1073741823===b?a===Ij?Hj++:(Hj=
0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};
function wk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}wk.prototype.render=function(a,b){var c=this._internalRoot;rk(a,c,null,void 0===b?null:b)};wk.prototype.unmount=function(a){var b=this._internalRoot;rk(null,b,null,void 0===a?null:a)};
function yk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}eb=bk;fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};
function zk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new wk(a,0,b?{hydrate:!0}:void 0)}
function Ak(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=zk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!yk(b))throw Error(u(200));return vk(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!0,c)},render:function(a,b,c){if(!yk(b))throw Error(u(200));return Ak(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!yk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return Ak(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!yk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){Ak(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.11.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(370);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(107);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  __WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */]('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(373);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.11.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(398);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(157);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"](mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(385);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */](value)
    : __WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */](value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(383);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(154);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(387);


/** Built-in value references. */
var getPrototype = __WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */](Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(391);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */](root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55), __webpack_require__(390)(module)))

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(155);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */](inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(157);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(158);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(399);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(107);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */]("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

var _history = __webpack_require__(109);

var _KeyComponentTitle = __webpack_require__(408);

var _KeyComponentTitle2 = _interopRequireDefault(_KeyComponentTitle);

var _Header = __webpack_require__(414);

var _Header2 = _interopRequireDefault(_Header);

var _IntroPage = __webpack_require__(415);

var _IntroPage2 = _interopRequireDefault(_IntroPage);

var _NotFoundPage = __webpack_require__(416);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _QuestionPage = __webpack_require__(417);

var _QuestionPage2 = _interopRequireDefault(_QuestionPage);

var _ResourcesPage = __webpack_require__(428);

var _ResourcesPage2 = _interopRequireDefault(_ResourcesPage);

var _ResultsPage = __webpack_require__(429);

var _ResultsPage2 = _interopRequireDefault(_ResultsPage);

var _SectionGuidance = __webpack_require__(431);

var _SectionGuidance2 = _interopRequireDefault(_SectionGuidance);

var _StartPage = __webpack_require__(445);

var _StartPage2 = _interopRequireDefault(_StartPage);

var _SubSectionMenu = __webpack_require__(448);

var _SubSectionMenu2 = _interopRequireDefault(_SubSectionMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = exports.history = (0, _history.createBrowserHistory)();

var AppRouter = function AppRouter() {
  return _react2.default.createElement(
    _reactRouterDom.Router,
    { history: history },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Header2.default, null),
      _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _IntroPage2.default, exact: true }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/keyComponent/:secId/:subSecId', component: _KeyComponentTitle2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/start', component: _StartPage2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/menu/:secId', component: _SubSectionMenu2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/results', component: _ResultsPage2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/guidance/:secId/:subSecId', component: _SectionGuidance2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/question/:secId/:subSecId/:qId', component: _QuestionPage2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/resources', component: _ResourcesPage2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _NotFoundPage2.default })
      )
    )
  );
};

exports.default = AppRouter;

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(78);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default.a() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default.a(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default.a(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 404 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(407)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _NextBtn = __webpack_require__(79);

var _NextBtn2 = _interopRequireDefault(_NextBtn);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

var _subSections = __webpack_require__(62);

var _subSections2 = _interopRequireDefault(_subSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyComponentTitle = function KeyComponentTitle(props) {
  var secId = props.match.params.secId;

  var _sections$filter = _sections2.default.filter(function (section) {
    return secId === section.secId;
  }),
      _sections$filter2 = _slicedToArray(_sections$filter, 1),
      section = _sections$filter2[0];

  var subSecId = props.match.params.subSecId;

  var _subSections$filter = _subSections2.default.filter(function (subSection) {
    return subSecId === subSection.subSecId;
  }),
      _subSections$filter2 = _slicedToArray(_subSections$filter, 1),
      subSection = _subSections$filter2[0];

  return _react2.default.createElement(
    'div',
    { className: 'grid-container page' },
    _react2.default.createElement('div', { className: 'clear' }),
    _react2.default.createElement(
      'div',
      { className: 'key-component-title' },
      _react2.default.createElement('div', { className: 'icon ' + secId + '-icon', dangerouslySetInnerHTML: section.icon }),
      _react2.default.createElement(
        'h3',
        { className: 'bold question-title' },
        section.number + '. ' + section.title
      ),
      _react2.default.createElement(
        'h3',
        null,
        'Next key component: ',
        subSection.title
      ),
      _react2.default.createElement(_NextBtn2.default, { nextLabel: 'Continue', nextLink: '/question/' + secId + '/' + subSecId + '/' + subSecId + '1' })
    )
  );
};

exports.default = KeyComponentTitle;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var coreIcon = {
    __html: "\n        <svg width=\"100px\" height=\"100px\" viewBox=\"0 0 98 100\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsXlink=\"http://www.w3.org/1999/xlink\">\n            <g>\n                <path d=\"M94,55 C96.2905908,52.2687927 97.9592998,49.515262 97.9592998,45.7861048 C97.9592998,42.404328 97.3691466,38.4726651 95,36 C92.6260394,33.5275626 89.2166302,33.2974943 85.9680525,33.2974943 L68.6634573,33.2974943 C68.8297593,32.6906606 68.9964989,32.1703872 69.1628009,31.7369021 C69.3275711,31.3034169 69.559081,30.8259681 69.849453,30.3056948 C70.1400438,29.7851936 70.3490153,29.3947608 70.473523,29.1350797 C71.2229759,27.6617312 71.7967177,26.4469248 72.192779,25.4938497 C72.5881838,24.5389522 72.9818381,23.2387244 73.3787746,21.5911162 C73.7750547,19.9444191 73.9719912,18.2961276 73.9719912,16.6485194 C73.9719912,15.6084282 73.9599562,14.7621868 73.9402626,14.1123007 C73.9207877,13.461959 73.8146608,12.4861048 73.628884,11.1851936 C73.4402626,9.88496583 73.1899344,8.80091116 72.878337,7.93416856 C72.5654267,7.06719818 72.0652079,6.09088838 71.3792123,5.00774487 C70.6916849,3.92255125 69.859081,3.04578588 68.8794311,2.37334852 C67.9,1.70136674 66.6509847,1.13781321 65.1308534,0.682915718 C63.6091904,0.227562642 63,-5.68434189e-14 61,-5.68434189e-14 C59.9172867,-5.68434189e-14 58.7921225,0.176082005 58,1 C57.1671772,1.86697039 56.5824945,2.69977221 56,4 C55.4166302,5.30091116 55.2293217,7.04578588 55,8 C54.7708972,8.95375854 54.290372,10.3095672 54,12 C53.6238512,13.8218679 53.1886214,15.1979499 53,16 C52.8129103,16.8020501 52.540919,17.6995444 52,19 C51.4579869,20.3013667 49.9153173,21.2660592 49.1654267,22.0469248 C47.7912473,23.4774487 45.6881838,26.0790433 42.8553611,29.8507973 C40.8140044,32.6252847 38.7109409,35.2482916 36.5452954,37.7198178 C34.3792123,40.1917995 29.8612691,42.0883827 29.1113786,42.8908884 C28.361488,43.6929385 27.9866521,44.6362187 27.9866521,45.7198178 L27.9866521,87.4077449 C27.9866521,88.5350797 28.3820569,89.4993166 29.173523,90.3013667 C29.9645514,91.104328 36.7326039,92.5667426 41.8557987,94.4328018 C45.0623632,95.5583144 47.5713348,96.4159453 49.383151,97.0004556 C51.1945295,97.5849658 53.726477,98.214123 56.9726477,98.8870159 C60.2218818,99.5587699 63.2201313,99.895672 65.9682713,99.895672 L67.0306346,99.895672 L71.7789934,99.895672 L77,100 C82.9724289,99.104328 83.6689278,98.1175399 86.3354486,94.8232346 C88.7503282,91.8312073 89.373523,87.8560364 89,83 C90.62407,81.3958998 92.1461707,79.4102506 92.7700219,76.9382688 C93.4770241,74.2949886 92.7070022,71.4275626 92,69 C93.9155361,66.3551253 95.5811816,63.7159453 95.4553611,60.4207289 C95.4606127,59.0318907 94.6260394,56.9084282 94,55 Z\"></path>\n                <path d=\"M21.9912473,42 L3.99912473,42 C2.91553611,42 1.97833698,42.4120729 1.18708972,43.2359909 C0.395842451,44.0594533 1.0658141e-14,45.0350797 1.0658141e-14,46.1624146 L1.0658141e-14,87.7870159 C1.0658141e-14,88.9127563 0.395842451,89.8888383 1.18730853,90.7134396 C1.97921225,91.5359909 2.91641138,91.9482916 3.99934354,91.9482916 L21.9912473,91.9482916 C23.0739606,91.9482916 24.0107221,91.5359909 24.802407,90.7134396 C25.5936543,89.8888383 25.9892779,88.9129841 25.9892779,87.7870159 L25.9892779,46.1624146 C25.9892779,45.0350797 25.5934354,44.0596811 24.802407,43.2359909 C24.0109409,42.4118451 23.0741794,42 21.9912473,42 Z\"></path>\n            </g>    \n        </svg>"
};

exports.default = coreIcon;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var financeIcon = {
    __html: "\n        <svg width=\"100px\" height=\"100px\" viewBox=\"0 0 53 100\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsXlink=\"http://www.w3.org/1999/xlink\">\n            <g>\n                <path d=\"M40.8824742,46.3492784 C36.9649485,44.1843299 32.8,42.5348454 28.6762887,40.8235052 C26.2845361,39.8338144 23.9958763,38.6791753 21.9752577,37.0709278 C17.9958763,33.8956701 18.7587629,28.7410309 23.4185567,26.6997938 C24.7381443,26.1224742 26.1195876,25.9369072 27.5216495,25.854433 C32.9237113,25.5657732 37.8886598,28.8119588 42.9443299,28.9059794 C48,29 48.9360142,27.5468459 50,24 C51.0138214,20.6203794 50,17 47.5628866,15.297732 C45.1257732,13.5954639 41.2123711,12.9265979 37.8309278,12.3905155 C33.4185567,11.7101031 33.4185567,11.6894845 33.3979381,7.25649485 C33.3773196,1.00907216 32,-5.68434189e-14 27,-5.68434189e-14 C23,-5.68434189e-14 20.9649485,1.60701031 20.8824742,4.55546392 C20.8412371,5.87505155 20.8824742,7.19463918 20.8618557,8.53484536 C20.8412371,12.4523711 20.8206186,12.3905155 17.0680412,13.7513402 C7.99587629,17.0503093 2.38762887,23.2358763 1.78969072,33.1327835 C1.25360825,41.8956701 5.83092784,47.8131959 13.0268041,52.1224742 C17.4597938,54.782268 22.3670103,56.3492784 27.0680412,58.4317526 C28.9030928,59.2358763 30.6556701,60.1637113 32.1814433,61.4420619 C36.6969072,65.1740206 35.8721649,71.3802062 30.5113402,73.7307216 C27.6453608,74.9884536 24.614433,75.297732 21.5010309,74.9059794 C16.6969072,74.3080412 12.0989691,73.0503093 7.76907216,70.8028866 C5.23298969,69.483299 1.65979381,72.6082474 1,75 C0.113402062,78.2164948 1.00618557,83.7101031 4.07835052,85.2152577 C7.99587629,87.1121649 12.1814433,88.0812371 16.4494845,88.7616495 C19.7896907,89.297732 19.8927835,89.4420619 19.9340206,92.9059794 C19.9546392,94.4729897 19.9546392,96.0606186 19.9752577,97.6276289 C19.9958763,99.6070103 23,101 27,101 C31,101 32.8,99.7101031 32.8,97.7925773 C32.8,95.6482474 32.9030928,93.483299 32.8206186,91.3389691 C32.7175258,89.1534021 33.6659794,88.04 35.7690722,87.4626804 C40.614433,86.1430928 44.7381443,83.5451546 47.9134021,79.668866 C56.7381443,68.9472165 53.3773196,53.2564948 40.8824742,46.3492784 Z\"></path>\n            </g>\n        </svg>"
};

exports.default = financeIcon;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var operationsIcon = {
    __html: "\n        <svg width=\"100px\" height=\"100px\" viewBox=\"0 0 103 109\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsXlink=\"http://www.w3.org/1999/xlink\">\n            <g>\n                <path d=\"M11.5594855,41.5300866 C12.0846731,43.3482684 12.8135048,45.1015152 13.7352626,46.7465368 L11.1093248,50.0906926 C10.2518757,51.1837662 10.3483387,52.7422078 11.3129689,53.7270563 L15.8360129,58.2941558 C16.8113612,59.2790043 18.3547696,59.3654762 19.437299,58.4996753 L22.7277599,55.8698052 C24.4212219,56.8547619 26.221865,57.6230519 28.0975348,58.1641775 L28.5905681,62.4390693 C28.7513398,63.8243506 29.908896,64.8633117 31.2808146,64.8633117 L37.6795284,64.8633117 C39.0514469,64.8633117 40.2090032,63.8242424 40.3697749,62.4390693 L40.8413719,58.3156926 C42.8563773,57.7853896 44.7856377,56.9953463 46.5969989,55.9672078 L49.7802787,58.5104978 C50.8628081,59.3762987 52.4062165,59.2788961 53.3815648,58.3048701 L57.9046088,53.7377706 C58.8799571,52.7529221 58.965702,51.1944805 58.1082529,50.1014069 L55.6323687,46.9304113 C56.6613076,45.1337662 57.4651661,43.21829 58.0010718,41.2161255 L61.8167203,40.7724026 C63.188746,40.6100649 64.2175777,39.4412338 64.2175777,38.0559524 L64.2175777,31.5949134 C64.2175777,30.209632 63.1886388,29.0408009 61.8167203,28.8784632 L58.0546624,28.4347403 C57.5400857,26.4542208 56.7684887,24.5602814 55.7825295,22.7853896 L58.097642,19.8308442 C58.9550911,18.7377706 58.8586281,17.179329 57.8939979,16.1944805 L53.381672,11.6382035 C52.4063237,10.653355 50.8629153,10.5667749 49.7803859,11.4325758 L46.9400857,13.705303 C45.0965702,12.6122294 43.1243301,11.7788961 41.0558414,11.2161255 L40.6271168,7.50400433 C40.4663451,6.11872294 39.3087889,5.0797619 37.9368703,5.0797619 L31.5381565,5.0797619 C30.1662379,5.0797619 29.0086817,6.11872294 28.84791,7.50400433 L28.4191854,11.2161255 C26.2969989,11.7897186 24.2712755,12.6555195 22.3848875,13.7918831 L19.4374062,11.4325758 C18.3548767,10.5667749 16.8114684,10.6641775 15.83612,11.6382035 L11.3130761,16.205303 C10.3377278,17.1901515 10.2519829,18.7485931 11.1094319,19.8416667 L13.5745981,22.9910173 C12.5885316,24.7875541 11.8382637,26.7031385 11.3452304,28.6944805 L7.40096463,29.149026 C6.02904609,29.3113636 5.00010718,30.4801948 5.00010718,31.8654762 L5.00010718,38.3265152 C5.00010718,39.7117965 6.02904609,40.8806277 7.40096463,41.0429654 L11.5594855,41.5300866 Z M34.5289258,24.0096221 C40.3595796,24.0096221 45.1077039,28.8039944 45.1077039,34.6914403 C45.1077039,40.5788862 40.3595796,45.3732585 34.5289258,45.3732585 C28.6983791,45.3732585 23.9501476,40.5788862 23.9501476,34.6914403 C23.9501476,28.8039944 28.698272,24.0096221 34.5289258,24.0096221 Z\" transform=\"translate(34.608842, 34.971537) rotate(10.000000) translate(-34.608842, -34.971537) \"></path>\n                <path d=\"M95.7768451,48.4111433 L92.4006393,45.5323555 C91.3610894,44.6449096 89.828292,44.6881996 88.8423327,45.6297581 L86.977381,47.3938273 C85.4019254,46.6254291 83.7298997,46.0843035 82.0041763,45.7704507 L81.479203,43.1730481 C81.2112502,41.8310568 79.9786671,40.9003208 78.6279705,41.0085459 L74.2228258,41.3873338 C72.8723435,41.5063814 71.8112502,42.6211 71.7683778,43.9955589 L71.68274,46.6362516 C69.9891709,47.2531347 68.392172,48.0972905 66.9345085,49.1578966 L64.7052481,47.6643901 C63.5689137,46.9068143 62.0577668,47.1232645 61.1789887,48.1730481 L58.3279705,51.603784 C57.448978,52.6535676 57.4918504,54.2011866 58.4242191,55.1968576 L60.375023,57.2963165 C59.6996746,58.833113 59.2173595,60.4457754 58.9387958,62.1015113 L56.1520862,62.6751044 C54.8230401,62.9456671 53.9012824,64.1902559 54.0084635,65.5540005 L54.3835975,70.0020524 C54.5014967,71.3656888 55.6054624,72.4371174 56.9666629,72.4804074 L59.9784528,72.5777018 C60.5252909,74.0279182 61.2432974,75.4024853 62.1113574,76.6902559 L60.4287207,79.255191 C59.6784528,80.4023771 59.8928151,81.9283511 60.9323649,82.815797 L64.3085707,85.6945849 C65.3483349,86.5820308 66.8809179,86.5387407 67.8670916,85.5971823 L70.075023,83.5084377 C71.5219683,84.1902559 73.0438333,84.6989139 74.6086779,85.0019442 L75.2197175,88.0538923 C75.4876704,89.3958836 76.7202534,90.3266195 78.0707357,90.2183944 L82.4758804,89.8396065 C83.8263627,89.7205589 84.887456,88.6059485 84.9303284,87.2313814 L85.0267915,84.2442602 C86.6345085,83.6706671 88.1563735,82.8914464 89.5604463,81.9283511 L91.9935653,83.5517278 C93.1296854,84.3093035 94.6408322,84.0928533 95.5198247,83.0430697 L98.3708429,79.6339788 C99.2496211,78.5841953 99.2067486,77.0365762 98.2743799,76.0409052 L96.3128579,73.9414464 C97.0310787,72.4046498 97.5563735,70.7812732 97.8562663,69.1144983 L100.535795,68.5625503 C101.864841,68.2919875 102.786599,67.0473987 102.679417,65.6836542 L102.304283,61.2356022 C102.186384,59.8719658 101.082418,58.8005373 99.7212181,58.7572472 L97.0309715,58.6706671 C96.4735224,57.0905806 95.7232545,55.5971823 94.7908858,54.2117927 L96.2591602,51.9823555 C97.0309715,50.8353858 96.8166093,49.2985892 95.7768451,48.4111433 Z M79.3888769,74.4563939 C74.6300345,74.8677576 70.4283196,71.2853983 70.0318565,66.4803117 C69.624461,61.6751169 73.172371,57.4325844 77.9309991,57.0321515 C82.6898415,56.6208961 86.8915564,60.2032554 87.2880194,65.008342 C87.6954149,69.813645 84.147505,74.0560693 79.3888769,74.4563939 Z\" ></path>\n                <path d=\"M20.9233651,82.2669593 C19.5728828,82.407652 18.5332258,83.5547299 18.5225076,84.929297 L18.4900176,87.6673922 C18.4689171,89.0418511 19.4764198,90.2106823 20.8269021,90.3839507 L22.8204712,90.6435827 C23.1527327,91.8666347 23.6243297,93.0354658 24.2352622,94.1393619 L22.9490886,95.7410935 C22.0916395,96.8124139 22.1559482,98.3493186 23.1098603,99.3341671 L25.0069664,101.293042 C25.9608785,102.27789 27.4828506,102.386115 28.5653801,101.541959 L30.1622718,100.297371 C31.2876738,100.968366 32.4774916,101.498778 33.7206856,101.866635 L33.9350478,103.944557 C34.0743833,105.308193 35.2105034,106.357977 36.5717038,106.368799 L39.2834937,106.401606 C40.644587,106.422912 41.8022504,105.405596 41.9737402,104.041959 L42.2202568,102.072262 C43.5708463,101.736656 44.85702,101.228107 46.0787777,100.557111 L47.5793136,101.780055 C48.6404069,102.645855 50.1624862,102.58092 51.1378345,101.617717 L53.0778131,99.7021325 C54.0531614,98.7390372 54.1603426,97.2021325 53.3244369,96.1090589 L52.1773844,94.6046217 C52.8847799,93.4141455 53.4315109,92.1479117 53.8066448,90.8167429 L55.5858517,90.6327602 C56.936334,90.4920676 57.9758838,89.3448814 57.9867091,87.9704225 L58.0190954,85.2322191 C58.0402997,83.8578684 57.032797,82.688929 55.6823147,82.5157689 L53.9458731,82.2884961 C53.6136116,80.9681498 53.1206856,79.6910935 52.4775987,78.5006173 L53.5601282,77.158626 C54.4175773,76.0871974 54.3532686,74.5504009 53.3993565,73.5655524 L51.5023576,71.6066779 C50.5484455,70.6217212 49.026259,70.5134961 47.9438367,71.3577602 L46.6468378,72.3642537 C45.42508,71.6175005 44.1173629,71.0439074 42.7455516,70.654297 L42.5739546,68.9551628 C42.4346191,67.5914182 41.2986062,66.5417429 39.9372986,66.5309204 L37.2256159,66.4981138 C35.8644155,66.4768078 34.7068592,67.4941238 34.5352622,68.8577602 L34.3208999,70.5461801 C32.9062161,70.9140372 31.5450157,71.476916 30.2802783,72.2127385 L28.9405141,71.1088424 C27.8794208,70.2430416 26.3573415,70.3080849 25.3819932,71.2711801 L23.4312965,73.1976953 C22.4559482,74.1607905 22.348767,75.6976953 23.1847799,76.7906606 L24.331618,78.2842753 C23.667095,79.4747515 23.1419074,80.7408771 22.7989278,82.0721541 L20.9233651,82.2669593 Z M38.1109718,79.0192539 C42.0016471,79.0625439 45.1205109,82.2985829 45.0777457,86.2271543 C45.0348732,90.1557257 41.8300501,93.3049682 37.9393748,93.2617863 C34.0486996,93.2184963 30.9298357,89.9825656 30.972601,86.0538859 C31.0155806,82.1254227 34.2202966,78.9760721 38.1109718,79.0192539 Z\" transform=\"translate(38.254558, 86.449860) rotate(5.000000) translate(-38.254558, -86.449860) \"></path>\n            </g>\n        </svg>"
};

exports.default = operationsIcon;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var patientIcon = {
    __html: "\n        <svg width=\"100px\" height=\"100px\" viewBox=\"0 0 82 100\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsXlink=\"http://www.w3.org/1999/xlink\">\n            <g>\n                <path d=\"M68.9805743,81.8171642 L70.5883085,81.8171642 C71.2047264,81.8171642 71.7360697,81.5940299 72.1870647,81.1427861 C72.6348259,80.6915423 72.861194,80.1604478 72.861194,79.5440299 L72.861194,11.3639303 C72.861194,10.7482587 72.6365672,10.2154229 72.1870647,9.7659204 C71.7358209,9.31517413 71.2047264,9.09129353 70.5883085,9.09129353 L11.4982587,9.09129353 C10.8828358,9.09129353 10.3504975,9.3159204 9.90049751,9.7659204 C9.45049751,10.2154229 9.22587065,10.7482587 9.22587065,11.3639303 L9.22587065,79.5440299 C9.22587065,80.1604478 9.45074627,80.6932836 9.90049751,81.1427861 C10.3502488,81.5922886 10.8828358,81.8171642 11.4982587,81.8171642 L14.0877998,81.8171642 C14.1468222,80.0771902 14.2138863,77.6132725 14.2138863,73.0059764 C14.2138863,60.3211953 23.4380043,50 34.7761534,50 L48.4032503,50 C59.7413994,50 68.9655173,60.3211953 68.9614177,73.0059764 C68.959994,77.4110579 68.9702713,79.9821537 68.9805743,81.8171642 Z M4,0 L78,0 C80.209139,-4.05812251e-16 82,1.790861 82,4 L82,96 C82,98.209139 80.209139,100 78,100 L4,100 C1.790861,100 -1.70489377e-14,98.209139 -1.73194792e-14,96 L-1.73194792e-14,4 C-1.75900207e-14,1.790861 1.790861,4.05812251e-16 4,0 Z M44.2395522,94.1042289 C45.1385572,93.2029851 45.589801,92.1380597 45.589801,90.9084577 C45.589801,89.6773632 45.1385572,88.6099502 44.2395522,87.7126866 C43.3405473,86.8119403 42.2746269,86.3609453 41.0432836,86.3609453 C39.8124378,86.3609453 38.7475124,86.8121891 37.8467662,87.7126866 C36.9470149,88.610199 36.4975124,89.6776119 36.4975124,90.9084577 C36.4975124,92.1380597 36.9470149,93.2037313 37.8467662,94.1042289 C38.7465174,95.0032338 39.8114428,95.4527363 41.0432836,95.4527363 C42.2748756,95.4527363 43.340796,95.0032338 44.2395522,94.1042289 Z M41.5014039,48 C50.6140985,48 58,39.9400928 58,29.9992341 C58,20.0583755 50.6126946,12 41.5014039,12 C32.3901132,12 25,20.0599072 25,30.0007659 C25,39.9416245 32.3901132,48 41.5014039,48 Z\"></path>\n            </g>\n        </svg>"
};

exports.default = patientIcon;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var staffIcon = {
    __html: "\n        <svg width=\"100px\" height=\"100px\" viewBox=\"0 0 100 101\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsXlink=\"http://www.w3.org/1999/xlink\">\n            <g>\n                <path d=\"M59.18938,16.4953033 C63.7245191,19.7033352 66.9046248,25.1319934 67.4836048,31.4334351 C69.3331581,32.4084117 71.3859053,32.9690922 73.5622825,32.9690922 C81.5076504,32.9690922 87.9474256,25.7037218 87.9474256,16.741119 C87.9474256,7.77713509 81.5076504,0.511764706 73.5622825,0.511764706 C65.6928062,0.514526679 59.3093378,7.65008432 59.18938,16.4953033 Z M49.7653486,49.7246024 C57.7107165,49.7246024 64.1504917,42.457851 64.1504917,33.4952481 C64.1504917,24.5326452 57.7094925,17.2672748 49.7653486,17.2672748 C41.8212048,17.2672748 35.3777574,24.5340262 35.3777574,33.4966291 C35.3777574,42.459232 41.8212048,49.7246024 49.7653486,49.7246024 Z M55.8672835,50.8307726 L43.6609657,50.8307726 C33.5049469,50.8307726 25.2425477,60.153813 25.2425477,71.6118586 C25.2425477,83.0699042 24.7871977,79.8522055 25.2804935,88.7167584 C25.7737894,97.5813112 37.0290132,100.511765 50.5658833,100.511765 C64.1027534,100.511765 74.2024654,96.1202274 74.2820293,88.4557519 C74.3615931,80.7912764 74.2783571,83.0699042 74.2820293,71.6118586 C74.2857014,60.153813 66.0233022,50.8307726 55.8672835,50.8307726 Z M24.524025,32.9718542 C27.338137,32.9718542 29.9563995,32.0452122 32.1743946,30.4667445 C32.8794527,25.278378 35.3447078,20.744599 38.866326,17.6567131 C38.8810147,17.352896 38.9067199,17.0518409 38.9067199,16.7452619 C38.9067199,7.78127805 32.4657207,0.515907666 24.524025,0.515907666 C16.577433,0.515907666 10.1388819,7.78127805 10.1388819,16.7452619 C10.1388819,25.7051028 16.577433,32.9718542 24.524025,32.9718542 Z M37.4427452,48.008036 C34.1867479,44.4851393 32.1254323,39.5881609 31.974873,34.1539787 C31.5256433,34.1166921 31.0813098,34.0766435 30.6235117,34.0766435 L18.418418,34.0766435 C8.26239923,34.0766435 5.68434189e-14,43.3983028 5.68434189e-14,54.8549675 C5.68434189e-14,66.3116321 5.68434189e-14,62.9489298 0.0379458335,71.9584862 C0.075891667,80.9680427 21.8029415,80.1670705 21.8078377,76.7228899 C21.8111019,74.4267696 21.8111019,72.7313784 21.8078377,71.6367164 C21.8102859,60.4811068 28.4128609,51.0393016 37.4427452,48.008036 Z M62.4637382,47.7691254 C65.7197355,44.2462286 67.7810511,39.3492502 67.9316104,33.915068 C68.3808401,33.8777814 68.8251736,33.8377328 69.2829717,33.8377328 L81.4880655,33.8377328 C91.6440842,33.8377328 99.9064834,43.1593922 99.9064834,54.6160568 C99.9064834,66.0727215 100.140279,63.8880007 99.8685376,71.7195756 C99.5967965,79.5511504 78.1035419,79.9281598 78.0986457,76.4839793 C78.0953815,74.1878589 78.0953815,72.4924677 78.0986457,71.3978057 C78.0961976,60.2421961 71.4936225,50.8003909 62.4637382,47.7691254 Z\"></path>\n            </g>\n        </svg>"
};

exports.default = staffIcon;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Header = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = function Header() {
    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        menuOpen = _useState2[0],
        setMenuOpen = _useState2[1];

    var location = (0, _reactRouterDom.useLocation)();

    (0, _react.useEffect)(function () {
        setMenuOpen(false);
    }, [location]);

    return _react2.default.createElement(
        'header',
        { id: 'top-anchor', className: 'no-print' },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'a',
                { href: 'https://mhcc.maryland.gov/', target: '_blank', rel: 'noopener noreferrer' },
                _react2.default.createElement('img', { className: 'logo', src: '/logo192.png', alt: 'mhcc logo' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'collapsed-menu-bar', onClick: function onClick() {
                        return setMenuOpen(!menuOpen);
                    } },
                _react2.default.createElement('div', { className: 'menu-icon' }),
                _react2.default.createElement(
                    'div',
                    { className: 'menu-title' },
                    'Menu'
                )
            ),
            _react2.default.createElement(
                'div',
                { id: 'nav-links' },
                _react2.default.createElement(
                    'ul',
                    { className: menuOpen ? 'main-nav mobile-nav' : 'main-nav' },
                    _react2.default.createElement(
                        _reactRouterDom.NavLink,
                        { exact: true, to: '/start', className: 'nav-link' },
                        'Concept Menu'
                    ),
                    _react2.default.createElement(
                        _reactRouterDom.NavLink,
                        { to: '/results', className: 'nav-link' },
                        'My Results'
                    ),
                    _react2.default.createElement(
                        _reactRouterDom.NavLink,
                        { to: '/resources', className: 'nav-link' },
                        'Telehealth Resources'
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            onClick: function onClick() {
                                gtag('event', 'Download paper tool', {
                                    'event_category': 'download'
                                });
                            },
                            href: '/Telehealth-Readiness-Assessment.pdf',
                            target: '_blank',
                            className: 'nav-link download-link'
                        },
                        'Paper Tool'
                    )
                )
            )
        )
    );
};

exports.default = Header;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntroPage = function IntroPage() {
    return _react2.default.createElement(
        'div',
        { className: 'grid-container page' },
        _react2.default.createElement(
            'div',
            { className: 'intro-text' },
            _react2.default.createElement(
                'h3',
                { className: 'bold' },
                'What is the Telehealth Readiness Assessment Tool?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'The Telehealth Readiness Assessment (TRA) tool allows small physician practices to determine their readiness for implementing or scaling up a telehealth project. The tool also provides guidance and resources to improve readiness in key areas.'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'start-link' },
            _react2.default.createElement(
                _reactRouterDom.NavLink,
                { exact: true, to: '/start', className: 'btn question-btn' },
                'Launch the Tool'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'intro-text' },
            _react2.default.createElement(
                'h3',
                { className: 'bold' },
                'About the Telehealth Readiness Assessment Tool'
            ),
            _react2.default.createElement(
                'p',
                null,
                'As a result of lessons learned from telehealth demonstration projects and discussions with telehealth leaders in Maryland, a need was identified for an assessment tool to help practices understand barriers, facilitators, patient and environmental factors associated with telehealth readiness. To address this need, the Maryland Health Care Commission (MHCC) collaborated with RTI International to develop the Telehealth Readiness Assessment (TRA) tool.'
            ),
            _react2.default.createElement(
                'p',
                null,
                'In February, 2018, the TRA tool development project was initiated. TRA tool content is founded in literature and a comprehensive environmental scan of existing resources and information. The literature review and environmental scan identified more than 150 references including guidelines, best practices, and other information applicable to telehealth implementation in small physician practices. TRA tool content was also reviewed and field tested with key stakeholder groups, including the Maryland Telehealth Alliance and Maryland Medicaid, and 20 small physician practices in Maryland, including those that had and those that had not implemented telehealth. Field testing consisted of cognitive interviews to ensure that the TRA tool content is understandable, engaging, relevant, and appropriate for the intended audience.'
            ),
            _react2.default.createElement(
                'h3',
                { className: 'bold' },
                'About the MHCC'
            ),
            _react2.default.createElement(
                'p',
                null,
                'The MHCC is an independent regulatory agency whose mission is to plan for health system needs, promote informed decision-making, increase accountability, and improve access in a rapidly changing health care environment by providing timely and accurate information on availability, cost, and quality of services to policy makers, purchasers, providers and the public. The MHCC is responsible for advancing health information technology statewide and fostering innovation in a way that balances the need for information sharing with the need for strong privacy and security policies.'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'start-link' },
            _react2.default.createElement(
                _reactRouterDom.NavLink,
                { exact: true, to: '/start', className: 'btn question-btn' },
                'Launch the Tool'
            )
        )
    );
};

exports.default = IntroPage;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function NotFoundPage() {
  return _react2.default.createElement(
    'div',
    { className: 'grid-container page' },
    '404 - Page not found. ',
    _react2.default.createElement(
      _reactRouterDom.Link,
      { className: 'underline', to: '/start' },
      'Go back to the start'
    )
  );
};

exports.default = NotFoundPage;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

var _NextBtn = __webpack_require__(79);

var _NextBtn2 = _interopRequireDefault(_NextBtn);

var _PreviousBtn = __webpack_require__(418);

var _PreviousBtn2 = _interopRequireDefault(_PreviousBtn);

var _ProgressBar = __webpack_require__(419);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Question = __webpack_require__(420);

var _Question2 = _interopRequireDefault(_Question);

var _questions = __webpack_require__(427);

var _questions2 = _interopRequireDefault(_questions);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

var _subSections = __webpack_require__(62);

var _subSections2 = _interopRequireDefault(_subSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestionPage = function QuestionPage(props) {
  var qId = props.match.params.qId;
  var question = _questions2.default.find(function (question) {
    return qId === question.qId;
  });
  var secId = props.match.params.secId;
  var section = _sections2.default.find(function (section) {
    return secId === section.secId;
  });
  var subSecId = props.match.params.subSecId;
  var subSection = _subSections2.default.find(function (subSection) {
    return subSecId === subSection.subSecId;
  });

  var questionIndexSection = section.questions.findIndex(function (question) {
    return question === qId;
  });
  var questionIndexSubSection = subSection.questions.findIndex(function (question) {
    return question === qId;
  });

  var lastQuestionSection = section.questions[section.questions.length - 1];
  var lastQuestionSubSection = subSection.questions[subSection.questions.length - 1];

  var previousDisabled = questionIndexSection === 0;
  var previousLink = previousDisabled ? '' : '/question/' + secId + '/' + (questionIndexSubSection === 0 ? parseInt(subSecId) - 1 : subSecId) + '/' + section.questions[questionIndexSection - 1];
  var nextLink = lastQuestionSection === qId ? '/menu/' + secId : lastQuestionSubSection === qId ? '/keyComponent/' + secId + '/' + (parseInt(subSecId) + 1) + '/' : '' + (parseInt(qId) + 1);
  var nextLabel = lastQuestionSection === qId ? 'Results' : 'Next';

  (0, _react.useEffect)(function () {
    document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
  }, []);

  return _react2.default.createElement(
    'div',
    { className: 'grid-container page' },
    _react2.default.createElement('div', { className: 'clear' }),
    _react2.default.createElement(
      'div',
      { className: 'question-intro' },
      _react2.default.createElement('div', { className: 'icon ' + secId + '-icon', dangerouslySetInnerHTML: section.icon }),
      _react2.default.createElement(
        'h3',
        { className: 'bold question-title' },
        '' + section.number,
        subSection.title && '' + subSection.number,
        '. ' + section.title,
        subSection.title && ': ' + subSection.title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'grid-x grid-margin-x' },
      _react2.default.createElement(_ProgressBar2.default, { currentQuestion: questionIndexSubSection + 1, totalQuestions: subSection.questions.length }),
      _react2.default.createElement(_Question2.default, { question: question }),
      _react2.default.createElement(
        'div',
        { className: 'cell small-12 large-8 large-offset-2 question-btn-box' },
        _react2.default.createElement(_PreviousBtn2.default, { previousDisabled: previousDisabled, previousLink: previousLink }),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/menu/' + secId, className: 'btn question-btn' },
          _react2.default.createElement(
            'p',
            null,
            'Key Component Menu'
          )
        ),
        _react2.default.createElement(_NextBtn2.default, { nextLabel: nextLabel, nextLink: nextLink })
      )
    )
  );
};

exports.default = QuestionPage;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviousBtn = function PreviousBtn(_ref) {
    var previousDisabled = _ref.previousDisabled,
        previousLink = _ref.previousLink;

    if (previousDisabled) {
        return _react2.default.createElement(
            'button',
            { className: 'btn question-btn question-btn--disabled' },
            _react2.default.createElement(
                'svg',
                { className: 'back', width: '30px', height: '14px', viewBox: '0 0 30 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                _react2.default.createElement('path', { d: 'M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z' })
            ),
            _react2.default.createElement(
                'p',
                null,
                'Prev'
            )
        );
    } else {
        return _react2.default.createElement(
            _reactRouterDom.Link,
            { className: 'btn question-btn', to: previousLink },
            _react2.default.createElement(
                'svg',
                { className: 'back', width: '30px', height: '14px', viewBox: '0 0 30 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                _react2.default.createElement('path', { d: 'M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z' })
            ),
            _react2.default.createElement(
                'p',
                null,
                'Prev'
            )
        );
    }
};

exports.default = PreviousBtn;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
    var currentQuestion = _ref.currentQuestion,
        totalQuestions = _ref.totalQuestions;

    var message = "Question " + currentQuestion + " of " + totalQuestions;
    var percentComplete = currentQuestion / totalQuestions * 100;

    return _react2.default.createElement(
        "div",
        { className: "cell small-12 large-8 large-offset-2 progress-container" },
        _react2.default.createElement(
            "p",
            { className: "bold" },
            message
        ),
        _react2.default.createElement(
            "div",
            { className: "progress progress-bar", role: "progressbar", tabIndex: "0", "aria-valuenow": "" + percentComplete, "aria-valuemin": "0", "aria-valuetext": message, "aria-valuemax": "100" },
            _react2.default.createElement("div", { className: "progress-meter", style: { width: percentComplete + '%' } })
        )
    );
};

exports.default = ProgressBar;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRadioGroup = __webpack_require__(421);

var _reactRedux = __webpack_require__(47);

var _answers = __webpack_require__(422);

var _tracker = __webpack_require__(423);

var _score = __webpack_require__(424);

var _subSectionScore = __webpack_require__(425);

var _subSectionScore2 = _interopRequireDefault(_subSectionScore);

var _sectionScore = __webpack_require__(426);

var _sectionScore2 = _interopRequireDefault(_sectionScore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Question = function Question(_ref) {
    var answers = _ref.answers,
        existingAnswer = _ref.existingAnswer,
        qId = _ref.qId,
        question = _ref.question,
        scores = _ref.scores,
        secId = _ref.secId,
        setAnswer = _ref.setAnswer,
        setCompleted = _ref.setCompleted,
        setLatestQuestion = _ref.setLatestQuestion,
        setSectionScore = _ref.setSectionScore,
        setSubSectionScore = _ref.setSubSectionScore,
        subSecId = _ref.subSecId,
        tracker = _ref.tracker;

    var handleChange = function handleChange(value) {
        var newAnswer = parseInt(value);
        setAnswer(_defineProperty({}, qId, newAnswer), secId, subSecId);
        setLatestQuestion(secId, subSecId, qId);
    };

    (0, _react.useEffect)(function () {
        var subSectionAnswers = Object.values(answers[secId][subSecId]).filter(function (answer) {
            return answer !== "";
        });
        var numAnswered = subSectionAnswers.length;
        numAnswered === tracker[secId][subSecId].totalQuestions && setCompleted(secId, subSecId);
        setSubSectionScore(subSecId, Math.round((0, _subSectionScore2.default)(subSectionAnswers)));
    }, [answers]);

    (0, _react.useEffect)(function () {
        var subSectionData = Object.values(scores.subSections).filter(function (subSection) {
            return subSection.section === secId && !!subSection.score;
        });
        var subSectionScores = subSectionData.length === 0 ? undefined : subSectionData.map(function (subSection) {
            return [subSection.score, subSection.weight];
        });
        !!subSectionScores && setSectionScore(secId, (0, _sectionScore2.default)(subSectionScores));
    }, [scores.subSections]);

    return _react2.default.createElement(
        _reactRadioGroup.RadioGroup,
        {
            className: 'cell small-12 large-8 large-offset-2 question-box',
            Component: 'fieldset',
            name: question.id,
            selectedValue: existingAnswer,
            onChange: handleChange
        },
        _react2.default.createElement(
            'legend',
            null,
            question.text
        ),
        _react2.default.createElement(
            'div',
            { className: 'input--radio' },
            _react2.default.createElement(_reactRadioGroup.Radio, { id: 'no', className: 'input', value: '1' }),
            _react2.default.createElement(
                'label',
                { className: 'bold', htmlFor: 'no' },
                'No'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'input--radio' },
            _react2.default.createElement(_reactRadioGroup.Radio, { id: 'somewhat', className: 'input', value: '2' }),
            _react2.default.createElement(
                'label',
                { className: 'bold', htmlFor: 'somewhat' },
                'Somewhat'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'input--radio' },
            _react2.default.createElement(_reactRadioGroup.Radio, { id: 'definitely', className: 'input', value: '3' }),
            _react2.default.createElement(
                'label',
                { className: 'bold', htmlFor: 'definitely' },
                'Definitely'
            )
        ),
        _react2.default.createElement('hr', { className: 'divider' }),
        _react2.default.createElement(
            'div',
            { className: 'input--radio' },
            _react2.default.createElement(_reactRadioGroup.Radio, { id: 'na', className: 'input', value: '0' }),
            _react2.default.createElement(
                'label',
                { className: 'bold', htmlFor: 'na' },
                'Not Applicable'
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    var secId = props.question.secId;
    var subSecId = props.question.subSecId;
    var qId = props.question.qId;

    return {
        answers: state.answers,
        existingAnswer: '' + state.answers[secId][subSecId][qId],
        qId: qId,
        scores: state.scores,
        secId: secId,
        subSecId: subSecId,
        tracker: state.tracker
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setAnswer: function setAnswer(answer, secId, subSecId) {
            return dispatch((0, _answers.setAnswer)(answer, secId, subSecId));
        },
        setCompleted: function setCompleted(secId, subSecId) {
            return dispatch((0, _tracker.setCompleted)(secId, subSecId));
        },
        setLatestQuestion: function setLatestQuestion(secId, subSecId, qId) {
            return dispatch((0, _tracker.setLatestQuestion)(secId, subSecId, qId));
        },
        setSectionScore: function setSectionScore(secId, score) {
            return dispatch((0, _score.setSectionScore)(secId, score));
        },
        setSubSectionScore: function setSubSectionScore(subSecId, score) {
            return dispatch((0, _score.setSubSectionScore)(subSecId, score));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Question);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = __webpack_require__(52);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var Radio = (function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(Radio, [{
    key: 'render',
    value: function render() {
      var _context$radioGroup = this.context.radioGroup;
      var name = _context$radioGroup.name;
      var selectedValue = _context$radioGroup.selectedValue;
      var onChange = _context$radioGroup.onChange;

      var optional = {};
      if (selectedValue !== undefined) {
        optional.checked = this.props.value === selectedValue;
      }
      if (typeof onChange === 'function') {
        optional.onChange = onChange.bind(null, this.props.value);
      }

      return _react2['default'].createElement('input', _extends({}, this.props, {
        type: 'radio',
        name: name
      }, optional));
    }
  }]);

  return Radio;
})(_react2['default'].Component);

exports.Radio = Radio;
;

Radio.contextTypes = {
  radioGroup: _propTypes2['default'].object
};

var RadioGroup = (function (_React$Component2) {
  _inherits(RadioGroup, _React$Component2);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(RadioGroup, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props;
      var name = _props.name;
      var selectedValue = _props.selectedValue;
      var onChange = _props.onChange;

      return {
        radioGroup: {
          name: name, selectedValue: selectedValue, onChange: onChange
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var Component = _props2.Component;
      var name = _props2.name;
      var selectedValue = _props2.selectedValue;
      var onChange = _props2.onChange;
      var children = _props2.children;

      var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);

      return _react2['default'].createElement(
        Component,
        rest,
        children
      );
    }
  }]);

  return RadioGroup;
})(_react2['default'].Component);

exports.RadioGroup = RadioGroup;
;

RadioGroup.defaultProps = {
  Component: "div"
};

RadioGroup.propTypes = {
  name: _propTypes2['default'].string,
  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
  onChange: _propTypes2['default'].func,
  children: _propTypes2['default'].node.isRequired,
  Component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].object])
};

RadioGroup.childContextTypes = {
  radioGroup: _propTypes2['default'].object
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var setAnswer = exports.setAnswer = function setAnswer(answer, secId, subSecId) {
    return {
        type: 'SET_ANSWER',
        answer: answer,
        secId: secId,
        subSecId: subSecId
    };
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var setLatestQuestion = exports.setLatestQuestion = function setLatestQuestion(secId, subSecId, qId) {
    return {
        type: 'SET_LATEST_QUESTION',
        secId: secId,
        subSecId: subSecId,
        qId: qId
    };
};

var setCompleted = exports.setCompleted = function setCompleted(secId, subSecId) {
    return {
        type: 'SET_COMPLETED',
        secId: secId,
        subSecId: subSecId
    };
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var setSubSectionScore = exports.setSubSectionScore = function setSubSectionScore(subSecId, score) {
    return {
        type: 'SET_SUBSECTION_SCORE',
        subSecId: subSecId,
        score: score
    };
};

var setSectionScore = exports.setSectionScore = function setSectionScore(secId, score) {
    return {
        type: 'SET_SECTION_SCORE',
        secId: secId,
        score: score
    };
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (answers) {
    var intAnswers = answers.map(function (answer) {
        return parseInt(answer);
    });
    var noNaAnswers = intAnswers.filter(function (num) {
        return num > 0;
    });
    var points = noNaAnswers.length > 0 ? noNaAnswers.reduce(function (acc, cur) {
        return acc + cur;
    }) : [];
    return points / (noNaAnswers.length * 3) * 100;
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// subSectionScores is an array of arrays, each with score, weight
// ex: for patient readiness - [[56, 0.5], [35, 0.5]]
exports.default = function (subSectionScores) {
    var weightedScores = subSectionScores.map(function (subSection) {
        return subSection[0] * subSection[1];
    });
    return Math.round(weightedScores.reduce(function (acc, cur) {
        return acc + cur;
    }));
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    qId: "111",
    secId: "core",
    subSecId: "11",
    text: "Do patients in your practice have difficulty getting the medical care they need because providers are too far away, patients lack transportation, or patients are unable to leave work or home?"
}, {
    qId: "112",
    secId: "core",
    subSecId: "11",
    text: "Has your organization identified specific types of patients or clinical needs that may benefit from using telehealth?"
}, {
    qId: "113",
    secId: "core",
    subSecId: "11",
    text: "Do patients in your practice ask for telehealth services or express interest in aspects of telehealth such as remote visits?"
}, {
    qId: "114",
    secId: "core",
    subSecId: "11",
    text: "Do patients in your practice use or express a need or desire for afterhours (evenings and weekends) medical care?"
}, {
    qId: "115",
    secId: "core",
    subSecId: "11",
    text: "Do providers affiliated with your practice routinely travel over 30 minutes from their primary location to provide services in other locations?"
}, {
    qId: "116",
    secId: "core",
    subSecId: "11",
    text: "Do the potential benefits of telehealth for your practice outweigh the potential challenges associated with telehealth?"
}, {
    qId: "121",
    secId: "core",
    subSecId: "12",
    text: "Is your practice’s leadership committed to telehealth development efforts?"
}, {
    qId: "122",
    secId: "core",
    subSecId: "12",
    text: "Has your practice identified the vision, priorities, and goals for implementing telehealth?"
}, {
    qId: "123",
    secId: "core",
    subSecId: "12",
    text: "Has your practice created a telehealth business plan?"
}, {
    qId: "124",
    secId: "core",
    subSecId: "12",
    text: "Has your practice’s leadership had past successes with instituting programs that required complex change processes, such as quality improvement initiatives or electronic health record implementations?"
}, {
    qId: "211",
    secId: "finance",
    subSecId: "21",
    text: "Has your practice considered how it will fund any capital costs (e.g., equipment, software, licensing) needed to start a telehealth program?"
}, {
    qId: "212",
    secId: "finance",
    subSecId: "21",
    text: "Has your practice identified what additional staffing costs, if any, are needed to implement and maintain a telehealth program?"
}, {
    qId: "213",
    secId: "finance",
    subSecId: "21",
    text: "Has your practice examined the telehealth services reimbursement policies for major insurers (Medicare/Medicaid, and private insurance)?"
}, {
    qId: "214",
    secId: "finance",
    subSecId: "21",
    text: "Has your practice considered whether it would be financially feasible to offer telehealth services that are reimbursed by some but not all insurers?"
}, {
    qId: "215",
    secId: "finance",
    subSecId: "21",
    text: "Has your practice gathered the necessary information to conduct a cost, benefit, and risk analysis of implementing and using telehealth?"
}, {
    qId: "311",
    secId: "operations",
    subSecId: "31",
    text: "Has your practice determined the staff responsibilities required to manage the administrative aspects of telehealth such as appointment scheduling, coordinating information across providers, and patient documentation?"
}, {
    qId: "312",
    secId: "operations",
    subSecId: "31",
    text: "Has your practice determined the staff responsibilities required to support telehealth patients, such as having a dedicated telehealth contact person to explain telehealth, answer patient questions, and provide assistance during telehealth appointments?"
}, {
    qId: "313",
    secId: "operations",
    subSecId: "31",
    text: "Has your practice determined what, if any, additional telehealth staffing support is needed to implement and maintain a telehealth program?"
}, {
    qId: "314",
    secId: "operations",
    subSecId: "31",
    text: "Has your practice determined how to protect staff time that needs to be dedicated to their telehealth roles and responsibilities?"
}, {
    qId: "321",
    secId: "operations",
    subSecId: "32",
    text: "Has your practice considered how administrative workflows (scheduling, billing, patient documentation, communication between staff) will need to change to incorporate telehealth?"
}, {
    qId: "322",
    secId: "operations",
    subSecId: "32",
    text: "Has your practice considered how clinical workflows (e.g., taking vital signs, ordering labs, writing prescriptions) will need to change to incorporate telehealth services?"
}, {
    qId: "323",
    secId: "operations",
    subSecId: "32",
    text: "Has your practice considered how care for telehealth patients will be coordinated and communicated across providers?"
}, {
    qId: "324",
    secId: "operations",
    subSecId: "32",
    text: "Has your practice determined how to obtain and document the patient’s consent prior to receiving telehealth services?"
}, {
    qId: "325",
    secId: "operations",
    subSecId: "32",
    text: "Has your practice considered how telehealth services will fit within your practice’s workflow with respect to when telehealth services are offered (e.g., follow-up care vs treatment, referral vs. self-referral, after hours vs. regular hours)?"
}, {
    qId: "331",
    secId: "operations",
    subSecId: "33",
    text: "Has your practice determined state licensing requirements necessary for each provider type (e.g., physician, nurse, PA) implementing telehealth services?"
}, {
    qId: "332",
    secId: "operations",
    subSecId: "33",
    text: "Has your practice evaluated privacy and confidentiality procedures for telehealth services and how these conform to patient health protection laws (e.g., HIPAA; 42 CFR-Part II)?"
}, {
    qId: "333",
    secId: "operations",
    subSecId: "33",
    text: "Has your practice determined potential telehealth malpractice insurance coverage and liability costs?"
}, {
    qId: "334",
    secId: "operations",
    subSecId: "33",
    text: "Has your practice determined whether any additional credentialing processes are needed for providers to provide telehealth services?"
}, {
    qId: "341",
    secId: "operations",
    subSecId: "34",
    text: "Has your practice considered what the “success factors” for telehealth are such as cost effectiveness, patient/provider satisfaction, improved patient outcomes?"
}, {
    qId: "342",
    secId: "operations",
    subSecId: "34",
    text: "Has your practice considered how staff and patients will provide feedback on the telehealth program and how it is working?"
}, {
    qId: "343",
    secId: "operations",
    subSecId: "34",
    text: "Does your practice have tools or methods in place for soliciting feedback from providers, staff and patients that could be used or adapted for telehealth?"
}, {
    qId: "344",
    secId: "operations",
    subSecId: "34",
    text: "Has your practice considered the need for making improvements to services and administrative procedures based on feedback from providers, staff, and patients?"
}, {
    qId: "351",
    secId: "operations",
    subSecId: "35",
    text: "Has your practice reviewed or tested different telehealth equipment, software or services?"
}, {
    qId: "352",
    secId: "operations",
    subSecId: "35",
    text: "Has your practice identified what types of telecommunication connections (e.g., bandwidth and internet connectivity quality) are needed to support telehealth at both originating and distant sites?"
}, {
    qId: "353",
    secId: "operations",
    subSecId: "35",
    text: "Have staff at your practice been involved in reviewing or selecting the technology?"
}, {
    qId: "354",
    secId: "operations",
    subSecId: "35",
    text: "Does your practice have existing IT staff or an IT vendor that provides technical expertise, technical support and troubleshooting?"
}, {
    qId: "361",
    secId: "operations",
    subSecId: "36",
    text: "Has your practice identified a designated space for virtual patient visits with an appropriate layout, privacy, and adequate lighting that will enable a distant provider to do a clinical assessment?"
}, {
    qId: "362",
    secId: "operations",
    subSecId: "36",
    text: "Has your practice identified the requirements for physical space and equipment at the provider’s site to ensure quality and privacy? For example, has your practice considered whether providers will consult from their office or a designated telehealth room?"
}, {
    qId: "363",
    secId: "operations",
    subSecId: "36",
    text: "Has your practice considered emergency protocols for telehealth patients?"
}, {
    qId: "411",
    secId: "staff",
    subSecId: "41",
    text: "Are your staff aware of telehealth and the potential benefits and challenges involved in implementing a program?"
}, {
    qId: "412",
    secId: "staff",
    subSecId: "41",
    text: "Has your practice considered how to ensure provider engagement in telehealth services once they’re implemented?"
}, {
    qId: "413",
    secId: "staff",
    subSecId: "41",
    text: "Has your practice considered how much time (calendar time and staff time) will be devoted to training staff and providers (particularly those who are less tech-savvy) on telehealth services?"
}, {
    qId: "421",
    secId: "staff",
    subSecId: "42",
    text: "Has your practice identified one or more provider champions within the practice who are enthusiastic for telehealth and can keep the process moving forward once started?"
}, {
    qId: "422",
    secId: "staff",
    subSecId: "42",
    text: "Are clinical staff at your practice interested in and willing to use telehealth technology for client services?"
}, {
    qId: "423",
    secId: "staff",
    subSecId: "42",
    text: "Do any of the staff at your practice have experience with telehealth services?"
}, {
    qId: "424",
    secId: "staff",
    subSecId: "42",
    text: "Has your practice solicited interest and input on implementing telehealth from clinical staff and administrative staff within your practice?"
}, {
    qId: "511",
    secId: "patient",
    subSecId: "51",
    text: "Has your practice considered whether telehealth could be used to increase patient engagement in managing their health and making healthcare decisions?"
}, {
    qId: "512",
    secId: "patient",
    subSecId: "51",
    text: "When your practice has implemented technologies aimed at patients (e.g., patient portals, text reminders, online scheduling) have your patients used them?\n" + "[If you have not implemented any technology aimed at patients, answer Not Applicable.]"
}, {
    qId: "513",
    secId: "patient",
    subSecId: "51",
    text: "Does your practice have existing mechanisms in place that can be used or adapted to conduct education and outreach about telehealth to the target population?"
}, {
    qId: "514",
    secId: "patient",
    subSecId: "51",
    text: "Has your practice considered what additional methods might be needed to conduct education and outreach about telehealth to the target population?    "
}, {
    qId: "515",
    secId: "patient",
    subSecId: "51",
    text: "Has your practice considered patient demographics and cultural issues that could influence implementing telehealth?"
}, {
    qId: "521",
    secId: "patient",
    subSecId: "52",
    text: "Have you considered your patients’ perceived needs and motivations for telehealth to determine how telehealth can best benefit them?"
}, {
    qId: "522",
    secId: "patient",
    subSecId: "52",
    text: "Have you considered how well your patients comprehend health information and whether telehealth would help or hinder that?"
}, {
    qId: "523",
    secId: "patient",
    subSecId: "52",
    text: "Have you considered surveying patients to learn what types of telehealth services patients need, how important certain telehealth services are, or how best to implement telehealth?"
}];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcesPage = function ResourcesPage() {
  (0, _react.useEffect)(function () {
    document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
  }, []);

  return _react2.default.createElement(
    "div",
    { className: "grid-container page" },
    _react2.default.createElement(
      "h3",
      { className: "bold" },
      "Telehealth Resources"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Please click the links below to explore more telehealth resources. Each link will open in a new tab/window."
    ),
    _react2.default.createElement(
      "h5",
      { className: "blue-line bold uppercase" },
      "General Resources"
    ),
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://www.americantelemed.org/home", target: "_blank", rel: "noopener noreferrer" },
          "American Telehealth Association (ATA)"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://www.cchpca.org/telehealth-policy", target: "_blank", rel: "noopener noreferrer" },
          "Center for Connected Health Policy, The National Telehealth Policy Resource Center"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://ctel.org/", target: "_blank", rel: "noopener noreferrer" },
          "Center for Telehealth and e-Health Law (CTel) - Robert J Waters Center for Telehealth & e-Health Law"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://mhcc.maryland.gov/mhcc/pages/hit/hit_telemedicine/hit_telemedicine.aspx", target: "_blank", rel: "noopener noreferrer" },
          "Maryland Health Care Commission (MHCC) Telehealth"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.marylandtelehealth.org/", target: "_blank", rel: "noopener noreferrer" },
          "Maryland Telehealth Alliance, Inc."
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.matrc.org/", target: "_blank", rel: "noopener noreferrer" },
          "Mid-Atlantic Telehealth Resource Center"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.telehealthresourcecenter.org/", target: "_blank", rel: "noopener noreferrer" },
          "Telehealth Resource Centers"
        )
      )
    ),
    _react2.default.createElement(
      "h5",
      { className: "blue-line bold uppercase" },
      "Privacy and Security"
    ),
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://mhcc.maryland.gov/mhcc/Pages/hit/hit_cybersecurity/hit_cybersecurity.aspx", target: "_blank", rel: "noopener noreferrer" },
          "MHCC Cybersecurity"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "http://mhcc.maryland.gov/mhcc/Pages/hit/hit_hipaa/hit_hipaa.aspx", target: "_blank", rel: "noopener noreferrer" },
          "MHCC HIPAA"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.hhs.gov/hipaa/for-professionals/index.html", target: "_blank", rel: "noopener noreferrer" },
          "U.S. Department of Health and Human Services (HHS) Health Insurance Portability and Accountability Act (HIPAA) for Professionals"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.hhs.gov/hipaa/for-professionals/training/index.html", target: "_blank", rel: "noopener noreferrer" },
          "HHS \u2013 Helping Entities Implement Privacy and Security Protections"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.hhs.gov/hipaa/for-professionals/privacy/guidance/index.html", target: "_blank", rel: "noopener noreferrer" },
          "HHS Privacy Rule Guidance Materials"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.hhs.gov/hipaa/for-professionals/security/guidance/index.html", target: "_blank", rel: "noopener noreferrer" },
          "HHS Security Rule Guidance Materials:"
        )
      )
    ),
    _react2.default.createElement(
      "h5",
      { className: "blue-line bold uppercase" },
      "Privacy and Security"
    ),
    _react2.default.createElement(
      "ul",
      null,
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.cdc.gov/obesity/downloads/cdc-evaluation-workbook-508.pdf", target: "_blank", rel: "noopener noreferrer" },
          "Centers for Disease Control and Prevention (CDC) \u2013 Developing an Effective Evaluation Plan"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://ctb.ku.edu/en/table-of-contents/evaluate/evaluation/evaluation-plan/main", target: "_blank", rel: "noopener noreferrer" },
          "Community Toolbox \u2013 Developing an Evaluation Plan"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://www.thehealthcompass.org/how-to-guides/how-develop-monitoring-and-evaluation-plan", target: "_blank", rel: "noopener noreferrer" },
          "Health Compass - How to Develop a Monitoring and Evaluation Plan"
        )
      ),
      _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          "a",
          { href: "https://s3.amazonaws.com/rdcms-himss/files/production/public/HIMSSorg/Content/files/RTI%20Public%20Health%20Evaluation.pdf", target: "_blank", rel: "noopener noreferrer" },
          "Healthcare Information and Management Systems Society (HIMSS) \u2013 Using Public Health Models to Assess Health Information Technology (health IT) Implementation"
        )
      )
    )
  );
};

exports.default = ResourcesPage;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _PdfBtn = __webpack_require__(160);

var _PdfBtn2 = _interopRequireDefault(_PdfBtn);

var _SectionResult = __webpack_require__(430);

var _SectionResult2 = _interopRequireDefault(_SectionResult);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultsPage = function ResultsPage(_ref) {
    var scoredSectionData = _ref.scoredSectionData,
        scoredSubSections = _ref.scoredSubSections;

    (0, _react.useEffect)(function () {
        document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
    }, []);

    return _react2.default.createElement(
        'div',
        { className: 'grid-container page' },
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
            'div',
            { className: 'grid-x' },
            _react2.default.createElement(
                'div',
                { className: 'results-intro cell small-12 large-8' },
                _react2.default.createElement(
                    'h3',
                    { className: 'bold' },
                    'My Results'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'no-print' },
                    'Your results will appear on this page as you complete each key component of the readiness assessment.'
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'print-only' },
                    'These are your results from the Telehealth Readiness Assessment. Please visit mhcc.maryland.gov for more information.'
                ),
                !scoredSectionData && _react2.default.createElement(
                    'p',
                    null,
                    'Use the Concept Menu above to get started.'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'all-guidance--results btn-group no-print' },
                _react2.default.createElement(_PdfBtn2.default, { link: '/Telehealth-Readiness-Guidance.pdf', btnText: 'Download All Guidance' }),
                _react2.default.createElement(
                    'button',
                    { className: 'btn pdf-btn no-print print-btn', onClick: function onClick() {
                            gtag('event', 'Print results', {
                                'event_category': 'download'
                            });
                            window.print();
                        } },
                    'Print My Results',
                    _react2.default.createElement(
                        'svg',
                        { className: 'pdf-icon', viewBox: '0 0 512 512', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                        _react2.default.createElement(
                            'g',
                            null,
                            _react2.default.createElement('path', { d: 'M448,192 L448,77.25 L370.74,0 L96,0 L64,32 L64,192 C28.65,192 0,220.65 0,256 L0,384 L64,384 L64,480 L96,512 L416,512 L448,480 L448,384 L512,384 L512,256 C512,220.65 483.35,192 448,192 Z M417,482 L94,482 L94,340 L417,340 L417,482 Z M417,220 L94,220 L94,30 L336.25,30 L336.25,106 L417,106 L417,220 Z M458,267 C444.75,267 434,256.25 434,243 C434,229.74 444.75,219 458,219 C471.25,219 482,229.74 482,243 C482,256.25 471.25,267 458,267 Z' })
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'section-results-list no-print-vertical-margin' },
            !!scoredSectionData && scoredSectionData.map(function (section) {
                return _react2.default.createElement(_SectionResult2.default, { firstSubSection: section.subSections[0], section: section, subSectionScores: scoredSubSections.filter(function (subSection) {
                        return subSection.section === section.secId;
                    }), key: section.secId });
            })
        )
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    var scoredSections = Object.keys(state.scores.sections);
    var scoredSubSections = Object.values(state.scores.subSections).filter(function (subSection) {
        return subSection.score != null;
    });

    return {
        scoredSectionData: scoredSections.length === 0 ? undefined : _sections2.default.filter(function (section) {
            return scoredSections.includes(section.secId);
        }),
        scoredSubSections: scoredSubSections
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResultsPage);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactRouterDom = __webpack_require__(12);

var _ScoreBar = __webpack_require__(161);

var _ScoreBar2 = _interopRequireDefault(_ScoreBar);

var _subSections = __webpack_require__(62);

var _subSections2 = _interopRequireDefault(_subSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionResult = function SectionResult(_ref) {
    var firstSubSection = _ref.firstSubSection,
        sectionScore = _ref.sectionScore,
        section = _ref.section,
        subSectionScores = _ref.subSectionScores;

    var findSubSectionScore = function findSubSectionScore(scoreNum) {
        if (!scoreNum) {
            return { text: "", className: "" };
        } else if (scoreNum <= 50) {
            return { text: "Area for Improvement", className: "low-score" };
        } else if (scoreNum <= 75) {
            return { text: "Almost Ready", className: "medium-score" };
        } else {
            return { text: "Ready", className: "high-score" };
        }
    };

    return _react2.default.createElement(
        'div',
        { className: 'section-result-bar grid-x grid-margin-x grid-padding-x' },
        _react2.default.createElement(
            'div',
            { className: 'section-title cell small-12 medium-4 large-3' },
            _react2.default.createElement('div', { className: 'icon ' + section.secId + '-icon', dangerouslySetInnerHTML: section.icon }),
            _react2.default.createElement(
                'h4',
                { className: 'bold' },
                section.number + '. ' + section.title
            ),
            _react2.default.createElement(
                'div',
                { className: 'btn-group--concept-result no-print' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/question/' + section.secId + '/' + firstSubSection + '/' + firstSubSection + '1', className: 'btn question-btn' },
                    'Answer Questions'
                ),
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { className: 'btn question-btn', to: '/guidance/' + section.secId + '/' + firstSubSection },
                    'View Guidance'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'cell small-12 medium-8 large-9' },
            _react2.default.createElement(
                'div',
                { className: 'grid-x grid-margin-x grid-margin-y' },
                _react2.default.createElement(
                    'div',
                    { className: 'section-result cell medium-12 large-6 no-print-vertical-margin' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Concept result:'
                    ),
                    _react2.default.createElement(_ScoreBar2.default, { score: sectionScore })
                ),
                subSectionScores[0].section != "finance" && _react2.default.createElement(
                    'div',
                    { className: 'sub-section-results cell medium-12 large-6 no-print-vertical-margin' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Key Component results:'
                    ),
                    subSectionScores.map(function (subSection) {
                        if (!!subSection.score) {
                            var result = findSubSectionScore(subSection.score);
                            var subSectionNumber = _subSections2.default.find(function (subSec) {
                                return subSec.title === subSection.title;
                            }).number;
                            return _react2.default.createElement(
                                'h5',
                                { key: subSection.title },
                                '' + section.number + subSectionNumber + '. ' + subSection.title + ' - ',
                                _react2.default.createElement(
                                    'span',
                                    { className: result.className + ' bold' },
                                    result.text
                                )
                            );
                        }
                    })
                )
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    return {
        sectionScore: state.scores.sections[props.section.secId]
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SectionResult);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _ScoreBar = __webpack_require__(161);

var _ScoreBar2 = _interopRequireDefault(_ScoreBar);

var _PdfBtn = __webpack_require__(160);

var _PdfBtn2 = _interopRequireDefault(_PdfBtn);

var _NextBtn = __webpack_require__(79);

var _NextBtn2 = _interopRequireDefault(_NextBtn);

var _Core = __webpack_require__(432);

var _Core2 = _interopRequireDefault(_Core);

var _Core3 = __webpack_require__(434);

var _Core4 = _interopRequireDefault(_Core3);

var _Finance = __webpack_require__(435);

var _Finance2 = _interopRequireDefault(_Finance);

var _Operations = __webpack_require__(436);

var _Operations2 = _interopRequireDefault(_Operations);

var _Operations3 = __webpack_require__(437);

var _Operations4 = _interopRequireDefault(_Operations3);

var _Operations5 = __webpack_require__(438);

var _Operations6 = _interopRequireDefault(_Operations5);

var _Operations7 = __webpack_require__(439);

var _Operations8 = _interopRequireDefault(_Operations7);

var _Operations9 = __webpack_require__(440);

var _Operations10 = _interopRequireDefault(_Operations9);

var _Operations11 = __webpack_require__(441);

var _Operations12 = _interopRequireDefault(_Operations11);

var _Staff = __webpack_require__(442);

var _Staff2 = _interopRequireDefault(_Staff);

var _Staff3 = __webpack_require__(443);

var _Staff4 = _interopRequireDefault(_Staff3);

var _Patient = __webpack_require__(444);

var _Patient2 = _interopRequireDefault(_Patient);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

var _subSections = __webpack_require__(62);

var _subSections2 = _interopRequireDefault(_subSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionGuidance = function SectionGuidance(_ref) {
    var nextBtnLink = _ref.nextBtnLink,
        score = _ref.score,
        section = _ref.section,
        subSection = _ref.subSection,
        subSectionScores = _ref.subSectionScores;

    (0, _react.useEffect)(function () {
        document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
    }, []);

    var findSubSectionScore = function findSubSectionScore(scoreNum) {
        if (!scoreNum) {
            return undefined;
        } else if (scoreNum <= 50) {
            return { text: "Area for Improvement", className: "low-score" };
        } else if (scoreNum <= 75) {
            return { text: "Almost Ready", className: "medium-score" };
        } else {
            return { text: "Ready", className: "high-score" };
        }
    };

    var matchSubSectionComponent = function matchSubSectionComponent(subSection) {
        var subSectionScore = findSubSectionScore(subSectionScores[subSection].score);
        switch (subSection) {
            case '11':
                return _react2.default.createElement(_Core2.default, { score: subSectionScore });
            case '12':
                return _react2.default.createElement(_Core4.default, { score: subSectionScore });
            case '21':
                return _react2.default.createElement(_Finance2.default, null);
            case '31':
                return _react2.default.createElement(_Operations2.default, { score: subSectionScore });
            case '32':
                return _react2.default.createElement(_Operations4.default, { score: subSectionScore });
            case '33':
                return _react2.default.createElement(_Operations6.default, { score: subSectionScore });
            case '34':
                return _react2.default.createElement(_Operations8.default, { score: subSectionScore });
            case '35':
                return _react2.default.createElement(_Operations10.default, { score: subSectionScore });
            case '36':
                return _react2.default.createElement(_Operations12.default, { score: subSectionScore });
            case '41':
                return _react2.default.createElement(_Staff2.default, { score: subSectionScore });
            case '42':
                return _react2.default.createElement(_Staff4.default, { score: subSectionScore });
            case '51':
                return _react2.default.createElement(_Patient2.default, null);
            case '52':
                return _react2.default.createElement(_Patient2.default, null);
            default:
                return undefined;
        }
    };

    var startingSubSection = matchSubSectionComponent(subSection);
    var subSectionData = _subSections2.default.filter(function (subSection) {
        return subSection.secId === section.secId;
    });

    var _useState = (0, _react.useState)(startingSubSection),
        _useState2 = _slicedToArray(_useState, 2),
        currentSubSection = _useState2[0],
        setCurrentSubSection = _useState2[1];

    return _react2.default.createElement(
        'div',
        { className: 'grid-container page wide-score' },
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
            'div',
            { className: 'grid-x', style: { marginBottom: '1rem' } },
            _react2.default.createElement(
                'div',
                { className: 'cell medium-12 large-5' },
                _react2.default.createElement(
                    'div',
                    { className: 'guidance-intro' },
                    _react2.default.createElement('div', { className: 'icon ' + section.secId + '-icon', dangerouslySetInnerHTML: section.icon }),
                    _react2.default.createElement(
                        'h3',
                        { className: 'bold' },
                        section.number + '. ' + section.title
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'cell medium-12 large-7' },
                _react2.default.createElement(
                    'div',
                    { className: 'btn-group btn-group--guidance' },
                    _react2.default.createElement(_PdfBtn2.default, { link: '/Telehealth-Readiness-Guidance.pdf', btnText: 'Download All Guidance' }),
                    _react2.default.createElement(_NextBtn2.default, { nextLabel: nextBtnLink === "/results" ? "View My Results" : "Next Concept", nextLink: nextBtnLink })
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'score-margin' },
            !!score && _react2.default.createElement(_ScoreBar2.default, { extraText: 'Overall concept result: ', score: score })
        ),
        _react2.default.createElement(
            'h3',
            { className: 'bold center' },
            'Supporting Guidance'
        ),
        section.secId !== 'finance' && section.secId !== 'patient' && _react2.default.createElement(
            'div',
            { className: 'subsection-toc center blue-line' },
            _react2.default.createElement(
                'p',
                null,
                'Click a key component to view the related guidance:'
            ),
            _react2.default.createElement(
                'ul',
                { className: 'subsection-names' },
                subSectionData.map(function (subSection) {
                    return _react2.default.createElement(
                        'li',
                        {
                            className: 'underline',
                            onClick: function onClick() {
                                setCurrentSubSection(matchSubSectionComponent(subSection.subSecId));
                                document.getElementById("subsection-anchor").scrollIntoView({ behavior: "smooth" });
                            },
                            key: subSection.subSecId
                        },
                        '' + section.number + subSection.number + '. ' + subSection.title
                    );
                })
            )
        ),
        _react2.default.createElement('div', { id: 'subsection-anchor' }),
        currentSubSection
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    var section = _sections2.default.find(function (section) {
        return section.secId === props.match.params.secId;
    });
    var sectionIndex = _sections2.default.indexOf(section);
    var nextSection = _sections2.default[sectionIndex + 1];

    return {
        nextBtnLink: section.secId === "patient" ? "/results" : '/menu/' + nextSection.secId + '/',
        score: state.scores.sections[section.secId],
        section: section,
        subSection: props.match.params.subSecId,
        subSectionScores: state.scores.subSections
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SectionGuidance);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactRouterDom = __webpack_require__(12);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Core11 = function Core11(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Need for Telehealth'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'When considering and developing a telehealth program, it is critical to understand the needs and motivation of the practice and patients and how telehealth can meet those needs. Identifying areas for improvement',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ', unmet patient needs',
                _react2.default.createElement(
                    'sup',
                    null,
                    '2'
                ),
                ', the overall strategic plan for your practice',
                _react2.default.createElement(
                    'sup',
                    null,
                    '3,4'
                ),
                ' and how telehealth is incorporated within the practice vision can help create a strong case for telehealth. Telehealth involves a variety of services and identifying specific services to offer should be based on your practice context and the needs of your patients. A telehealth service that a colleague offers in his or her practice may not be the best fit for yours. Your practice should identify ways that telehealth can help address the needs of your practice and its patient population. Ultimately, the benefit of telehealth comes from its potential to provide value to different types of stakeholders, including patients, staff, vendors, and payers.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '5'
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to telehealth implementation. These include identifying the need for telehealth to determine what services to offer and identifying benefits of those services.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identify the need for telehealth'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'bold italicize' },
                                    'Evaluate how telehealth aligns with the overarching goals of the practice '
                                ),
                                ' including your strategic plan and vision for the future.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '6,7'
                                ),
                                ' Telehealth may be able to help address concerns or fill gaps in your current practice.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '3,4,8,9'
                                ),
                                ' Some needs telehealth can address include:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Overcome patient barriers to receiving care (e.g., distance, availability or transportation difficulties).',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '10-12'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize bold' },
                                            'Example: '
                                        ),
                                        'If a significant portion of your patient population requires comprehensive behavioral health care but there are limited local specialists, telehealth may be able to expand access to specialists and/or reduce the amount of time patients spend driving to appointments.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Allow practices to facilitate patient care for chronic or complex conditions.'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize bold' },
                                            'Example: '
                                        ),
                                        'If a patient keeps a journal of glucose readings, a provider could review those and provide a virtual consult versus having a patient come in for a face-to-face visit.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Improve provider and staff access to training, resources, or other critical elements.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '13,14'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Some practices find that doing site visits with other places that have implemented telehealth is helpful to their understanding of how telehealth may work in their practice. Vendors can typically arrange this for you.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Identify if/how telehealth can contribute to your practice meeting local or national goals',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '15'
                                ),
                                ' such as reporting outcome measures, state campaigns, or payer-based initiatives.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Organizations listed on the ',
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { className: 'underline', to: '/resources' },
                                            'Telehealth Resources page'
                                        ),
                                        ' may disseminate opportunities as they arise.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Review how telehealth may fit into the existing infrastructure',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '16'
                                ),
                                ' and workflow of your practice.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Determine what telehealth services to offer'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'bold italicize' },
                                    'Identify services for which there is an immediate and compelling need',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '2'
                                    )
                                ),
                                ' the expand to other areas.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '1'
                                ),
                                ' This will help establish buy\u2011in and ease the transition into telehealth.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'ul-label' },
                                'Common places to start include:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize' },
                                            'Behavioral health services'
                                        ),
                                        ' - If there is a gap between the availability of on-site or local mental health services and patient needs, telehealth may be used to reach specialists and address this issue.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '18,19'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize' },
                                            'Follow-up'
                                        ),
                                        ' - Telehealth can be used for follow-up care for chronic conditions, wound care and other conditions requiring multiple visits.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '20'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize' },
                                            'Addressing location barriers'
                                        ),
                                        ' - Remote or immobile patient populations may benefit from telehealth.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '12,21'
                                        ),
                                        ' In addition, remote patient monitoring may enhance services already in place.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '22,23'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Not every telehealth application or videoconferencing use will be valuable for every practice. For example, if your patient population does not have access to technology at home, then remote patient monitoring may not be a good fit.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '5'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'example-box' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'italicize bold' },
                                    'Example: '
                                ),
                                'Practices in rural areas may use telehealth to facilitate a specialty visit in a larger city to reduce the travel time for patients to receive additional care.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '24-26'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Document benefits of telehealth services'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Once you identify what telehealth services will be offered',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '27'
                                ),
                                ' then quantify the benefits you expect to achieve. This includes developing and sharing goals, considering the patient perspective and the practice perspective.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'Identify anticipated benefits of telehealth'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Based on your anticipated use of telehealth, identify the benefits you expect to see. Benefits can be to the practice, patients or both.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'example-box margin-bottom' },
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'italicize bold' },
                                        'Benefits to the practice'
                                    ),
                                    ' could include reduced no-show rate, increased reporting of quality outcome measures, provider satisfaction, reduced provider travel time and increased efficiency.'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'italicize bold' },
                                        'Benefits to patients'
                                    ),
                                    ' could include improved outcomes, improved access to care, improved follow-up, and reduction in travel time.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'Developing goals based on benefits'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Develop goals based on your expected use of telehealth and benefits and think about what goals you can measure. Goals to consider might include the number of encounters or outcome measures for a subpopulation.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Establish guidelines for when you expect to use telehealth and keep that in mind when defining goals.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '28'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'italicize bold' },
                                            'Example:'
                                        ),
                                        ' You may establish a rule that all new patients must have a certain number of appointments in person before using telehealth. This could influence your goals if you have a transient population.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Consider demographics of your patient population when setting your goals so that your goals align with your patient population\u2019s access to technology, technology acceptance and socioeconomic status.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '3,4'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Keep in mind that change takes time for both the practice and patients.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Consider the resources available to your practice when setting goals.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Establish goals that are measurable in order to assess if the practice is reaching its goals.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'Sharing goals'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Share the goals for the practice\u2019s use of telehealth with providers, practice staff and (when you deem it appropriate) patients and any referring providers.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '29,30'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Ask for input from both those who do and those who do not support telehealth and modify goals as appropriate.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '3,4,31,32'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Arkwright B. Telehealth readiness factors - what are they and why are they essential? 2014. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.himss.org/news/telehealth-readiness-factors-what-are-they-and-why-are-they-essential', target: '_blank' },
                                        'www.himss.org/news/telehealth-readiness-factors-what-are-they-and-why-are-they-essential'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Weinstein RS, Lopez AM, Joseph BA, et al. Telemedicine, telehealth, and mobile health applications that work: opportunities and barriers. Am J Med. 2014;127(3):183-187. PMID: 24384059. doi: 10.1016/j.amjmed.2013.09.032'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson A, Healy T, et al. A study of a rural community\'s readiness for telehealth. Journal of Telemedicine and Telecare. 2003;9:259-263'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vassilev I, Rowsell A, Pope C, et al. Assessing the implementability of telehealth interventions for self-management support: a realist review. Implementation Science. 2015;10. PMID: WOS:000354182900001. doi: 10.1186/s13012-015-0238-9'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'CTEC. Assessing organizational readiness: is your organization ready for telemedicine? 2009. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf', target: '_blank' },
                                        'www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci. 2016;11(1):146. PMID: 27782832. doi: 10.1186/s13012-016-0510-7'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Yusif S, Hafeez-Baig A, Soar J. e-Health readiness assessment factors and measuring tools: a systematic review. Int J Med Inform. 2017;107:56-64. PMID: 29029692. doi: 10.1016/j.ijmedinf.2017.08.006'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka J, Simpson K, Hiott L, Langston L, Fakhry S, Ford D. A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res. 2013;13:33. PMID: 23360332. doi: 10.1186/1472-6963-13-33'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bullock DR, Vehe RK, Zhang L, Correll CK. Telemedicine and other care models in pediatric rheumatology: an exploratory study of parents\' perceptions of barriers to care and care preferences. Pediatr Rheumatol Online J. 2017;15(1):55. PMID: 28693580. doi: 10.1186/s12969-017-0184-y'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bullock DR, Vehe RK, Zhang L, Correll CK. Accessing pediatric rheumatology care: despite barriers, few parents prefer telemedicine. Pediatric Rheumatology. 2016;14. doi: 10.1186/s12969-016-0098-0'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jariwala N, Lipoff J. Evaluation of teledermatology implementation with insurance reimbursement in outpatient primary care practices. Journal of the American Academy of Dermatology. 2017;76(6):AB130-AB130. PMID: WOS:000403369301120'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Glenn IC, Bruns NE, Hayek D, Hughes T, Ponsky TA. Rural surgeons would embrace surgical telementoring for help with difficult cases and acquisition of new skills. Surg Endosc. 2017;31(3):1264-1268. PMID: 27444835. doi: 10.1007/s00464-016-5104-6'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Park H, Cormier E, Glenna G. Health consumers eHealth literacy to decrease disparities in accessing ehealth information. Stud Health Technol Inform. 2016;225:895-896. PMID: 27332397'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Baird MB, Whitney L, Caedo CE. Experiences and attitudes among psychiatric mental health advanced practice nurses in the use of telemental health: results of an online survey. J Am Psychiatr Nurses Assoc. 2018;24(3):235-240. PMID: 28748728. doi: 10.1177/1078390317717330'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'El Sanadi N. Telehealth expansion requires advances in payment and coverage policies. Mod Healthc. 2015;45(37):25. PMID: 26619694'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Asch DA. The hidden economics of telemedicine. Ann Intern Med. 2015;163(10):801-802. PMID: 26343261. doi: 10.7326/m15-1416'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Waugh M, Voyles D, Thomas MR. Telepsychiatry: benefits and costs in a changing health-care environment. International Review of Psychiatry. 2015;27(6):558-568. doi: 10.3109/09540261.2015.1091291'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bouknight JG, Srinivasan S, Glover J, Mazumder M. Geriatric telepsychiatry: model programs and innovations in clinical services and education. American Journal of Geriatric Psychiatry. 2015;23(3):S9'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Dodwad SJM, Hart BE, Lordon RJ, et al. Implementation of an mHealth postoperative wound management program. Journal of the American College of Surgeons. 2017;225(4):e88'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jamison RN. Are we really ready for telehealth cognitive behavioral therapy for pain? Pain. 2017;158(4):539-540. PMID: WOS:000400440200001. doi: 10.1097/j.pain.0000000000000801'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Slotwiner D, Wilkoff B. Cost efficiency and reimbursement of remote monitoring: a US perspective. Europace. 2013;15 Suppl 1:i54-i58. PMID: 23737232. doi: 10.1093/europace/eut109'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Terry NP. Mobile health: assessing the barriers. Chest. 2015;147(5):1429-1434. doi: 10.1378/chest.14-2459'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks E, Turvey C, Augusterfer EF. Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health. 2013;19(6):433-437. PMID: 23590176. doi: 10.1089/tmj.2013.0068'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Karem P, Shifflett K, Vegi L, Ravi K, Brooks M. Evaluating barriers to adopting telemedicine worldwide: a systematic review. Journal of Telemedicine and Telecare. 2018;24(1):4-12. PMID: WOS:000419868900002. doi: 10.1177/1357633x16674087'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Krowski N, Rodriguez B, Tran L, Vela J, Brooks M. Telehealth and patient satisfaction: a systematic review and narrative analysis. BMJ Open. 2017;7(8):e016242. PMID: 28775188. doi: 10.1136/bmjopen-2017-016242'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ferreira A. Steps to telehealth success - organizational readiness. 2016. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.avizia.com/blog/telehealth-success-organizational-readiness', target: '_blank' },
                                        'www.avizia.com/blog/telehealth-success-organizational-readiness'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Giambrone D, Rao BK, Esfahani A, Rao S. Obstacles hindering the mainstream practice of teledermatopathology. J Am Acad Dermatol. 2014;71(4):772-780. PMID: 24906611. doi: 10.1016/j.jaad.2014.04.043'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon MP, Duplantie J, Fortin JP, Landry R. Implementing telehealth to support medical practice in rural/remote regions: what are the conditions for success? Implementation Science. 2006(18). doi: doi:10.1186/1748-5908-1-18'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon MP, Ngangue P, Payne-Gagnon J, Desmartis M. m-Health adoption by healthcare professionals: a systematic review. J Am Med Inform Assoc. 2016;23(1):212-220. PMID: 26078410. doi: 10.1093/jamia/ocv052'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Hoonakker PLT, Carayon P. Work system barriers and strategies reported by tele-intensive care unit nurses: a case study. Critical Care Nursing Clinics of North America. 2018;30(2):259-271. PMID: 129386687. Language: English. Entry Date: 20180508. Revision Date: 20180508. Publication Type: Article. Journal Subset: Core Nursing. doi: 10.1016/j.cnc.2018.02.008'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ray KN, Felmet KA, Hamilton MF, et al. Clinician attitudes toward adoption of pediatric emergency telemedicine in rural hospitals. Pediatr Emerg Care. 2017;33(4):250-257. PMID: 26785087. doi: 10.1097/pec.0000000000000583'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Core11;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(1));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FadeIn =
/*#__PURE__*/
function (_Component) {
  _inherits(FadeIn, _Component);

  function FadeIn() {
    var _this;

    _classCallCheck(this, FadeIn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FadeIn).call(this));
    _this.state = {
      maxIsVisible: 0
    };
    return _this;
  }

  _createClass(FadeIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var count = _react["default"].Children.count(this.props.children);

      var i = 0;
      this.interval = setInterval(function () {
        i++;
        if (i > count) clearInterval(_this2.interval);

        _this2.setState({
          maxIsVisible: i
        });
      }, this.delay);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var transitionDuration = this.transitionDuration;
      return _react["default"].createElement("div", {
        className: this.props.className
      }, _react["default"].Children.map(this.props.children, function (child, i) {
        return _react["default"].createElement("div", {
          className: _this3.props.childClassName,
          style: {
            transition: "opacity ".concat(transitionDuration, "ms, top ").concat(transitionDuration, "ms"),
            position: "relative",
            top: _this3.state.maxIsVisible > i ? 0 : 20,
            opacity: _this3.state.maxIsVisible > i ? 1 : 0
          }
        }, child);
      }));
    }
  }, {
    key: "delay",
    get: function get() {
      return this.props.delay || 50;
    }
  }, {
    key: "transitionDuration",
    get: function get() {
      return this.props.transitionDuration || 400;
    }
  }]);

  return FadeIn;
}(_react.Component);

exports["default"] = FadeIn;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Core12 = function Core12(_ref) {
    var score = _ref.score;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Organizational Leadership Buy-In'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth implementation involves change, with implications throughout the entire practice. If practice leaders take an active, hands-on role in supporting telehealth implementation, this support is more likely to be infused throughout the practice.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1-4'
                ),
                ' In addition to setting an example, having leadership support and buy\u2011in can help when supporting staff engagement and addressing nay-sayers. When everyone in the practice is engaged and excited, it is easier to overcome implementation difficulties and patients will pick up on the excitement as well.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions leaders should take before and during telehealth implementation. They include identifying other leaders, understanding practice readiness for and experience with change, engaging those who have indicated they are not in favor of telehealth, reinforcing the reasons behind telehealth and ensuring support for staff.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identify other leaders within the practice'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Identify other leaders within the practice (e.g., practice manager, physician) who are in favor of telehealth and work with them to ensure they share their support throughout the practice and are on-board with necessary changes. Also, identify those who are early adopters of technology and those who are innovative.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '2-5'
                                ),
                                ' They can serve as telehealth champions.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Understand practice readiness for and experience with change'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'ul-label' },
                                'Understand practice readiness for and experience with change by reviewing how staff have handled previous changes, in particular those related to technology. Before implementation begins, your practice can look at what can be learned from previous changes, build on what went well, and identify areas to improve.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '6'
                                ),
                                ' Some items to consider include:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Staff experience and attitude about previous changes.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Organizational and technical challenges that need to be addressed such as human resource implications (e.g., role, responsibility or job description changes), technical and workflow training, policies, and procedures needed.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '1,2'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identify and address concerns'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Identify and address concerns of staff, particularly anyone in the practice not in favor of telehealth and make sure they feel heard prior to roll-out. Seek staff input to identify foreseeable issues and develop strategies to address these issues.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '5'
                                ),
                                ' Leaders must have authority to make changes if appropriate and respond to nay-sayers.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Share reasoning behind telehealth implementation'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Share reasoning behind telehealth implementation and how it\u2019s right for your practice and patients so that everyone understands why this change is helpful for the practice. This is particularly important to get provider engagement. Revisit the vision, priorities, and goals for implementing telehealth with leadership to maintain buy\u2011in and purpose for the initiative.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Work with other practice leaders to garner support'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'ul-label' },
                                'Work with other practice leaders to garner support for staff to demonstrate that this is a practice priority. This includes ensuring staff have sufficient time to adjust to telehealth.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7-9'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Allow time for clinical and administrative staff to adjust to telehealth.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '9'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Work with staff to identify operational and design components that might influence telehealth implementation and use.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '8'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Work to garner support and excitement around telehealth.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Share results'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Share results from assessment and evaluation as telehealth implementation continues to demonstrate program value and identify any changes that should be made.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson, A., Healy, T., Ho, K., Kazanjian, A., Woollard, R., Haydt, S., Bates, J. A study of a rural community\'s readiness for telehealth. Journal of telemedicine and telecare. 2003;9:259-263.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon, M. P., Brandstadt, H. K. Preparing for Success: Readiness Models for Rural Telehealth. J Postgrad Med. 2005;51(4).'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'CTEC. Assessing Organizational Readiness: Is Your Organization Ready for Telemedicine? 2009. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf', target: '_blank' },
                                        'http://www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implementation science : IS. 2016;11(1):146.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ferreira A. Steps to Telehealth Success - Organizational Readiness. 2016. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.avizia.com/blog/telehealth-success-organizational-readiness', target: '_blank' },
                                        'www.avizia.com/blog/telehealth-success-organizational-readiness'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Meyer J, Rowan B. Institutionalized Organizations: Formal Structure as Myth and Ceremony. The American Journal of Sociology. 1977;83(2):340 - 363.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ple-Plakon P, Lee PP, Blachley T, Musch DC, Woodward MA. Attitudes toward tele-ophthalmology. Investigative Ophthalmology and Visual Science. 2014;55(13):5565.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruklitis RJ, Tracy JA, McCambridge MM. Clinical and financial considerations for implementing an ICU telemedicine program. Chest. 2014;145(6):1392-1396.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Merchant KA, Ward MM, Mueller KJ. Hospital Views of Factors Affecting Telemedicine Use. Rural policy brief. 2015(2015 5):1-4.'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Core12;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Finance21 = function Finance21() {
    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Financial Considerations'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth implementation can have a variety of financial considerations.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1-3'
                ),
                ' Telehealth can affect infrastructure, workflow, and reimbursement, all of which can influence the financial health of your practice.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '4,5'
                ),
                ' Some telehealth programs have been funded through State, Federal, foundation, and payer grant programs.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '6'
                ),
                ' Others are funded through the practice or through partnerships with other organizations. Regardless of the funding source, creating a sustainable program is a key component of telehealth success. Identifying costs and benefits of telehealth before implementation is a critical part of sustainability. The payer landscape for telehealth is in flux,',
                _react2.default.createElement(
                    'sup',
                    null,
                    '7'
                ),
                ' so it is important to understand expected reimbursement. Identifying costs and benefits of telehealth can help you make an informed decision.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Before implementing telehealth, you should consider several types of actions. These include identifying costs and benefits for telehealth to conduct a return-on-investment (ROI) analysis and seeking clarity from payers regarding reimbursement and requirements. In addition, grant funding might be available from State, Federal, or foundation sources or through a partnership (e.g., by partnering with a larger provider such as an academic medical center) to help support telehealth implementation.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '8'
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identify the need for telehealth'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Telehealth vendors may have calculators to help identify costs and benefits. However, reviewing these items yourself can help you more fully understand costs and benefits that are specific to your practice so that you can make an informed decision about ROI.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '9'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'uppercase bold' },
                                            'Identify costs of telehealth'
                                        ),
                                        ' based on the service you are considering.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '10,11'
                                        ),
                                        ' Exact costs will vary based on the specific telehealth services you are implementing and the current technical infrastructure of the practice. Some categories of costs include:'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'margin-bottom sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Start-up costs such as technical infrastructure (e.g., cameras, lighting, computers), vendor costs, and training',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '4,12'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Ongoing costs such as staff time, connectivity, monthly service or licensing fees, and upgrades',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '13,14'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Opportunity costs of staff time',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '13'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'uppercase bold' },
                                            'Identify the benefits of telehealth'
                                        ),
                                        ', including sources of revenue or cost savings due to telehealth:'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'margin-bottom sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Additional revenue from payers (see below on obtaining clarity from payers)'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Ability to see more patients per day because of time savings',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '9,15'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Ability to have larger patient panels in a capitated system',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '6'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Reduced mileage reimbursement for providers (if applicable)',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '17'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Better payments under value-based programs (if applicable)',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '18'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'uppercase bold' },
                                            'Non-monetary benefits to consider'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'The following benefits of telehealth may not result in direct financial benefits to your practice but are important to consider:',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '19'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'ul',
                                            null,
                                            _react2.default.createElement(
                                                'li',
                                                null,
                                                'Improved adherence and follow-up with patients, which could lead to improved quality metrics and enhanced alternative care models',
                                                _react2.default.createElement(
                                                    'sup',
                                                    null,
                                                    '20'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                null,
                                                'Better outcomes and reduced cost to patients',
                                                _react2.default.createElement(
                                                    'sup',
                                                    null,
                                                    '18,21'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                null,
                                                'Improved preventative or proactive care between in-person visits'
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                null,
                                                'Travel reductions for patients and providers',
                                                _react2.default.createElement(
                                                    'sup',
                                                    null,
                                                    '22'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                null,
                                                'Reduction in hospitalizations',
                                                _react2.default.createElement(
                                                    'sup',
                                                    null,
                                                    '15,18'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Get clarity about reimbursement and requirements from payers'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'bold uppercase' },
                                    'Identify the payers that are the highest volume'
                                ),
                                ' in your practice. This information will help you prioritize your efforts.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'bold uppercase' },
                                    'Understand payer policies about reimbursement and keep up with changes.'
                                ),
                                ' The landscape for both public and private payers is changing',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7,23'
                                ),
                                ' due to telehealth policy updates and regulatory changes at the Federal and State levels.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Maryland Medicaid reimburses for services under the Telehealth Program.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'The Telehealth Program serves Medicaid participants regardless of geographic location within Maryland.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Telehealth providers must be enrolled in the Maryland Medical Assistance Program among other things.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Medicare pays for a limited number of services furnished by physicians or practitioners to eligible beneficiaries in rural/shortage areas via telehealth.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rural and health professional shortage areas are defined by the Health Resources and Services Administration.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Reimbursed services or codes are identified in the Physician Fee Schedule.'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'example-box margin-bottom' },
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    'You can get more information about telehealth reimbursement by calling payers or going online to the payer\u2019s medical policies. Some questions you may wish to ask or look up include:',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '24-29'
                                    )
                                ),
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'What services are reimbursed? Do some services receive higher reimbursement? Are some services covered more often than others or for particular populations?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'What are the requirements for reimbursement? (e.g., setting of care, special coding requirements, coding identifiers, or documentation requirements)'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Are some things not reimbursed?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Are particular identifiers needed for billing?'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'You can review external resources for further information about telehealth, available resources, and reimbursement policies.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Explore external support'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'If external support (e.g., grant funding and partnerships with other organizations) is available, it may give practices resources such as technology, personnel, technical assistance, and financial support.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Sources of grant funding for telehealth include payers, the Maryland Health Care Commission, the Maryland Community Resources Commission, foundations, and Federal agencies.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'External partners that may provide support include payers and academic medical centers that are seeking practices to participate in their telehealth efforts.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'These opportunities are disseminated through organizational listservs and mailings.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'External support should not be exclusively relied on to develop and sustain a telehealth program given that these types of support may be awarded for a limited time period focused on implementation or be subject to other changes over time.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ferreira, A. Steps to Telehealth Success\u2014Organizational Readiness. 2016.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon, M.P., J. Duplantie, J.P. Fortin, and R. Landry, Implementing telehealth to support medical practice in rural/remote regions: what are the conditions for success? Implement Sci, 2006. 1: p. 18.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon, M.P., et al., m-Health adoption by healthcare professionals: a systematic review. J Am Med Inform Assoc, 2016. 23(1): p. 212-20.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Effertz, G., et al., Sustaining and expanding telehealth: a survey of business models from selected prominent U.S. telehealth centers. Telemed J E Health, 2017. 23(2): p. 137-142.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Arkwright, B. Telehealth Readiness Factors\u2014What are They and Why Are They Essential? 2014.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Adler-Milstein, J., J. Kvedar, and D.W. Bates, Telehealth among US hospitals: several factors, including state reimbursement and licensure policies, influence adoption. Health Aff (Millwood), 2014. 33(2): p. 207-15.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Campagna, M., F. Naka, and J. Lu, Teledermatology: an updated overview of clinical applications and reimbursement policies. Int J Womens Dermatol, 2017. 3(3): p. 176-179.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Chen, S., A. Cheng, and K. Mehta, A review of telemedicine business models. Telemed J E Health, 2013. 19(4): p. 287-97.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bashshur, R.L., et al., Sustaining and realizing the promise of telemedicine. Telemed J E Health, 2013. 19(5): p. 339-45.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Binder, W.J., et al., Telemedicine in the intensive care unit: improved access to care at what cost? Crit Care Nurs Clin North Am, 2018. 30(2): p. 289-296.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Hertz, B.T., Telemedicine: patient demand, cost containment drive growth. Joining the trend may not be as expensive or time-consuming as you think, experts say. Med Econ, 2013. 90(3): p. 37, 39-42.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross, J., et al., Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci, 2016. 11(1): p. 146.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Waugh, M., D. Voyles, and M.R. Thomas, Telepsychiatry: benefits and costs in a changing health-care environment. International Review of Psychiatry, 2015. 27(6): p. 558-568.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruklitis, R.J., J.A. Tracy, and M.M. McCambridge, Clinical and financial considerations for implementing an ICU telemedicine program. Chest, 2014. 145(6): p. 1392-1396.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Schwamm, L.H., Telehealth: seven strategies to successfully implement disruptive technology and transform health care. Health Aff (Millwood), 2014. 33(2): p. 200-6.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rosen, A.R., et al., Landscape of business models in teledermatology. Cutis, 2016. 97(4): p. 302-304.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Russo, J.E., R.R. McCool, and L. Davies, VA telemedicine: an analysis of cost and time savings. Telemed J E Health, 2016. 22(3): p. 209-15.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Morphew, T., et al., Mobile health care operations and return on investment in predominantly underserved children with asthma: the breathmobile program. Popul Health Manag, 2013. 16(4): p. 261-9.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kumar, G., et al., The costs of critical care telemedicine programs: a systematic review and analysis. Chest, 2013. 143(1): p. 19-29.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'North, F., et al., Telemedicine barriers associated with regional quality measures. Telemed J E Health, 2014. 20(2): p. 179-81.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Okon, N., et al., Telestroke network cost-effectiveness in the pacific Northwest: geography and facility size support a cost-sharing model between hub and spoke. Stroke, 2015. 46(1).'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'MacKinney, A.C., et al., The business case for tele-emergency. Telemed J E Health, 2015. 21(12): p. 1005-11.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Trout, K.E., et al., Legal mapping analysis of state telehealth reimbursement policies. Telemed J E Health, 2017. 23(10): p. 805-814.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Weinstein, R.S., et al., Telemedicine, telehealth, and mobile health applications that work: opportunities and barriers. Am J Med, 2014. 127(3): p. 183-7.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Glenn, I.C., et al., Rural surgeons would embrace surgical telementoring for help with difficult cases and acquisition of new skills. Surg Endosc, 2017. 31(3): p. 1264-1268.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Blackman, K., Covering and reimbursing telehealth services. NCSL Legisbrief, 2016. 24(4): p. 1-2.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks, E., C. Turvey, and E.F. Augusterfer, Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health, 2013. 19(6): p. 433-7.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ladika, S., Telehealth dials up discussion about payment to providers. Manag Care, 2016. 25(6): p. 15-9.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rutledge, C.M., et al., Telehealth and eHealth in nurse practitioner training: current perspectives. Adv Med Educ Pract, 2017. 8: p. 399-409.'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Finance21;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations31 = function Operations31(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Telehealth Roles'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'As with any change, telehealth will impact roles and responsibilities for staff throughout your practice. It is important to understand how telehealth will modify roles and responsibilities from referral through billing so you can prepare and train staff accordingly. This will help garner a consistent understanding of expectations of the program and staff responsibilities to contribute to the success of the telehealth program. Proactively identifying areas of tension and minimizing conflict between roles and the amount of disruption to normal workflow,',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1-3'
                ),
                ' can improve the success of telehealth initiatives.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions your practice should consider prior to telehealth implementation related to roles and responsibilities. These include engaging staff during planning, identifying changes to roles and developing a plan for helping staff integrate their new telehealth roles into their regular workflow.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identifying roles and changes'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Engage staff during planning to obtain their buy\u2011in. This includes reiterating the benefits you expect to achieve, identifying goals and identifying resources.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Identify staff to help manage logistics and provide technical support to patients. This is in addition to a champion who will support telehealth buy\u2011in.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '4'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'bold uppercase' },
                                                'Manage logistics'
                                            ),
                                            ' - Identify physical space where telehealth will be used, appointment scheduling, information coordination across providers, and how staff time will be used.'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'bold uppercase' },
                                                'Technical support'
                                            ),
                                            ' includes staff who will set up technology for patients, assist patients with questions, and provide support during the appointment.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Identify activities needed to support the telehealth program, identify the roles to complete those activities, assign responsibility and structure training and workflow accordingly.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '5'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'margin-bottom sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Consider what support providers and staff need to effectively use the technology.'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'example-box' },
                                            'While you should consider vendor suggestions for training policy and procedure changes and workflow changes based on their previous experience you should adopt changes based on your practice\u2019s needs. For example some vendors suggest workflows based on having a full-time telehealth coordinator. A solo practitioner is unlikely to have staff for a dedicated person but will need to identify a person to serve this role in addition to their other roles and responsibilities.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Review current staff roles, considering how they would need to change to accommodate telehealth based on what you are implementing.',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '6'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'example-box' },
                                            'If you are not sure what role is appropriate for a given task, do not leave it to chance, but make a decision based on alignment with current work. Items without a role assigned end up with diffused responsibility and may not get done consistently.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Identify staff with availability and review other initiatives or duties which might conflict with telehealth efforts.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '6'
                                    ),
                                    ' In cases of conflicting roles or in a small practice where staff wear many hats, leadership must establish priorities.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ensure roles and responsibilities are clear and avoid spreading responsibility too widely.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Develop a process for onboarding new staff or transitioning telehealth roles in case of turnover.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ensure that there is a role and process to use emergency personnel or resources if needed.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Integrating telehealth and other roles'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'In order to ensure that staff are able to fulfill their telehealth roles and feel comfortable with any additional responsibilities, it is necessary to consider the roles they already fill at the practice and discuss expectations with them honestly and openly. Keep the lines of communication open.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'Communicate the changes in roles and responsibilities to staff'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Assess how relationships among staff will change given the new program, work with staff to address concerns, and develop strategies to ensure good communication.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '8,9'
                                    ),
                                    ' Encourage collaboration among clinical and administrative staff to increase buy\u2011in.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '10,11'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Clarify the resources needed for each staff and increase buy\u2011in by including staff and leadership in planning the new role.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '12'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'Communicate the expected lifecycle of telehealth project implementation and permanence of any changes to the organization.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ensure staff have an understanding of the impact of telehealth on their regular duties through education and dissemination of protocols and that best practices for face to face visits such a care coordination also apply for telehealth visits.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Work with the telehealth champion to reinforce protocols and the role of telehealth in the practice.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '3'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ensure that roles and responsibilities are structured to reduce the amount of time physicians spend on administrative aspects of telehealth services so they have more time for clinical activities.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '13'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'McGregor D, Keep M, Brunner M, et al. Preparing e-Health ready graduates: a qualitative focus group study. Stud Health Technol Inform. 2017;239:91-96. PMID: 128801371. doi: 10.3233/978-1-61499-783-2-91'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Phillips J, Yu D, Poon SK, et al. E-health readiness for teams: a comprehensive conceptual model. Stud Health Technol Inform. 2017;239:119-125. PMID: 28756446'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Shaw RJ, Kaufman MA, Bosworth HB, et al. Organizational factors associated with readiness to implement and translate a primary care based telemedicine behavioral program to improve blood pressure control: the HTN-IMPROVE study. Implement Sci. 2013;8:106. PMID: 24010683. doi: 10.1186/1748-5908-8-106'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci. 2016;11(1):146. PMID: 27782832. doi: 10.1186/s13012-016-0510-7'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. J Neurosurg Pediatr. 2016;25(6):753-757. PMID: 27589599. doi: 10.3171/2016.6.peds16202'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'CTEC. Assessing organizational readiness: is your organization ready for telemedicine? 2009. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf', target: '_blank' },
                                        'www.caltrc.org/wp-content/uploads/2013/10/08-1129-final_ctec_discovery_series.pdf'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vimarlund V, Le Rouge C. Barriers and opportunities to the widespread adoption of telemedicine: a bi-country evaluation. Stud Health Technol Inform. 2013;192:933. PMID: 23920707'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Meyer J, Pare G. Telepathology impacts and implementation challenges a scoping review. Arch Pathol Lab Med. 2015;139(12):1550-1557. PMID: WOS:000368422300015. doi: 10.5858/arpa.2014-0606-RA'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rutledge CM, Kott K, Schweickert PA, Poston R, Fowler C, Haney TS. Telehealth and eHealth in nurse practitioner training: current perspectives. Adv Med Educ Pract. 2017;8:399-409. PMID: 28721113. doi: 10.2147/amep.s116071'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Herrin J, Harris KG, Kenward K, Hines S, Joshi MS, Frosch DL. Patient and family engagement: a survey of US hospital practices. BMJ Quality & Safety. 2015. doi: 10.1136/bmjqs-2015-004006'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Wu RC, Abrams H, Baker M, Rossos PG. Implementation of a computerized physician order entry system of medications at the University Health Network--physicians\' perspectives on the critical issues. Healthc Q. 2006;9(1):106-109. PMID: 16548441'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka J, Simpson K, Hiott L, Langston L, Fakhry S, Ford D. A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res. 2013;13:33. PMID: 23360332. doi: 10.1186/1472-6963-13-33'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Stempniak M. Revisiting e-visits. Electronic visits slow to be embraced by payers and providers. Hosp Health Netw. 2013;87(10):25. PMID: 24303632'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Operations31;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactRouterDom = __webpack_require__(12);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations32 = function Operations32(_ref) {
    var score = _ref.score;
    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Scheduling and Workflow'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth implementation represents a change in the mode of care delivery, with corresponding changes in clinical and administrative processes.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ' Telehealth impacts activities from identifying patients and scheduling them through consultation, documentation and billing.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '2'
                ),
                ' Your practice should identify potential changes needed for telehealth implementation and how to address them. When possible, try to build on existing processes and practices to minimize disruption.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '3'
                ),
                ' Once you identify and document changes to clinical and administrative workflows, it is important to disseminate these to the staff through training and education.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to telehealth implementation. These include identifying processes that will change given telehealth, such as scheduling and workflow, and integrating telehealth into practice.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Identifying impacts of telehealth'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Identify processes that will change due to telehealth implementation ahead of time so that your practice is prepared.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '1'
                                ),
                                ' Preparation includes documenting and disseminating how your practice will handle changes.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '1,4'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'There are a number of aspects to consider when reviewing your workflows and identifying changes.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '5'
                                ),
                                ' Questions to consider include:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Which staff will be involved in the telehealth program and who will have input into decisions?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'How will responsibilities and staff roles be aligned?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'What are the time implications and are there ways to save time on administrative tasks?',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '6'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Will you schedule telehealth consults throughout clinic hours or during a particular time? If there will be after-hours telehealth visits, who will staff them?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Will they be flagged somehow so staff are aware it\u2019s a telehealth visit?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Will all providers deliver telehealth services or just some? How will this impact the schedule? Do the providers who will be offering telehealth services have particular scheduling preferences with respect to telehealth?'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'How will staff know about scheduling decisions?',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '2'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'before visit:'
                                    ),
                                    ' How will processes work for identifying and referring telehealth patients, communication between sites (i.e., location of the patient versus location of the provider)? When and how will patient consent for telehealth be obtained and stored, especially for patients who have not visited the practice?',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    ),
                                    ' In cases where there is coordination between providers, how will information exchange occur?'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'during visit:'
                                    ),
                                    ' Who will help the patient with the technology during the actual telehealth encounter?'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'after visit:'
                                    ),
                                    ' How will documentation and billing be handled?',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '8'
                                    ),
                                    ' How will staff work together and how they will communicate clinical and administrative information across sites and coordinate care.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '9'
                                    ),
                                    ' How will information be stored and who will have access to it? Will this process differ from other services? How will encounter information be shared with the patient\u2019s referring provider?'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Integration into existing workflow'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Once you have outlined things that will change due to telehealth, it is important to identify how your practice will accommodate these aspects. Integrating telehealth into your practice\u2019s current clinical and administrative processes has less of a learning curve and is less disruptive than designing new processes.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '10'
                                ),
                                ' It is important to consider your current infrastructure and workflow and integrate telehealth services accordingly.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '11,12'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'protocols:'
                                    ),
                                    ' Identify and document activities for a telehealth encounter, including the service (i.e., when and how telehealth will be used), person(s) involved, system involved and any other considerations. If staff have questions about the protocols or raise concerns, it is easier to make changes before roll-out than after. It is important to have multiple roles and perspectives involved to fully understand impacts.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '13,14'
                                    ),
                                    ' Design simple and easy to read telehealth protocols, which can include flow charts, or look similar to the practice\u2019s current protocol design. Samples may be available from telehealth associations or other organizations.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'documentation:'
                                    ),
                                    ' Work with your vendor to ensure that telehealth services and documentation are integrated into the current electronic health record (EHR) to prevent multiple documentation streams.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '11,12,15'
                                    ),
                                    ' Work with your vendor to try to minimize toggling back and forth between screens and how many different systems or interfaces need to be accessed.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '16-19'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'dissemination within the practice:'
                                    ),
                                    ' Communicate expectations with the staff about how telehealth will fit into the practice and its processes, expectations for involvement of staff, and patients who will use services.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '16,17,20'
                                    ),
                                    ' This will help staff plan for scheduling, workflow, and fulfilling the expectations for involvement.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'test encounter:'
                                    ),
                                    ' Conduct a test telehealth encounter, compare it to protocols developed and make any changes that are necessary to improve workflow and ensure that the protocols closely matches encounters in practice.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'The ',
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { className: 'underline', to: '/resources' },
                                    'Telehealth Resources page'
                                ),
                                ' and your vendor will be important resources for you when evaluating your workflow and considering how telehealth will impact it.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kreofsky BLH, Blegen RN, Lokken TG, Kapraun SM, Bushman MS, Demaerschalk BM. Sustainable telemedicine: designing and building infrastructure to support a comprehensive telemedicine practice. Telemed J E Health. 2018. PMID: 29658828. doi: 10.1089/tmj.2017.0291'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. J Neurosurg Pediatr. 2016;25(6):753-757. PMID: 27589599. doi: 10.3171/2016.6.peds16202'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Shaw RJ, Kaufman MA, Bosworth HB, et al. Organizational factors associated with readiness to implement and translate a primary care based telemedicine behavioral program to improve blood pressure control: the HTN-IMPROVE study. Implement Sci. 2013;8:106. PMID: 24010683. doi: 10.1186/1748-5908-8-106'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Maunder K, Walton K, Williams P, Ferguson M, Beck E. A framework for eHealth readiness of dietitians. Int J Med Inform. 2018;115:43-52. PMID: 29779719. doi: 10.1016/j.ijmedinf.2018.04.002'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka J, Simpson K, Hiott L, Langston L, Fakhry S, Ford D. A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res. 2013;13:33. PMID: 23360332. doi: 10.1186/1472-6963-13-33'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Soegaard Ballester JM, Scott MF, Owei L, Neylan C, Hanson CW, Morris JB. Patient preference for time-saving telehealth postoperative visits after routine surgery in an urban setting. Surgery. 2018;163(4):672-679. PMID: 29398042. doi: 10.1016/j.surg.2017.08.015'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Glenn IC, Bruns NE, Hayek D, Hughes T, Ponsky TA. Rural surgeons would embrace surgical telementoring for help with difficult cases and acquisition of new skills. Surg Endosc. 2017;31(3):1264-1268. PMID: 27444835. doi: 10.1007/s00464-016-5104-6'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Binder WJ, Cook JL, Gramze N, Airhart S. Telemedicine in the intensive care unit: improved access to care at what cost? Crit Care Nurs Clin North Am. 2018;30(2):289-296. PMID: 29724446. doi: 10.1016/j.cnc.2018.02.010'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Hoonakker PLT, Carayon P. Work system barriers and strategies reported by tele-intensive care unit nurses: a case study. Critical Care Nursing Clinics of North America. 2018;30(2):259-271. PMID: 129386687. Language: English. Entry Date: 20180508. Revision Date: 20180508. Publication Type: Article. Journal Subset: Core Nursing. doi: 10.1016/j.cnc.2018.02.008'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ferreira A. Steps to telehealth success - organizational readiness. 2016. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.avizia.com/blog/telehealth-success-organizational-readiness', target: '_blank' },
                                        'www.avizia.com/blog/telehealth-success-organizational-readiness'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon MP, Duplantie J, Fortin JP, Landry R. Implementing telehealth to support medical practice in rural/remote regions: what are the conditions for success? Implementation Science. 2006(18). doi: doi:10.1186/1748-5908-1-18'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gagnon MP, Ngangue P, Payne-Gagnon J, Desmartis M. m-Health adoption by healthcare professionals: a systematic review. J Am Med Inform Assoc. 2016;23(1):212-220. PMID: 26078410. doi: 10.1093/jamia/ocv052'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci. 2016;11(1):146. PMID: 27782832. doi: 10.1186/s13012-016-0510-7'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Griffith ML, Siminerio L, Payne T, Krall J. A shared decision-making approach to telemedicine: engaging rural patients in glycemic management. J Clin Med. 2016;5(11). PMID: 27869655. doi: 10.3390/jcm5110103'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks E, Turvey C, Augusterfer EF. Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health. 2013;19(6):433-437. PMID: 23590176. doi: 10.1089/tmj.2013.0068'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Karem P, Shifflett K, Vegi L, Ravi K, Brooks M. Evaluating barriers to adopting telemedicine worldwide: a systematic review. Journal of Telemedicine and Telecare. 2018;24(1):4-12. PMID: WOS:000419868900002. doi: 10.1177/1357633x16674087'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'L\'Esperance ST, Perry DJ. Assessing advantages and barriers to telemedicine adoption in the practice setting: a MyCareTeam (TM) exemplar. Journal of the American Association of Nurse Practitioners. 2016;28(6):311-319. PMID: WOS:000378357300005. doi: 10.1002/2327-6924.12280'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Haverhals LM, Sayre G, Helfrich CD, et al. E-consult implementation: lessons learned using consolidated framework for implementation research. Am J Manag Care. 2015;21(12):e640-647. PMID: 26760426'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Krowski N, Rodriguez B, Tran L, Vela J, Brooks M. Telehealth and patient satisfaction: a systematic review and narrative analysis. BMJ Open. 2017;7(8):e016242. PMID: 28775188. doi: 10.1136/bmjopen-2017-016242'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};
exports.default = Operations32;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations33 = function Operations33(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Operational Requirements'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth involves patients and providers who are not co-located and thus has unique operational considerations related to coordination, licensure, reimbursement, and credentialing.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ' There are also legal considerations, including privacy and professional liability concerns that must be monitored as the policy landscape evolves.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '2,3'
                ),
                ' Representatives from both the originating site (where the patient is located) and the distant site (where the provider is located) must work together to determine what types of services telehealth should be used for, workflow, identify common policies and procedures, and identify communication and coordination mechanisms. Identifying points of contact at the originating and distant sites and taking steps to develop and maintain good relationships between sites is useful in working through telehealth implementation and use.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to telehealth implementation. These include formalizing relationships between sites, understanding licensing and credentialing considerations, creating protections for privacy, and navigating malpractice concerns.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Formalizing relationships between sites'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'coordinate between sites:'
                                    ),
                                    ' Relationships between originating and distant sites vary in formality. Some of the most formal involve contracting with a third party to provide telehealth services and supports including clinical staff. Others may involve a referring relationship between a primary care and specialty provider without specific written agreements. Regardless of the contractual nature of the relationship, it is important to ensure that you coordinate policies and procedures between sites and establish clear expectations for communication and processes.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '2,3'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'build relationships:'
                                    ),
                                    ' Provide opportunities for referring providers to build relationships with consulting providers. This can be accomplished through in-person meetings, phone calls or using telehealth technology. This can help build trust and establish patterns for referrals.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '4'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'identify coordinators:'
                                    ),
                                    ' Identify a person at each site who is responsible for coordination and administrative activities and provide opportunities for them to discuss expectations around documentation, coordination, scheduling and referrals.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'clarify expectations:'
                                    ),
                                    ' Ensure that coordinators understand the expectations and address workflow concerns and considerations with the relevant people in your practice. For example, if there is a concern about how pictures will be taken and shared between sites, practice leadership should seek input from those who will take and upload pictures and those who will receive and view the pictures. Testing telehealth with a patient or two then debriefing with the care team about the process, areas of tension and potential areas of improvement can help foster a collaborative working relationship between sites.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '6,7'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Licensure and credentialing'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Your practice should review licensure and credentialing considerations when building and/or expanding telehealth programs and establish a mechanism for monitoring changes. One reason to keep up with changes is that these items impact provider arrangements and the availability of services.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '8,9'
                                ),
                                ' If you intend to provide services within Maryland to patients in Maryland, then credentialing across organizations is more important than licensing, which is more relevant when practicing across state lines.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'state licensure'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Practices should consider the impact of state and local policies on licensing.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '10'
                                ),
                                ' Generally, telehealth providers deliver services in the same state as the patient.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '11'
                                ),
                                ' If your practice is considering providing services across state lines, there are several things to consider.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'The Maryland Board of Physicians requires certain practice standards of certain practitioners who practice telemedicine, which are outlined in the ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.dsd.state.md.us/COMAR/SubtitleSearch.aspx?search=10.32.05.*', target: '_blank' },
                                        'regulation COMAR 10.32.05'
                                    ),
                                    '. Practitioners licensed by the Board of Physicians, using telehealth or planning to use telehealth, should be familiar with these licensure requirements.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Identify if there are providers in the practice who hold multiple state licenses. If so, those providers are good candidates to provide services across states.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '12'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'If your practice chooses to provide telehealth services across state lines, decide if this is feasible based on state requirements, patient volume (e.g., does the anticipated volume justify the resources needed to secure another state license), or other needs outside of telehealth.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '12,13'
                                    ),
                                    ' This may involve practitioners applying for licenses in a neighboring state to ensure they can cover telehealth visits for patients living there, or the facility asking for distant providers to apply for licenses to practice within Maryland.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'credentialing'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'If providers in your practice intend to provide telehealth services to facilities, you need to consider the credentialing processes at these facilities. Hospitals may have different types of credentialing for telehealth services versus face to face services. This might apply to you if your practice expects to be the distant site (where the provider is) and the facility the originating site (where the patient is). For example, a psychiatrist could provide tele-behavioral health in a nursing home rather than going to the facility, but that may require separate credentialing from the facility. Call the credentialing office of the facility itself to learn more about their processes and inquire if they allow credentialing by proxy with any of your currently credentialed facilities.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '14'
                                ),
                                ' Also ask facilities if they participate in delegated credentialing.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'example-box' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'uppercase blue-text' },
                                    'delegated credentialing'
                                ),
                                ' In 2011 the Centers for Medicare and Medicaid Services (CMS) allowed for delegated credentialing to the distant hospitals and clinics essentially trusting that their providers have been appropriately vetted by another facility\u2019s credentialing office. If a facility in which you are considering offering telehealth services participates in delegated credentialing then your practice\u2019s providers may be able to avoid going through the credentialing process again.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7'
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'a',
                                    { href: 'https://www.cms.gov/Medicare/Provider-Enrollment-and-Certification/SurveyCertificationGenInfo/downloads/SCLetter11_32.pdf', target: '_blank' },
                                    'Read this rule from the CMS website'
                                ),
                                '.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Legal considerations'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'uppercase blue-text' },
                                            'REVIEW YOUR TELEHEALTH PROGRAM AS YOU WOULD ANY NEW SERVICE IN YOUR PRACTICE.'
                                        ),
                                        ' Consider the standard of care that applies, scope of practice, where providers may be held liable, and what malpractice insurance may cover.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '15'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Consult with others on the oversight needed for legal considerations. Your vendor will likely have resources based on previous experience. There may also be specific state or federal guidelines across services. Consult organizations that typically help with regulatory issues at your practice (e.g., your professional or medical society/association ), and consider reaching out to others that have implemented a telehealth program to learn about their experiences.',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '16'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Contact your malpractice insurance company prior to implementation. Ask about coverage options, conditions that apply, ePrescribing via telehealth, and if there are safeguards they suggest.',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '17'
                                            ),
                                            ' If there are special considerations that govern telehealth coverage, make sure you understand them.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Identify how you will obtain patient consent virtually.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Identify processes and requirements for ePrescribing via telehealth.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'ASK VENDORS ABOUT PRIVACY AND SECURITY POLICIES AND REGULATIONS.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '17'
                                        )
                                    ),
                                    ' If you are working with a vendor that provides distant site telehealth practitioners, identify the protections they have in place for malpractice and sign agreements outlining your understanding.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '18'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'ESTABLISH A METHOD TO KEEP UP WITH CHANGING REGULATIONS'
                                    ),
                                    ' that may impact the practice of telehealth. As the field evolves, you may find that your previous policies need to be updated.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '11,19'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Weinstein RS, Lopez AM, Joseph BA, et al. Telemedicine, telehealth, and mobile health applications that work: opportunities and barriers. Am J Med. 2014;127(3):183-187. PMID: 24384059. doi: 10.1016/j.amjmed.2013.09.032'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson A, Healy T, et al. A study of a rural community\'s readiness for telehealth. Journal of Telemedicine and Telecare. 2003;9:259-263'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Hertz BT. Telemedicine: patient demand, cost containment drive growth. Joining the trend may not be as expensive or time-consuming as you think, experts say. Med Econ. 2013;90(3):37, 39-42. PMID: 23875274'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. J Neurosurg Pediatr. 2016;25(6):753-757. PMID: 27589599. doi: 10.3171/2016.6.peds16202'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Becevic M, Boren S, Mutrux R, Shah Z, Banerjee S. User satisfaction with telehealth: study of patients, providers, and coordinators. Health Care Manag (Frederick). 2015;34(4):337-349. PMID: 26506296. doi: 10.1097/hcm.0000000000000081'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Uscher-Pines L, Kahn JM. Barriers and facilitators to pediatric emergency telemedicine in the United States. Telemed J E Health. 2014;20(11):990-996. PMID: 25238565. doi: 10.1089/tmj.2014.0015'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Giambrone D, Rao BK, Esfahani A, Rao S. Obstacles hindering the mainstream practice of teledermatopathology. J Am Acad Dermatol. 2014;71(4):772-780. PMID: 24906611. doi: 10.1016/j.jaad.2014.04.043'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Robeznieks A. State boards\' policy for telemedicine may present roadblocks. Mod Healthc. 2014;44(12):12. PMID: 24933751'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vimarlund V, Le Rouge C. Barriers and opportunities to the widespread adoption of telemedicine: a bi-country evaluation. Stud Health Technol Inform. 2013;192:933. PMID: 23920707'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Crane M. Exploring telehealth models. Med Econ. 2014;91(14):17-20. PMID: 25233550'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Adler-Milstein J, Kvedar J, Bates DW. Telehealth among US hospitals: several factors, including state reimbursement and licensure policies, influence adoption. Health Aff (Millwood). 2014;33(2):207-215. PMID: 24493762. doi: 10.1377/hlthaff.2013.1054'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks E, Turvey C, Augusterfer EF. Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health. 2013;19(6):433-437. PMID: 23590176. doi: 10.1089/tmj.2013.0068'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rogove H, Stetina K. Practice challenges of intensive care unit telemedicine. Crit Care Clin. 2015;31(2):319-334. PMID: 25814457. doi: 10.1016/j.ccc.2014.12.009'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kulcsar M, Gilchrist S, George MG. Improving stroke outcomes in rural areas through telestroke programs: an examination of barriers, facilitators, and state policies. Telemed J E Health. 2014;20(1):3-10. PMID: 24286197. doi: 10.1089/tmj.2013.0048'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Khan F. The "uberization" of healthcare: the forthcoming legal storm over mobile health technology\'s impact on the medical profession. Health Matrix Clevel. 2016;26:123-172. PMID: 27263251'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Picking the right telehealth platform for a small or solo practice. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice', target: '_blank' },
                                        'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice'
                                    ),
                                    '. Accessed June, 2018.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Yang YT, Silverman RD. Mobile health applications: the patchwork of legal and liability issues suggests strategies to improve oversight. Health Aff (Millwood). 2014;33(2):222-227. PMID: 24493764. doi: 10.1377/hlthaff.2013.0958'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'North F, Crane SJ, Takahashi PY, et al. Telemedicine barriers associated with regional quality measures. Telemed J E Health. 2014;20(2):179-181. PMID: 24205836. doi: 10.1089/tmj.2013.0167'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Operations33;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactRouterDom = __webpack_require__(12);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations34 = function Operations34(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Assessment Approach'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth implementation involves a change in the mode of care delivery, with corresponding changes in clinical and administrative processes.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ' In order to more fully understand the influence of telehealth on your practice and patients it is important to identify how you will assess progress towards goals, measure impact, and make changes, if necessary, based on the results. An assessment can also be valuable to justify the need to continue or expand the telehealth services to leadership or others. When developing your implementation plan, think about and document how you will assess outcomes and promote continuous improvement for telehealth in your practice.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '2'
                ),
                ' Then, you can implement assessment and clinical and administrative processes in tandem.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to and during telehealth implementation. These include planning for and conducting assessment tasks throughout the practice and planning to act on the results.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Develop a plan to assess and evaluate telehealth'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Consider how you will identify if your practice has met telehealth goals and the data needed to determine this. There are a number of resources available to assist in developing an evaluation plan in the ',
                                _react2.default.createElement(
                                    'span',
                                    { className: 'italicize' },
                                    'Evaluation and Assessment'
                                ),
                                'section of the ',
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { className: 'underline', to: '/resources' },
                                    'Telehealth Resources page'
                                ),
                                '. Those resources outline the mechanics of developing an evaluation plan.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'REVIEW TELEHEALTH IMPLEMENTATION REGULARLY AND MAKE CHANGES'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Develop a process to review how telehealth sessions went and make improvements. Your vendor might have a suggestion for this review.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Discuss perceptions of ease of use and quality with providers. Work to address their concerns to increase satisfaction with telehealth. Your vendor may have experience with this based on their work with other practices and can help arrange site visits with other practices so that your clinicians and staff can see telehealth in action.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '3'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Identify internal processes to assess if telehealth is being used as intended. For example, is telehealth being offered consistently to patients of interest? If triggers are in place to initiate a telehealth encounter, are those being followed consistently?'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Help staff maintain positive interactions with their patients and encourage them to seek patient feedback and identify things that are going well and things that can be improved.',
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '4'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Some staff may fear that implementing telehealth will mean that they no longer have valued face-to-face interactions with patients. Assuage these fears by showing staff that they can have meaningful interactions with patients using telehealth.'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'FACTORS TO CONSIDER IN ASSESSMENT'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'ul-label' },
                                'Assessment should include identifying factors for study and associated data to address them. Factors to identify include:',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '5'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Technical performance:'
                                    ),
                                    ' System uptime; documented hardware or software needs; usability',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '6'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Volume:'
                                    ),
                                    ' Number of encounters, number of encounters eligible for telehealth'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Provider and Staff acceptance:'
                                    ),
                                    ' Engagement, involvement and satisfaction with technology, processes, and work environment',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '3'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Quality of care:'
                                    ),
                                    ' Quality outcomes; staff perception',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Patient satisfaction:'
                                    ),
                                    ' Patient satisfaction survey items (if already collected); patient uptake; no-show rate; changes in adherence or other factors associated with the telehealth intervention',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7,8'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Workflow and processes:'
                                    ),
                                    ' Integration of telehealth into processes such as scheduling, consults, initiating visits; documentation, billing and information exchange',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '9'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Financial performance:'
                                    ),
                                    ' Costs (start-up and ongoing); revenue sources; sustainability considerations such as upcoming changes in reimbursement',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '10'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Plan to act on the results'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Use assessment results to inform continuous quality improvement. Your implementation and assessment should include how often your practice leadership will review results and act on them.'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'ul-label' },
                                'Some common areas to address and associated actions to take include:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Technical:'
                                    ),
                                    ' work with your vendor if there are changes from a technical perspective'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Training:'
                                    ),
                                    ' provide additional or refresher training'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Outcomes:'
                                    ),
                                    ' make changes to what you are measuring if the results show what you are measuring does not align with the goals'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Patient satisfaction:'
                                    ),
                                    ' identify if there are ways to improve the patient experience or opportunities to re-engage patients if necessary, perhaps by determining if patients are appropriate for telehealth'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'bold italicize' },
                                        'Workflow:'
                                    ),
                                    ' make changes to procedures or protocols if you can to make things run more smoothly or to improve progress towards goals or desired outcomes.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'bold italicize' },
                                            'Financial performance:'
                                        ),
                                        ' identify if there are ways to increase volume and reimbursement of services through retraining or patient outreach'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'bold italicize' },
                                                'Example:'
                                            ),
                                            ' A general surgery practice identified a need for wound management and partnered with a wound care center in a larger city to provide wound care remotely. A nurse at the general surgery site provided real-time evaluations of patients with poorly healing wounds and shared that information with the wound care center. This included physical examination, recording measurements of the wound, and taking pictures. The wound care clinic reviewed the images remotely and developed treatment recommendations that the general surgery practice carried out.'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'During regular reviews of the wound care practice, both practices found that a physician to physician consultation was needed in addition to the nurse to physician interaction. Thus, both practices modified their protocols such that treatment recommendations were given to the physician and the nurse simultaneously instead of to the nurse alone. This improved physician satisfaction at the general surgery practice. The practice found that they were able to keep more of their patients with poorly healing wounds in the practice and prevent patients from having to travel. They also reduced admissions due to wounds. Patient feedback was overwhelmingly positive.'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kreofsky BLH, Blegen RN, Lokken TG, Kapraun SM, Bushman MS, Demaerschalk BM. Sustainable telemedicine: designing and building infrastructure to support a comprehensive telemedicine practice. Telemed J E Health. 2018. PMID: 29658828. doi: 10.1089/tmj.2017.0291'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Richert S. Beyond videoconferencing: Is your infrastructure ready for telemedicine? Health Manag Technol. 2017;38(4):10. PMID: 29474038'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Boob D. What is the level of satisfaction for patients and/or families and healthcare providers as measured by satisfaction tool that have received telestroke consultation services: doctoral dissertation2017.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brookes N, Murata L, Tansey M. Guiding practice development using the Tidal Commitments. Journal of Psychiatric and Mental Health Nursing. 2006;13(4):460-463. PMID: 2009258330'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka J, Simpson K, Hiott L, Langston L, Fakhry S, Ford D. A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res. 2013;13:33. PMID: 23360332. doi: 10.1186/1472-6963-13-33'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Picking the right telehealth platform for a small or solo practice. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice', target: '_blank' },
                                        'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice'
                                    ),
                                    '. Accessed June, 2018.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Binder WJ, Cook JL, Gramze N, Airhart S. Telemedicine in the intensive care unit: improved access to care at what cost? Crit Care Nurs Clin North Am. 2018;30(2):289-296. PMID: 29724446. doi: 10.1016/j.cnc.2018.02.010'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'North F, Crane SJ, Takahashi PY, et al. Telemedicine barriers associated with regional quality measures. Telemed J E Health. 2014;20(2):179-181. PMID: 24205836. doi: 10.1089/tmj.2013.0167'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'LeRouge C, Garfield MJ. Crossing the telemedicine chasm: have the U.S. barriers to widespread adoption of telemedicine been significantly reduced? Int J Environ Res Public Health. 2013;10(12):6472-6484. PMID: 24287864. doi: 10.3390/ijerph10126472'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci. 2016;11(1):146. PMID: 27782832. doi: 10.1186/s13012-016-0510-7'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Operations34;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactRouterDom = __webpack_require__(12);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations35 = function Operations35(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Technology'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'The existing technical infrastructure of your practice influences telehealth implementation. It is important to assess your practice\u2019s technical state prior to vendor selection and telehealth implementation. Practices with a robust technical infrastructure including hardware, software and broadband connectivity may not need to invest as much as practices who do not have these technical resources.'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Previous experience with health information technology (health IT) can also help practices launch successful telehealth programs. If your practice has implemented health IT such as Electronic Health Records (EHRs) then you can draw upon that experience when identifying telehealth implementation needs and requirements.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ' Before implementation begins, the practice may want to consider what can be learned from previous health IT implementations and/or reach out to practices that have implemented their own telehealth programs.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to telehealth implementation. These include establishing a strong bandwidth connection capable of supporting telehealth, selecting technology that aligns with the goals of the project and the current state of the practice, and taking practice staff\u2019s experience with technology into account.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Connectivity'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Most telehealth applications require a robust bandwidth connection.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '2-4'
                                ),
                                ' Without sufficient bandwidth, even the best hardware and software may experience lags and interruptions, resulting in inefficient telehealth encounters.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '5'
                                ),
                                ' Simultaneous demands on connectivity such as operating administrative equipment, EHRs, and patient devices on guest Wi-Fi may also contribute to the need for additional bandwidth.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '6'
                                ),
                                ' These issues can cause both staff and patients to lose faith in the program and worry about the quality of telehealth interactions.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'Test your wireless connection'
                                    ),
                                    ' in places where telehealth will be used and at different times of the day to see if connectivity is adequate; i.e., the technology performs as expected (your vendor may have some input in this area). If not, you may need to upgrade bandwidth or explore options such as using a wireless extender.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'MAKE SUGGESTIONS TO YOUR PATIENTS AND OTHER PROVIDERS ABOUT CONNECTIVITY AND TESTING'
                                    ),
                                    ' if telehealth will be used in locations outside of your practice (e.g., provider\u2019s home, ancillary location, patient\u2019s home).'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Hardware & Software'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'uppercase blue-text' },
                                    'IDENTIFY SPECIFIC HARDWARE NEEDS'
                                ),
                                ', such as cameras or \u201Csmart\u201D medical devices, such as digital stethoscopes or otoscopes; software, such as web conferencing programs or platforms to share notes between providers; or additional applications to connect to patients or remote practitioners.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '7'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'If telehealth will be used in locations outside of your practice, identify what technology will be needed in those locations.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'If equipment purchases are needed, look for other uses for the equipment beyond telehealth to maximize the value of the investment.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'compatibility'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Ensure that hardware and software are compatible with the practice\u2019s current systems and will support your practice in the future.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '8'
                                ),
                                ' For example, before purchasing digital otoscopes, your practice could ask the vendor for a test unit to ensure that the device will connect with the telehealth platform and upload information to the EHR automatically.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'IDENTIFY THE TECHNOLOGY AND PROCESS NEEDED TO ENSURE INTEROPERABILITY'
                                    ),
                                    ' to share information across platforms to support care coordination through information that is regularly shared.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '9'
                                    ),
                                    ' Outline the uses for each system and where information will be stored, create processes for sharing information, and work to reduce the effort needed to switch between telehealth and traditional visits.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'IDENTIFY HOW TELEHEALTH AND TECHNOLOGY USE WILL FIT INTO WORKFLOWS.'
                                    ),
                                    ' Does the equipment allow staff to take patient histories or perform examinations as they would in the clinic?',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '10'
                                    ),
                                    ' Before implementation, consider how telehealth may be able to address each element of a patient interaction and complete a walkthrough or practice session to test your understanding.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'usability'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Usability (interface and features) is a key part of vendor selection and implementation.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '11'
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'STAFF SHOULD BE TRAINED'
                                    ),
                                    ' on the equipment prior to implementation and given adequate resources for learning; however, training does not replace usability.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '11-13'
                                    ),
                                    ' Training ensures that staff know how to use the equipment, but if the interface is cumbersome or the features do not fit with regular practice, staff may find the technology is a hindrance.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'CONSIDER USABILITY WITH RESPECT TO YOUR SPECIFIC PATIENT POPULATION.'
                                    ),
                                    ' For example, if your patient population is largely seniors and you are implementing a patient-facing technology, you may wish to select a telehealth application or software that allows for changes in font size to improve readability.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Privacy and Security'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'As with any new technology or service implementation within the practice, consider privacy and security implications. Whether your practice outsources compliance activities or manages them in-house, it is important to ensure that telehealth complies with your privacy and security policies and procedures.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'ul-label' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'uppercase blue-text' },
                                            'ASK VENDORS ABOUT HOW THEY MANAGE HIPAA COMPLIANCE FOR PRIVACY AND SECURITY'
                                        ),
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '2'
                                        ),
                                        '. Questions to ask include:'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Does the vendor have a standard business associate agreement (BAA)? Would they be willing to sign a comprehensive BAA? These agreements help ensure HIPAA requirements are upheld by everyone with access to the information, such as consultants for the vendors or other practices.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'What safeguards does the vendor have in place to ensure that data are protected before, during and after visits?'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Would the vendor be willing to be audited for compliance with HIPAA privacy and security rules?'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'How would information be protected and given to the practice if the vendor goes out of business?'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'ul-label' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'uppercase blue-text' },
                                            'IDENTIFY WAYS TO PROTECT PRIVACY AND SECURITY IN YOUR PRACTICE'
                                        ),
                                        '. Some suggestions to protect privacy include:'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Prior to visits where the patient is in a remote location, you can protect patient\u2019s privacy by establishing security questions or protocols such as having the patient present an ID to the camera to ensure the patient is who they say they are.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'If the patient is joining from outside of a practice, suggest they connect through private networks (i.e. not on a library computer or public Wi-Fi) so their data remains secure.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'For visits in the office, ensure that shared rooms are not used.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'During the visit, ensure that only necessary practitioners are able to hear and see the patient.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'After the visit, ensure that no logs of the conversation are kept outside of secure data systems and that patient information is only transferred securely to approved entities.'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'example-box' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'ul-label' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'uppercase blue-text' },
                                        'SUGGESTIONS TO MAINTAIN SECURITY:'
                                    ),
                                    ' In a small solo practice, the champion is likely to be the physician without a separate administrative champion because he or she is likely involved in both clinical and administrative components of the practice with a small staff.'
                                ),
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Include telehealth in general security standards and policies.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        'Identify and address potential risks, particularly with respect to physical infrastructure.'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Staff experience with technology'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'uppercase blue-text' },
                                    'EVALUATE YOUR STAFF\u2019S IT SKILLS AND EXPERIENCE'
                                ),
                                ' to inform decisions about providing telehealth services and identify training requirements.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '6'
                                ),
                                ' Once you have an understanding of your staff\u2019s health IT and IT literacy, this can inform your training. Your vendor is an important resource for training and education, as are the organizations in ',
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { className: 'underline', to: '/resources' },
                                    'Telehealth Resources'
                                ),
                                '. In addition, you may wish to have additional support available during roll-out.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'uppercase blue-text' },
                                    'IDENTIFY STAFF WITH IT EXPERIENCE.'
                                ),
                                ' Leverage experience from staff who are familiar with IT systems, have experience with similar technology implementations, or are willing to learn new processes.6 Learning from these staff or including them in planning may help identify potential barriers, strategies, or opportunities for improvement.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka J, Simpson K, Hiott L, Langston L, Fakhry S, Ford D. A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res. 2013;13:33. PMID: 23360332. doi: 10.1186/1472-6963-13-33'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Picking the right telehealth platform for a small or solo practice. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice', target: '_blank' },
                                        'https://mhealthintelligence.com/features/picking-the-right-telehealth-platform-for-a-small-or-solo-practice'
                                    ),
                                    '. Accessed June, 2018.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rogers H, Madathil KC, Agnisarman S, et al. A systematic review of the implementation challenges of telemedicine systems in ambulances. Telemedicine and E-Health. 2017;23(9):707-717. PMID: WOS:000410807000003. doi: 10.1089/tmj.2016.0248'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vassilev I, Rowsell A, Pope C, et al. Assessing the implementability of telehealth interventions for self-management support: a realist review. Implementation Science. 2015;10. PMID: WOS:000354182900001. doi: 10.1186/s13012-015-0238-9'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Glenn IC, Bruns NE, Hayek D, Hughes T, Ponsky TA. Rural surgeons would embrace surgical telementoring for help with difficult cases and acquisition of new skills. Surg Endosc. 2017;31(3):1264-1268. PMID: 27444835. doi: 10.1007/s00464-016-5104-6'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Yusif S, Hafeez-Baig A, Soar J. e-Health readiness assessment factors and measuring tools: a systematic review. Int J Med Inform. 2017;107:56-64. PMID: 29029692. doi: 10.1016/j.ijmedinf.2017.08.006'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Maunder K, Walton K, Williams P, Ferguson M, Beck E. A framework for eHealth readiness of dietitians. Int J Med Inform. 2018;115:43-52. PMID: 29779719. doi: 10.1016/j.ijmedinf.2018.04.002'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Binder WJ, Cook JL, Gramze N, Airhart S. Telemedicine in the intensive care unit: improved access to care at what cost? Crit Care Nurs Clin North Am. 2018;30(2):289-296. PMID: 29724446. doi: 10.1016/j.cnc.2018.02.010'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Stempniak M. Revisiting e-visits. Electronic visits slow to be embraced by payers and providers. Hosp Health Netw. 2013;87(10):25. PMID: 24303632'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. J Neurosurg Pediatr. 2016;25(6):753-757. PMID: 27589599. doi: 10.3171/2016.6.peds16202'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brewster L, Mountain G, Wessels B, Kelly C, Hawley M. Factors affecting front line staff acceptance of telehealth technologies: a mixed-method systematic review. J Adv Nurs. 2014;70(1):21-33. PMID: 23786584. doi: 10.1111/jan.12196'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson A, Healy T, et al. A study of a rural community\'s readiness for telehealth. Journal of Telemedicine and Telecare. 2003;9:259-263'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Operations35;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Operations36 = function Operations36(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Physical Space'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Telehealth involves a provider and patient who are not in the same space; thus, it is important to think about the physical space for both parties prior to implementation, whether the spaces are physician offices, facilities, patient homes, health fairs or other locations.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1-3'
                ),
                ' Physical space considerations include identifying the space itself and ensuring equipment availability, video quality, and patient privacy. If staff and patients have had previous negative interactions with technology or with telehealth, ensuring the space is suitable for telehealth and will promote positive encounters is of particular importance to overcome that previous experience.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '4,5'
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'There are several types of actions to consider prior to telehealth implementation. These include identifying physical space needs and ensuring that the space is appropriate.'
            ),
            _react2.default.createElement(
                'ul',
                { className: 'p-padding' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'p-padding' },
                        _react2.default.createElement(
                            'span',
                            { className: 'uppercase blue-text' },
                            'IDENTIFY A PHYSICAL SPACE WHERE THE TELEHEALTH CONSULTATION WILL TAKE PLACE AND ENSURE IT MEETS THE NEEDS FOR A TELEHEALTH VISIT.'
                        ),
                        ' Testing telehealth visits in the space during implementation can help you fine tune things. Resource organizations may have quick reference guides regarding space considerations. Characteristics of the space include:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'p-padding sub-ul' },
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'Private space:'
                            ),
                            ' Protect patient privacy so that the person on the other end does not perceive that those not involved in their care may be listening.',
                            _react2.default.createElement(
                                'sup',
                                null,
                                '6'
                            ),
                            ' If others are there (e.g., a nurse or scribe), make sure to introduce them. If multiple people are using one space, use screens or partitions to reduce background distractions. Remember to pair these with headphones or a headset so audio is clear and to prevent others from overhearing.'
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'NOT VIEWABLE FROM THE OUTSIDE:'
                            ),
                            ' Spaces should not have windows where others can see the interaction to protect patient privacy.',
                            _react2.default.createElement(
                                'sup',
                                null,
                                '1,2,6'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'QUALITY LIGHTING:'
                            ),
                            ' Ensure spaces do not have lighting that will cause a glare or make it difficult to see.',
                            _react2.default.createElement(
                                'sup',
                                null,
                                '6'
                            ),
                            ' Lighting should also be sufficient in all areas of the space if the clinical encounter will require the patient to move in the space. Consider optimal lighting placement and lighting source that reduces shadows and allows for natural clarity and color. More information can be found through the ',
                            _react2.default.createElement(
                                'a',
                                { href: 'http://thesource.americantelemed.org/resources/telemedicine-practice-guidelines', target: '_blank' },
                                'American Telemedicine Association'
                            ),
                            '.'
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'SUFFICIENT SIZE:'
                            ),
                            ' The space should be big enough for telehealth equipment and ensure that patients are able to sit at a comfortable distance from any monitors',
                            _react2.default.createElement(
                                'sup',
                                null,
                                '7'
                            ),
                            ' or comfortably and safely move if needed during the encounter.'
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'ACOUSTICS:'
                            ),
                            ' Ensure acoustics of the space are such that all parties can be heard. You may find that headphones or a headset are needed to ensure that audio is clear, especially for computer-based applications.'
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'margin-bottom' },
                            _react2.default.createElement(
                                'span',
                                { className: 'uppercase blue-text' },
                                'SAFETY:'
                            ),
                            ' The space should provide a safe and comfortable environment for the individual patient and facilitator; ensure any telehealth equipment and other items in the space are not too distracting or intimidating for the patient. If there is a concern about patient safety, steps should be taken to ensure that the space does not have items that can be used by the patient to hurt himself/herself or to hurt others in the room.'
                        )
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'margin-bottom' },
                    _react2.default.createElement(
                        'span',
                        { className: 'uppercase blue-text' },
                        'REVIEW THE SPACE AVAILABLE AT THE DISTANT SITES TO THE EXTENT POSSIBLE'
                    ),
                    ' in addition to making accommodations to your own space. If you are coordinating with another medical site that will host telehealth encounters, mention these best practices to promote a positive experience. If you are providing services to a patient in his or her home, review the above considerations with them prior to the first visit. Encourage patients to select a private space with strong wifi and/or cellular signal to promote reliable technology interaction.'
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'margin-bottom' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            { className: 'uppercase blue-text' },
                            'IDENTIFY EMERGENCY PROTOCOLS'
                        ),
                        ' needed given that the provider and patient are not co-located.'
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'sub-ul' },
                        _react2.default.createElement(
                            'li',
                            null,
                            'For in-facility visits, protocols may involve having staff on-call for concerns. For home visits, protocols might involve having patients report the address they are calling from prior to initiating the visit.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'example-box' },
                        _react2.default.createElement(
                            'span',
                            { className: 'bold uppercase' },
                            'Example:'
                        ),
                        ' If a provider is engaging in a telehealth visit with a patient and that patient demonstrates signs of a heart attack, there needs to be a way to call for and provide immediate help.'
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson, A., Healy, T., Ho, K., Kazanjian, A., Woollard, R., Haydt, S., Bates, J. A study of a rural community\'s readiness for telehealth. Journal of telemedicine and telecare. 2003;9:259-263.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon, M. P., Brandstadt, H. K. Preparing for Success: Readiness Models for Rural Telehealth. J Postgrad Med. 2005;51(4).'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kreofsky BLH, Blegen RN, Lokken TG, Kapraun SM, Bushman MS, Demaerschalk BM. Sustainable Telemedicine: Designing and Building Infrastructure to Support a Comprehensive Telemedicine Practice. Telemedicine journal and e-health : the official journal of the American Telemedicine Association. 2018;2018 Apr 16. doi: 10.1089/tmj.2017.0291. [Epub ahead of print].'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Rogers H, Madathil KC, Agnisarman S, et al. A Systematic Review of the Implementation Challenges of Telemedicine Systems in Ambulances. Telemed e-Health. 2017;23(9):707-717.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vassilev I, Rowsell A, Pope C, et al. Assessing the implementability of telehealth interventions for self-management support: a realist review. Implement Sci. 2015;10.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. Journal of neurosurgery Pediatrics. 2016;25(6):753-757.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Maunder K, Walton K, Williams P, Ferguson M, Beck E. A framework for eHealth readiness of dietitians. International journal of medical informatics. 2018;115:43-52.'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Operations36;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Staff41 = function Staff41(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Education and Awareness'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Successful telehealth programs rely on the commitment and effort of administrative and clinical staff. If staff members understand the benefits of telehealth and why the practice is offering it, that will facilitate implementation. Providing training before implementation can help overcome barriers,',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1'
                ),
                ' shape staff\u2019s perspective on telehealth, improve engagement in the program,',
                _react2.default.createElement(
                    'sup',
                    null,
                    '2'
                ),
                ' prepare staff for implementation, and motivate them to continue the program in the future.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '3'
                ),
                ' To create trainings that motivate and prepare staff for implementation, practices must consider the needs of staff, their motivations in the workplace, and how training can support the development of the program. Staff who are educated and enthusiastic about telehealth will share that enthusiasm with patients and strengthen the program as a whole.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Before implementing telehealth, you should consider several types of actions. These include steps to develop a training program and plan for its delivery. Telehealth vendors often have general training programs, and it is important to ensure that your practice allocates time for them before, during, and after implementation.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Training development'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'DESIGN TRAINING PROGRAMS ABOUT TELEHEALTH TO FACILITATE POSITIVE STAFF ATTITUDES AND SUPPORT FOR TELEHEALTH BY DEMONSTRATING THE VALUE AND EASE OF USE.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Ensure training is personalized to your staff and helps staff understand why the practice is implementing telehealth even if your vendor has telehealth programs that they will administer.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '2,4'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Address the value added to patients',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5'
                                    ),
                                    ' and how to engage them in training efforts.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '6'
                                    ),
                                    ' If your practice has a unique patient population, identify a few practice-specific examples for which telehealth might be helpful. Sharing those with the staff can help illustrate the importance of telehealth in a meaningful way.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Emphasize and demonstrate the reliability and benefits of telehealth to staff.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    ),
                                    ' This can help overcome resistance to something new.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Allocate time for demonstrations of the system and time for staff to adjust to changes.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '8'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'COMPREHENSIVE TRAINING PROGRAMS SHOULD INCLUDE PROCESSES, EXPECTATIONS, AND OTHER FACTORS IN ADDITION TO TECHNOLOGY USE.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'If practice staff are not technically savvy, ensure they work with the vendor on training programs that teach digital communication skills, technology literacy and usage skills, and mHealth products and services.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '9,10'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Share how staff can access ongoing support for information on the system.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '11'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Ensure that training addresses regulatory and compliance issues and any strategies for addressing them (e.g., if there are particular documentation requirements for telehealth encounters).',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5,11'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Educate the staff on the typical flow of a telehealth encounter.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '12'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Inform staff of the roles and responsibilities individuals will play throughout telehealth implementation.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '13'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Training delivery'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'INCLUDE ADMINISTRATIVE AND CLINICAL STAFF IN TRAINING.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Staff should be trained on the technology and processes relevant to the program14-16 and any specific requirements for telehealth encounters that are different.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5,17'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Telehealth training is not often included in professional programs such as residencies, so clinical staff will likely need training on best practices in addition to digital competency.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5,18'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Practices should provide opportunities to assess staff competency levels with using technology and target training for staff who might need additional trainings.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'PROVIDE EDUCATION IN A VARIETY OF FORMATS TO REACH THE GREATEST NUMBER OF INDIVIDUALS.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Vendors generally provide a combination of synchronous and asynchronous educational programs, so take advantage of those and make them available to your team.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Programs include in-person information campaigns, formal trainings, and train-the-trainer programs.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '19,20'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Training may be completed through online webinars, training handbooks, book chapters, academic medical center\u2013supported trainings, and vendor-supplied training.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '21'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Practices can conduct mock telehealth visits to train and engage staff in a visit that closely resembles a live telehealth session.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'blue-line uppercase' },
                                'CREATE OPPORTUNITIES FOR ONGOING EDUCATION DURING AND AFTER IMPLEMENTATION.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Designate people that staff can contact for additional questions or requests for training before, during, and after implementation, including after-hours support if necessary.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '21-23'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Ensure ongoing and periodic education is available; it is particularly important when telehealth technology is not used by staff on a regular basis, for example, only used during certain acute situations.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Establish resources that practitioners and other staff can use to practice with the technology frequently.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '24'
                                    ),
                                    ' These resources may include on-demand videos that can be referenced for technical support or trouble-shooting. Involve the equipment in regular staff meetings or schedule practice telehealth sessions at regular intervals.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Moore MA, Coffman M, Jetty A, Petterson S, Bazemore A. Only 15% of FPs report using telehealth; training and lack of reimbursement are top barriers. Am Fam Physician. 2016;93(2):101. PMID: 26926405'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Davis MM, Freeman M, Kaye J, Vuckovic N, Buckley DI. A systematic review of clinician and staff views on the acceptability of incorporating remote monitoring technology into primary care. Telemed J E Health. 2014;20(5):428-438. PMID: 24731239. doi: 10.1089/tmj.2013.0166'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Nayar P, McFarland KK, Chandak A, Gupta N. Readiness for teledentistry: validation of a tool for oral health professionals. J Med Syst. 2017;41(1):4. PMID: 27822871. doi: 10.1007/s10916-016-0654-7'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Tubat E. Efficacy of telemental health training on mental health practitioner\'s knowledge, attitudes, beliefs, and intent to offer telemental health services: doctoral dissertation2017.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Powell RE, Stone D, Hollander JE. Patient and health system experience with implementation of an enterprise-wide telehealth scheduled video visit program: mixed-methods study. JMIR Med Inform. 2018;6(1):e10. PMID: 29439947. doi: 10.2196/medinform.8479'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vassilev I, Rowsell A, Pope C, et al. Assessing the implementability of telehealth interventions for self-management support: a realist review. Implementation Science. 2015;10. PMID: WOS:000354182900001. doi: 10.1186/s13012-015-0238-9'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Campagna M, Naka F, Lu J. Teledermatology: an updated overview of clinical applications and reimbursement policies. Int J Womens Dermatol. 2017;3(3):176-179. PMID: 28831431. doi: 10.1016/j.ijwd.2017.04.002'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Driessen J, Castle NG, Handler SM. Perceived benefits, barriers, and drivers of telemedicine from the perspective of skilled nursing facility administrative staff stakeholders. J Appl Gerontol. 2018;37(1):110-120. PMID: WOS:000417697100008. doi: 10.1177/0733464816651884'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Baird MB, Whitney L, Caedo CE. Experiences and attitudes among psychiatric mental health advanced practice nurses in the use of telemental health: results of an online survey. J Am Psychiatr Nurses Assoc. 2018;24(3):235-240. PMID: 28748728. doi: 10.1177/1078390317717330'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Slovensky DJ, Malvey DM, Neigel AR. A model for mHealth skills training for clinicians: meeting the future now. Mhealth. 2017;3:24. PMID: 28736733. doi: 10.21037/mhealth.2017.05.03'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross J, Stevenson F, Lau R, Murray E. Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci. 2016;11(1):146. PMID: 27782832. doi: 10.1186/s13012-016-0510-7'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'James HE. Pediatric neurosurgery telemedicine clinics: a model to provide care to geographically underserved areas of the United States and its territories. J Neurosurg Pediatr. 2016;25(6):753-757. PMID: 27589599. doi: 10.3171/2016.6.peds16202'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Meyer J, Pare G. Telepathology impacts and implementation challenges a scoping review. Arch Pathol Lab Med. 2015;139(12):1550-1557. PMID: WOS:000368422300015. doi: 10.5858/arpa.2014-0606-RA'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Slater H, Campbell JM, Stinson JN, Burley MM, Briggs AM. End user and implementer experiences of mhealth technologies for noncommunicable chronic disease management in young adults: systematic review. J Med Internet Res. 2017;19(12). PMID: WOS:000417796900001. doi: 10.2196/jmir.8888'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Yusif S, Hafeez-Baig A, Soar J. e-Health readiness assessment factors and measuring tools: a systematic review. Int J Med Inform. 2017;107:56-64. PMID: 29029692. doi: 10.1016/j.ijmedinf.2017.08.006'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ferreira A. Steps to telehealth success - organizational readiness. 2016. ',
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'http://www.avizia.com/blog/telehealth-success-organizational-readiness', target: '_blank' },
                                        'www.avizia.com/blog/telehealth-success-organizational-readiness'
                                    ),
                                    '.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kim H, Goldsmith JV, Sengupta S, et al. Mobile health application and e-Health literacy: opportunities and concerns for cancer patients and caregivers. J Cancer Educ. 2017;2017 Nov 14. doi: 10.1007/s13187-017-1293-5. [Epub ahead of print]. PMID: 29139070. doi: 10.1007/s13187-017-1293-5'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'McGregor D, Keep M, Brunner M, et al. Preparing e-Health ready graduates: a qualitative focus group study. Stud Health Technol Inform. 2017;239:91-96. PMID: 128801371. doi: 10.3233/978-1-61499-783-2-91'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson A, Healy T, et al. A study of a rural community\'s readiness for telehealth. J Telemed Telecare. 2003;9:259-263'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks E, Turvey C, Augusterfer EF. Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health. 2013;19(6):433-437. PMID: 23590176. doi: 10.1089/tmj.2013.0068'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Karem P, Shifflett K, Vegi L, Ravi K, Brooks M. Evaluating barriers to adopting telemedicine worldwide: a systematic review. J Telemed Telecare. 2018;24(1):4-12. PMID: WOS:000419868900002. doi: 10.1177/1357633x16674087'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Haverhals LM, Sayre G, Helfrich CD, et al. E-consult implementation: lessons learned using consolidated framework for implementation research. Am J Manag Care. 2015;21(12):e640-647. PMID: 26760426'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Uscher-Pines L, Kahn JM. Barriers and facilitators to pediatric emergency telemedicine in the United States. Telemed J E Health. 2014;20(11):990-996. PMID: 25238565. doi: 10.1089/tmj.2014.0015'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Staff41;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Staff42 = function Staff42(_ref) {
    var score = _ref.score;

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Innovators and Champions'
            ),
            !!score && _react2.default.createElement(
                'h4',
                { className: 'bold' },
                'Key component result: ',
                _react2.default.createElement(
                    'span',
                    { className: score.className },
                    score.text
                )
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Implementing telehealth at your practice takes time, dedication, and buy\u2011in from the entire staff. As with any change, before implementing telehealth, it is important to consider the perspectives of staff. Having someone to champion telehealth and discuss the value of telehealth with patients and staff is of paramount importance. The champion can serve several functions throughout implementation and beyond, including maintaining focus on the goal of implementation, responding to naysayers, facilitating communication, and building enthusiasm.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1,2'
                ),
                ' The champion should support telehealth throughout the process of planning and implementation and use.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Your practice should consider several types of actions before and during telehealth implementation. These include working with practice leadership, identifying the champion(s), and providing support to the champion(s).'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Working with practice leadership'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'blue-text uppercase' },
                                    'ENSURE THERE IS SUPPORT FROM PRACTICE LEADERSHIP'
                                ),
                                ' (e.g., senior physician, practice manager).',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '3'
                                ),
                                ' Administrative and clinical leadership can work with the champion to:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Dedicate time and capacity for telehealth activities.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '3'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Emphasize the importance of telehealth and support from the top down to the staff.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '4'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Present a united front to foster positivity toward telehealth.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '1'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'blue-text uppercase' },
                                    'ENGAGE SENIOR CLINICAL STAFF'
                                ),
                                ' in using telehealth and share their experiences. Those widely recognized as leaders can set an example for appropriate use. Understanding the benefits and challenges can be a useful technique for developing staff buy\u2011in.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title' },
                                'Identifying The Champion(s)'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Depending on the structure of your practice, you may wish to identify both clinical and administrative champions.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Champion(s) should have authority and be well respected.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'The champion must be approachable so that staff feel they can ask questions, share concerns, and elicit feedback.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Clinical champions can help educate staff on the clinical benefits of telehealth and work through related workflow and quality implications.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        'Administrative champions can educate non-clinical staff about telehealth and work through coordination and communication implications from an administrative perspective. This way both the clinical and administrative staff will feel that they have a point of contact who understands their unique concerns.'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'example-box' },
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'bold' },
                                                'EXAMPLE: '
                                            ),
                                            'In a small solo practice, the champion is likely to be the physician without a separate administrative champion because he or she is likely involved in both clinical and administrative components of the practice with a small staff.'
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'In a larger practice with more physicians and mid-level providers, a physician who is a telehealth supporter should be the clinical champion. The office manager or front office coordinator would make a suitable administrative champion.'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'The role of the Champion'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Work with the champion(s) to provide support to fulfill their responsibilities, including:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Communicate goals with the staff.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '4'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Help counter resistance to change.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '5'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Get input from staff about potential uses of telehealth.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '6'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Garner excitement so that staff share that excitement with patients.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '1'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Help set expectations with staff and share how telehealth can benefit patients and the practice.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Work with other sites to help develop relationships.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7-10'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Help identify potential implications (workflow, operations, technical) so that they can be addressed as part of planning and reviewed on an ongoing basis.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '7'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Review implementation and use on an ongoing basis and work with providers and staff to address issues and make changes that optimize telehealth implementation and use. Changes may include adding to telehealth offerings, modifying the workflow, and offering refresher trainings. As clinicians or administrative staff gain positive experience with the program, encourage the champion to share these stories. Concrete examples of how the program improved workflow or helped a patient can create buy\u2011in.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ross, J., et al., Factors that influence the implementation of e-health: a systematic review of systematic reviews (an update). Implement Sci, 2016. 11(1): p. 146.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Crane, M., Exploring telehealth models. Med Econ, 2014. 91(14): p. 17-20.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Arkwright, B. Telehealth Readiness Factors\u2014What are They and Why Are They Essential? 2014.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Zapka, J., et al., A mixed methods descriptive investigation of readiness to change in rural hospitals participating in a tele-critical care intervention. BMC Health Serv Res, 2013. 13: p. 33.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Vimarlund, V. and C. Le Rouge, Barriers and opportunities to the widespread adoption of telemedicine: a bi-country evaluation. Stud Health Technol Inform, 2013. 192: p. 933.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Davis, M.M., et al., A systematic review of clinician and staff views on the acceptability of incorporating remote monitoring technology into primary care. Telemed J E Health, 2014. 20(5): p. 428-38.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Uscher-Pines, L. and J.M. Kahn, Barriers and facilitators to pediatric emergency telemedicine in the United States. Telemed J E Health, 2014. 20(11): p. 990-6.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ready for e-health. Gerontechnology, 2016. 15: p. 67s-67s.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Brooks, E., C. Turvey, and E.F. Augusterfer, Provider barriers to telemental health: obstacles overcome, obstacles remaining. Telemed J E Health, 2013. 19(6): p. 433-7.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse, C.S., et al., Evaluating barriers to adopting telemedicine worldwide: a systematic review. J Telemed Telecare, 2018. 24(1): p. 4-12.'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Staff42;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAccessibleAccordion = __webpack_require__(20);

var _reactFadeIn = __webpack_require__(21);

var _reactFadeIn2 = _interopRequireDefault(_reactFadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Patient51 = function Patient51() {
    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            _reactFadeIn2.default,
            null,
            _react2.default.createElement(
                'h4',
                { className: 'bold', style: { marginBottom: 0 } },
                'Patient Engagement and Health Literacy'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Why this is important for your practice'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'The success of telehealth is largely predicated on patient acceptance and buy\u2011in. Patient engagement and health literacy are important markers for telehealth acceptance. Patients (or their caregivers) who are engaged in their care and/or have high health literacy are more likely to use telehealth and have good acceptance',
                _react2.default.createElement(
                    'sup',
                    null,
                    '1,2'
                ),
                ' than those with low health literacy and engagement.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '3'
                ),
                ' Characteristics of your patient population such as age and socioeconomic status can influence telehealth acceptance.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '4'
                ),
                ' In addition, if the perceived need by patients and the barriers to a face-to face-visit are high, those patients may be motivated to use telehealth.',
                _react2.default.createElement(
                    'sup',
                    null,
                    '5'
                ),
                ' Once you understand your patients\u2019 demographics and needs pertaining to telehealth, experience with technology, literacy, and engagement, your practice can tailor the telehealth service, outreach, educational activities, and support services accordingly.'
            ),
            _react2.default.createElement(
                'h6',
                { className: 'sub-header uppercase' },
                'Actions to take'
            ),
            _react2.default.createElement(
                'p',
                { className: 'p-padding' },
                'Your practice should consider several types of actions before and during telehealth implementation. These include reviewing your patient population and identifying how telehealth can meet their needs so that you can tailor offerings accordingly. Evaluating your population\u2019s needs and experience with technology can help you decide if you want to tailor telehealth services for particular populations within your practice, what telehealth services you should offer, and what outreach and educational activities are needed. For example, if your patient population needs support with self-management of diabetes, a patient education or follow-up reminder program focused on the disease may be a good place to start.'
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactAccessibleAccordion.Accordion,
                    { className: 'p-padding', allowMultipleExpanded: true, allowZeroExpanded: true },
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Consider your patient population'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Review your patient population and any subpopulations of interest to identify which telehealth interventions might be the best fit. Your electronic health record may have reports you can run on your population on different variables. Alternatively, your physicians and mid-level providers can think about these demographics for their own patient panels. Think about and identify:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'blue-text uppercase' },
                                            'PATIENT DEMOGRAPHICS'
                                        ),
                                        ' can help you choose telehealth technologies that are accessible and adaptable to your patient population. For example, if the practice decides to target telehealth interventions at an older patient population, then you will want to use technology that requires minimal setup or maintenance and incorporates larger screens or fonts.'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Patient demographics can include factors such as age, socioeconomic status, insurance status (marker of demographics), technology use and availability, any large segment of a particular culture, or language other than English that is spoken',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '6-9'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'blue-text uppercase' },
                                            'PERCEIVED NEED AND MOTIVATION FOR TELEHEALTH.'
                                        ),
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '4,10,11'
                                        ),
                                        ' Understanding the motivation for patients can help practices determine which technologies will fit their needs best and motivate them to continue using telehealth. For example, patients may feel that the practice is easily accessible but be unwilling or unable to drive to a referred specialist. In this case, they may use a service that allows them to teleconference with specialists at the practice more than a service that allows them to reach the practice from home.'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Are the patients mobile? Are there barriers to access to care such as distance, ability to leave the home, transportation, missed days of work, and caregiver availability that telehealth can overcome?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '5,12-14'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Are there associated caregivers (e.g., fathers for an intervention targeting pregnant women or family members for a family intervention) who might benefit from telehealth?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '15'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Do they have conditions requiring multiple visits?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '16,17'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'blue-text uppercase' },
                                            'PATIENT EXPERIENCE WITH TECHNOLOGY AND HEALTH IT'
                                        ),
                                        _react2.default.createElement(
                                            'sup',
                                            null,
                                            '18,19'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Do patients use telehealth?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '20'
                                            ),
                                            ' Do they have experience with other technologies such as portals, self-monitoring, and messaging either with your practice or other health systems in the area?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '20,21'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Does your population have access to and experience with technology and the internet (e.g., do they own a smartphone or computer?)?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '20,22-29'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Do patients trust technology? Do they express privacy concerns?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '30-32'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'blue-text uppercase' },
                                            'PATIENT ENGAGEMENT AND HEALTH LITERACY'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'How engaged are your patients with their health?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '19,33,34'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            'Do your patients comprehend health instructions and would technology help or hinder their comprehension?',
                                            _react2.default.createElement(
                                                'sup',
                                                null,
                                                '24'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'blue-text uppercase' },
                                        'TELEHEALTH SERVICES THAT WOULD FIT YOUR PATIENT POPULATION.'
                                    ),
                                    ' Or, revisit if these services if they have already been identified.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'blue-text uppercase' },
                                        'EDUCATION AND OUTREACH NEEDS'
                                    ),
                                    ' based on your patient population. For example, if your patient population is technically savvy, you will need to provide less education about technical aspects than if your patient population is not used to technology.'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'example-box' },
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    'Consider polling your patients directly about their willingness to use or confidence using telehealth. This should be done in tandem with your own review and not as a substitute because those who respond to the survey are not necessarily representative of your population.'
                                ),
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        { className: 'margin-bottom' },
                                        'While patient demographics, motivation, experience with technology, and health literacy can all be good indicators of telehealth engagement, these can be complex factors to evaluate, and surveys can be used to supplement the practice information.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        { className: 'margin-bottom' },
                                        'Surveying patients before implementing a program may also encourage them to view the service as a response to their needs and desires. This type of survey could be done as part of existing patient surveys you may have in place or informally as part of intake.'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Review telehealth services'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Determine the services for which you would like to use telehealth. You may have already identified services of interest when evaluating core readiness. Reviewing these services once more with the patient population in mind can help you refine your telehealth offerings.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Review the patient population demographics to determine if the service is a suitable fit for the patient population.',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '20'
                                    ),
                                    ' For example, if your population does not have access to the internet (or reliable access) at home and/or is not technically savvy, then an in-office telehealth application would be more suitable than a remote application that requires home internet and technical literacy.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Given the population, determine if your initial ideas for what you would use telehealth for are appropriate. For example, if your telehealth offering includes patient follow-up via telehealth, determine if your patient population is likely to respond promptly and honestly to follow-up contact.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Identify components of education and outreach that are important based on this review. For example, if you are considering remote patient monitoring, then instructions for home use should be given.'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'Develop outreach and educational efforts'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Identify components for education and outreach materials for the patients you are targeting for telehealth based on the population characteristics you have identified above.',
                                _react2.default.createElement(
                                    'sup',
                                    null,
                                    '20,35'
                                ),
                                ' Check in with your vendor to see if they have suggestions as well and make sure to include the elements below in patient educational resources:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'The telehealth service(s) you are offering, why it is useful, what they (patients and/or caregivers) will see that is different and the same from the current state, how they will benefit',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '18'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Ensure staff are educated on telehealth so they can answer questions',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '13,36'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'If there are any requirements from patients (e.g., technology needed for home monitoring), make sure those are clearly outlined',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '37'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'How information will be protected',
                                    _react2.default.createElement(
                                        'sup',
                                        null,
                                        '31,32,38'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Develop and deliver education and outreach materials to patients. These materials need not be detailed \u2013 a simple flier explaining telehealth and the services you offer will work.'
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Keep it short\u2014bullet points are fine'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Consider a frequently asked questions (FAQ) format where you anticipate questions that patients are likely to ask and then answer them'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'See if your vendors have materials you can modify'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Identify a point of contact for patients for questions or technical issues (either in the practice or at the vendor)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Make sure staff are aware of the talking points from the fliers so they can explain the program and answer questions about the materials.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Do not simply hand out fliers; have staff give the fliers to patients while explaining benefits and explaining why telehealth is a good fit for them.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Demonstrate technology with patients before the first use so they know what to expect.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'margin-bottom' },
                                    'Deliver materials in multiple ways:',
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'sub-ul' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'margin-bottom' },
                                            'In the office during visits, put up posters in the office, share on your social media, send postcards or other mailings to patients, and share information with referring providers (if relevant).'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'margin-bottom' },
                                            'Continue to engage with patients after initial implementation'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'margin-bottom' },
                                            'If patients refuse to continue with telehealth or if telehealth use and engagement fall off, ask them why and help them troubleshoot. Identify a person in your practice to stay engaged with patients.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'margin-bottom' },
                                            'Have staff wear \u201Cask me about telehealth\u201D buttons even after implementation so that patients feel comfortable reaching out to staff even if they are in the office for another purpose.'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactAccessibleAccordion.AccordionItem,
                        { className: 'accordion-item' },
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemHeading,
                            null,
                            _react2.default.createElement(
                                _reactAccessibleAccordion.AccordionItemButton,
                                { className: 'accordion-title capitalize' },
                                'References'
                            )
                        ),
                        _react2.default.createElement(
                            _reactAccessibleAccordion.AccordionItemPanel,
                            { className: 'accordion-content' },
                            _react2.default.createElement(
                                'ol',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Karem P, Shifflett K, Vegi L, Ravi K, Brooks M. Evaluating barriers to adopting telemedicine worldwide: a systematic review. J Telemed Telecare. 2018;24(1):4-12. PMID: WOS:000419868900002. doi: 10.1177/1357633x16674087'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kruse CS, Krowski N, Rodriguez B, Tran L, Vela J, Brooks M. Telehealth and patient satisfaction: a systematic review and narrative analysis. BMJ Open. 2017;7(8):e016242. PMID: 28775188. doi: 10.1136/bmjopen-2017-016242'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Paige SR, Krieger JL, Stellefson M, Alber JM. eHealth literacy in chronic disease patients: an item response theory analysis of the eHealth literacy scale (eHEALS). Patient Educ Couns. 2017;100(2):320-326. PMID: 27658660. doi: 10.1016/j.pec.2016.09.008'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Georgsson M, Staggers N. Patients\' perceptions and experiences of a mHealth diabetes self-management system. Comput Inform Nurs. 2017;35(3):122-130. PMID: 27748662. doi: 10.1097/cin.0000000000000296'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bullock DR, Vehe RK, Zhang L, Correll CK. Telemedicine and other care models in pediatric rheumatology: an exploratory study of parents\' perceptions of barriers to care and care preferences. Pediatr Rheumatol Online J. 2017;15(1):55. PMID: 28693580. doi: 10.1186/s12969-017-0184-y'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Koivunen M, Saranto K. Nursing professionals\' experiences of the facilitators and barriers to the use of telehealth applications: a systematic review of qualitative studies. Scand J Caring Sci. 2018;32(1):24-44. PMID: WOS:000426524200003. doi: 10.1111/scs.12445'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Pflugeisen BM, Mou J. Patient satisfaction with virtual obstetric care. Matern Child Health J. 2017;21(7):1544-1551. PMID: 28176034. doi: 10.1007/s10995-017-2284-1'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Polinski JM, Barker T, Gagliano N, Sussman A, Brennan TA, Shrank WH. Patients\' satisfaction with and preference for telehealth visits. J Gen Intern Med. 2016;31(3):269-275. PMID: 26269131. doi: 10.1007/s11606-015-3489-x'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Driessen J, Castle NG, Handler SM. Perceived benefits, barriers, and drivers of telemedicine from the perspective of skilled nursing facility administrative staff stakeholders. J Appl Gerontol. 2018;37(1):110-120. PMID: WOS:000417697100008. doi: 10.1177/0733464816651884'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Bullock DR, Vehe RK, Zhang L, Correll CK. Accessing pediatric rheumatology care: despite barriers, few parents prefer telemedicine. Pediatric Rheumatology. 2016;14. doi: 10.1186/s12969-016-0098-0'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Radhakrishnan K, Xie B, Berkley A, Kim M. Barriers and facilitators for sustainability of tele-homecare programs: a systematic review. Health Serv Res. 2016;51(1):48-75. PMID: 26119048. doi: 10.1111/1475-6773.12327'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Ladika S. Telehealth dials up discussion about payment to providers. Manag Care. 2016;25(6):15-19. PMID: 27464368'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Deen TL, Fortney JC, Schroeder G. Patient acceptance of and initiation and engagement in telepsychotherapy in primary care. Psychiatr Serv. 2013;64(4):380-384. PMID: 23370530. doi: 10.1176/appi.ps.201200198'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Newman-Casey PA, Killeen OJ, Renner M, Robin AL, Lee P, Heisler M. Access to and experiences with e-Health technology among glaucoma patients and their relationship with medication adherence. Telemed J E Health. 2018;2018 Apr 23. doi: 10.1089/tmj.2017.0324. [Epub ahead of print]. PMID: 29683401. doi: 10.1089/tmj.2017.0324'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Mackert M, Guadagno M, Lazard A, et al. Engaging men in prenatal health promotion: a pilot evaluation of targeted e-Health content. Am J Mens Health. 2017;11(3):719-725. PMID: 27956587. doi: 10.1177/1557988316679562'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Crane M. Exploring telehealth models. Med Econ. 2014;91(14):17-20. PMID: 25233550'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'North F, Crane SJ, Takahashi PY, et al. Telemedicine barriers associated with regional quality measures. Telemed J E Health. 2014;20(2):179-181. PMID: 24205836. doi: 10.1089/tmj.2013.0167'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Gurupur V, Shettian K, Xu P, et al. Identifying the readiness of patients in implementing telemedicine in northern Louisiana for an oncology practice. Health Informatics J. 2017;23(3):181-196. PMID: 27102886. doi: 10.1177/1460458216639740'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Call VR, Erickson LD, Dailey NK, et al. Attitudes toward telemedicine in urban, rural, and highly rural communities. Telemed J E Health. 2015;21(8):644-651. PMID: 25839334. doi: 10.1089/tmj.2014.0125'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Slater H, Campbell JM, Stinson JN, Burley MM, Briggs AM. End user and implementer experiences of mhealth technologies for noncommunicable chronic disease management in young adults: systematic review. J Med Internet Res. 2017;19(12). PMID: WOS:000417796900001. doi: 10.2196/jmir.8888'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Yusif S, Hafeez-Baig A, Soar J. e-Health readiness assessment factors and measuring tools: a systematic review. Int J Med Inform. 2017;107:56-64. PMID: 29029692. doi: 10.1016/j.ijmedinf.2017.08.006'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'O\'Connor S, Hanlon P, O\'Donnell CA, Garcia S, Glanville J, Mair FS. Understanding factors affecting patient and public engagement and recruitment to digital health interventions: a systematic review of qualitative studies. BMC Med Inform Decis Mak. 2016;16(1):120. PMID: 27630020. doi: 10.1186/s12911-016-0359-3'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'O\'Connor S, Hanlon P, O\'Donnell CA, Garcia S, Glanville J, Mair FS. Barriers and facilitators to patient and public engagement and recruitment to digital health interventions: protocol of a systematic review of qualitative studies. BMJ Open. 2016;6(9):e010895. PMID: 27591017. doi: 10.1136/bmjopen-2015-010895'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Viers BR, Pruthi S, Rivera ME, et al. Are patients willing to engage in telemedicine for their care: a survey of preuse perceptions and acceptance of remote video visits in a urological patient population. Urology. 2015;85(6):1233-1239. PMID: 25863832. doi: 10.1016/j.urology.2014.12.064'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Gagnon MP, Brandstadt HK. Preparing for success: readiness models for rural telehealth. J Postgrad Med. 2005;51(4)'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jenkins C, Burkett NS, Ovbiagele B, et al. Stroke patients and their attitudes toward mHealth monitoring to support blood pressure control and medication adherence. Mhealth. 2016;2. PMID: 27347490. doi: 10.21037/mhealth.2016.05.04'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'McGillicuddy JW, Weiland AK, Frenzel RM, et al. Patient attitudes toward mobile phone-based health monitoring: questionnaire study among kidney transplant recipients. J Med Internet Res. 2013;15(1):e6. PMID: 23305649. doi: 10.2196/jmir.2284'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'L\'Esperance ST, Perry DJ. Assessing advantages and barriers to telemedicine adoption in the practice setting: a MyCareTeam (TM) exemplar. J Am Assoc Nurse Pract. 2016;28(6):311-319. PMID: WOS:000378357300005. doi: 10.1002/2327-6924.12280'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Mark JR, Rodriguez MC, Freischlag JA, Melnikow J, Humphries MD. Are patients with critical limb ischemia ready for telemedicine? J Vasc Surg. 2017;65(6):115S-115S. PMID: WOS:000403108000204. doi: 10.1016/j.jvs.2017.03.216'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Campagna M, Naka F, Lu J. Teledermatology: an updated overview of clinical applications and reimbursement policies. Int J Womens Dermatol. 2017;3(3):176-179. PMID: 28831431. doi: 10.1016/j.ijwd.2017.04.002'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Becevic M, Boren S, Mutrux R, Shah Z, Banerjee S. User satisfaction with telehealth: study of patients, providers, and coordinators. Health Care Manag (Frederick). 2015;34(4):337-349. PMID: 26506296. doi: 10.1097/hcm.0000000000000081'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Depatie A, Bigbee JL. Rural older adult readiness to adopt mobile health technology: a descriptive study. Online J Rural Nurs Health Care. 2015;15(1):150-184. PMID: 103297499. Language: English. Entry Date: 20161207. Revision Date: 20170515. Publication Type: Article. doi: 10.14574/ojrnhc.v15i1.346'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Chesser A, Burke A, Reyes J, Rohrberg T. Navigating the digital divide: a systematic review of eHealth literacy in underserved populations in the United States. Inform Health Soc Care. 2016;41(1):1-19. PMID: 25710808. doi: 10.3109/17538157.2014.948171'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Kim H, Goldsmith JV, Sengupta S, et al. Mobile health application and e-Health literacy: opportunities and concerns for cancer patients and caregivers. J Cancer Educ. 2017;2017 Nov 14. doi: 10.1007/s13187-017-1293-5. [Epub ahead of print]. PMID: 29139070. doi: 10.1007/s13187-017-1293-5'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Park H, Cormier E, Glenna G. Health consumers eHealth literacy to decrease disparities in accessing ehealth information. Stud Health Technol Inform. 2016;225:895-896. PMID: 27332397'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Jennett P, Jackson A, Healy T, et al. A study of a rural community\'s readiness for telehealth. J Telemed Telecare. 2003;9:259-263'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Woo K, Dowding D. Factors affecting the acceptance of telehealth services by heart failure patients: an integrative review. Telemed J E Health. 2018;24(4):292-300. PMID: 28767315. doi: 10.1089/tmj.2017.0080'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    'Schwamm LH. Telehealth: seven strategies to successfully implement disruptive technology and transform health care. Health Aff (Millwood). 2014;33(2):200-206. PMID: 24493761. doi: 10.1377/hlthaff.2013.1021'
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = Patient51;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

var _StartSectionBtn = __webpack_require__(446);

var _StartSectionBtn2 = _interopRequireDefault(_StartSectionBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartPage = function StartPage() {
    (0, _react.useEffect)(function () {
        document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
    }, []);

    var handleClick = function handleClick() {
        document.getElementById("bottom-anchor").scrollIntoView({ behavior: "smooth" });
    };

    var handleScroll = function handleScroll() {
        if (!!document.getElementById("scroll-btn")) {
            document.getElementById("scroll-btn").classList.add("hidden");
            setTimeout(function () {
                return document.getElementById("scroll-btn").classList.add("deleted");
            }, 500);
        }
    };
    window.addEventListener("scroll", handleScroll, { once: true });

    return _react2.default.createElement(
        'div',
        { className: 'grid-container page' },
        _react2.default.createElement(
            'div',
            { className: 'menu-intro' },
            _react2.default.createElement(
                'h3',
                { className: 'bold' },
                'Is your practice ready to offer telehealth services?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'This telehealth readiness assessment tool is intended to be completed in around 20 minutes by the lead physician or office manager in collaboration with other stakeholders in their practice.'
            ),
            _react2.default.createElement(
                'p',
                { className: 'bold' },
                'Select one of the five key concepts of telehealth to get started. The concepts may be completed in any order.'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'section-btns-list' },
            _sections2.default.map(function (section) {
                return _react2.default.createElement(_StartSectionBtn2.default, { section: section, key: section.secId });
            })
        ),
        _react2.default.createElement('div', { id: 'bottom-anchor' }),
        _react2.default.createElement(
            'div',
            { id: 'scroll-btn', className: 'scroll-down-bar', onClick: handleClick },
            _react2.default.createElement(
                'svg',
                { width: '50px', height: '35px', viewBox: '0 0 50 35', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                _react2.default.createElement(
                    'g',
                    { fill: '#333366' },
                    _react2.default.createElement('path', { d: 'M1.01219841,6.81250842 L0.99136662,6.81250842 C-0.366232515,5.21265824 -0.324262312,2.66643113 1.08510969,1.12535098 C2.4944817,-0.415729176 4.73755501,-0.368086692 6.09515419,1.23176345 L25.0104159,23.4365072 L43.9048458,1.23176345 C45.2624449,-0.368086732 47.5055183,-0.415729236 48.9148903,1.12535094 C50.3242623,2.66643111 50.3662325,5.21265824 49.0086333,6.81250842 L25.0104159,35 L1.01219841,6.81250842 Z', id: 'Shape' })
                )
            )
        )
    );
};

exports.default = StartPage;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactRouterDom = __webpack_require__(12);

var _CompletedIcon = __webpack_require__(447);

var _CompletedIcon2 = _interopRequireDefault(_CompletedIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartSectionBtn = function StartSectionBtn(_ref) {
    var completed = _ref.completed,
        section = _ref.section;

    return _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'start-section-btn ' + (completed && "start-section-btn--completed"), to: '/menu/' + section.secId },
        _react2.default.createElement('div', { className: 'icon ' + section.secId + '-icon', dangerouslySetInnerHTML: section.icon }),
        _react2.default.createElement(
            'div',
            { className: 'start-section-btn__text' },
            _react2.default.createElement(
                'h4',
                { className: 'bold' },
                section.number + '. ' + section.title
            ),
            _react2.default.createElement(
                'p',
                null,
                section.summary1
            ),
            _react2.default.createElement(
                'p',
                null,
                section.summary2
            )
        ),
        completed && _react2.default.createElement(_CompletedIcon2.default, null)
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    var section = state.tracker[props.section.secId];
    var subSections = Object.values(section);
    var incompleteSub = subSections.find(function (subSection) {
        return !subSection.completed;
    });
    if (incompleteSub) {
        return {
            completed: false
        };
    } else {
        return {
            completed: true
        };
    }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StartSectionBtn);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompletedIcon = function CompletedIcon() {
    return _react2.default.createElement(
        "div",
        { className: "success-circle" },
        _react2.default.createElement(
            "svg",
            { width: "30px", height: "30px", viewBox: "0 0 40 40", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("path", { d: "M20,0 C8.955,0 0,8.955 0,20 C0,31.045 8.955,40 20,40 C31.045,40 40,31.045 40,20 C40,8.955 31.045,0 20,0", fill: "#409C01" }),
                _react2.default.createElement("path", { d: "M28.9636902,12.8116414 L17.677351,23.2918136 L12.0341814,17.6486439 C11.651252,17.2334679 10.4218472,16.0363098 8.80951305,17.6486439 C7.19717887,19.2609781 8.42658368,20.4581362 8.80951305,20.8733123 L17.677351,29.7411503 L32.1883586,16.0363098 C32.5793496,15.6433033 33.8006928,14.4239756 32.1883586,12.8116414 C30.5760244,11.1993072 29.3566967,12.4206504 28.9636902,12.8116414 Z", fill: "#FFFFFF" })
            )
        )
    );
};

exports.default = CompletedIcon;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(47);

var _reactRouterDom = __webpack_require__(12);

var _NextBtn = __webpack_require__(79);

var _NextBtn2 = _interopRequireDefault(_NextBtn);

var _sections = __webpack_require__(54);

var _sections2 = _interopRequireDefault(_sections);

var _subSections = __webpack_require__(62);

var _subSections2 = _interopRequireDefault(_subSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubSectionResultsList = function SubSectionResultsList(_ref) {
    var secId = _ref.secId,
        subSectionData = _ref.subSectionData;

    (0, _react.useEffect)(function () {
        document.getElementById("section-anchor").scrollIntoView({ behavior: "smooth" });
    }, [secId]);

    (0, _react.useEffect)(function () {
        document.getElementById("top-anchor").scrollIntoView({ behavior: "smooth" });
    }, []);

    var currentSection = _sections2.default.find(function (section) {
        return section.secId === secId;
    });

    var nextArgs = secId === "patient" ? { nextLabel: "Results", nextLink: "/results" } : { nextLabel: "Next Concept", nextLink: '/menu/' + _sections2.default[currentSection.number].secId };

    var findProps = function findProps(score) {
        if (score <= 50) {
            return {
                word: "Area for Improvement",
                description: "The practice is in the beginning stages and/or has not considered many of the aspects related to the key component.",
                className: "low-score"
            };
        } else if (score <= 75) {
            return {
                word: "Almost Ready",
                description: "The practice has considered some aspects related to the key component.",
                className: "medium-score"
            };
        } else {
            return {
                word: "Ready",
                description: "The practice has considered many aspects related to the key component.",
                className: "high-score"
            };
        }
    };

    var displayScore = function displayScore(score) {
        var props = findProps(score);
        return _react2.default.createElement(
            'div',
            { className: 'sub-score-container' },
            _react2.default.createElement(
                'h4',
                { className: 'bold ' + props.className },
                props.word
            ),
            _react2.default.createElement(
                'p',
                null,
                props.description
            )
        );
    };

    var toggleConceptMenu = function toggleConceptMenu() {
        var conceptNav = document.getElementsByClassName("concept-nav")[0];
        conceptNav.classList.toggle("concept-nav--mobile");
    };

    return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(
            'div',
            { className: 'grid-container' },
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
                'div',
                { className: 'grid-x' },
                _react2.default.createElement(
                    'div',
                    { className: 'results-intro cell small-12' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'bold' },
                        'Key Components of ' + currentSection.title
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Each telehealth concept is made up of one or more key components. Supporting guidance documents are provided with each key component to provide additional information that can help you improve your practice\u2019s telehealth readiness in a particular area.'
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'collapsed-menu-bar collapsed-menu-bar--concepts', onClick: toggleConceptMenu },
            _react2.default.createElement('div', { className: 'menu-icon' }),
            _react2.default.createElement(
                'div',
                { className: 'menu-title' },
                'Concept Menu'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'grid-container' },
            _react2.default.createElement('div', { id: 'section-anchor', className: 'clear' }),
            _react2.default.createElement(
                'div',
                { className: 'grid-x' },
                _react2.default.createElement(
                    'div',
                    { className: 'subsection-results cell small-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'grid-x grid-margin-x results-side-by-side' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'section-tabs cell small-12 medium-3 concept-nav' },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { className: 'back-btn', to: '/start' },
                                _react2.default.createElement(
                                    'svg',
                                    { viewBox: '0 0 30 14', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
                                    _react2.default.createElement('path', { d: 'M1.78885438,6.10557281 L12.5527864,0.723606798 C13.0467649,0.476617549 13.6474379,0.676841896 13.8944272,1.17082039 C13.9638549,1.30967583 14,1.46278889 14,1.61803399 L14,6 L30,6 C30.5522847,6 31,6.44771525 31,7 C31,7.55228475 30.5522847,8 30,8 L14,8 L14,12.381966 C14,12.9342508 13.5522847,13.381966 13,13.381966 C12.8447549,13.381966 12.6916418,13.3458209 12.5527864,13.2763932 L1.78885438,7.89442719 C1.29487588,7.64743794 1.09465154,7.0467649 1.34164079,6.5527864 C1.43840449,6.359259 1.59532698,6.20233651 1.78885438,6.10557281 Z' })
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    'Back'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'tab-links' },
                                _sections2.default.map(function (section) {
                                    return _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { className: 'tab ' + (section.secId === secId ? 'active background--' + secId + ' border--' + secId : ""), to: '/menu/' + section.secId, key: section.secId },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'tab-content' },
                                            _react2.default.createElement('div', { className: 'icon ' + section.secId + '-icon', dangerouslySetInnerHTML: section.icon }),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'tab-title' },
                                                section.number + '. ' + section.title
                                            )
                                        )
                                    );
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'subsection-results-list cell small-12 medium-9' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'bold background--' + secId },
                                currentSection.number + '. ' + currentSection.title
                            ),
                            subSectionData.map(function (subSection) {
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'subsection-result border--' + secId, key: subSection.subSecId },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'grid-x' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'cell small-12 medium-8 subsection-score-container' },
                                            subSection.title && _react2.default.createElement(
                                                'h4',
                                                null,
                                                '' + currentSection.number + subSection.number + '. ' + subSection.title
                                            ),
                                            !!subSection.score ? displayScore(subSection.score) : _react2.default.createElement(
                                                'div',
                                                { className: 'sub-score-container' },
                                                _react2.default.createElement(
                                                    'p',
                                                    null,
                                                    'Answer questions for this key component to see your result.'
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'cell small-12 medium-4 btn-group' },
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'answer-count' },
                                                subSection.numAnswered + ' out of ' + subSection.totalQuestions + ' questions answered'
                                            ),
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '/question/' + secId + '/' + subSection.subSecId + '/' + subSection.firstQuestion, className: 'btn question-btn btn--key-component-menu' },
                                                'Answer Questions'
                                            ),
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { className: 'btn question-btn btn--key-component-menu', to: '/guidance/' + secId + '/' + subSection.subSecId },
                                                'View Guidance'
                                            )
                                        )
                                    )
                                );
                            }),
                            _react2.default.createElement(
                                'div',
                                { className: 'btn--next-concept' },
                                _react2.default.createElement(_NextBtn2.default, { nextLabel: nextArgs.nextLabel, nextLink: nextArgs.nextLink })
                            )
                        )
                    )
                )
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(state, props) {
    var secId = props.match.params.secId;
    var metaData = _subSections2.default.filter(function (subSection) {
        return subSection.secId === secId;
    });
    var secAnswers = state.answers[secId];

    return {
        secId: secId,
        subSectionData: metaData.map(function (subSection) {
            return {
                firstQuestion: subSection.questions[0],
                numAnswered: Object.values(secAnswers[subSection.subSecId]).filter(function (answer) {
                    return answer !== "";
                }).length,
                number: subSection.number,
                score: state.scores.subSections[subSection.subSecId].score,
                subSecId: subSection.subSecId,
                title: subSection.title,
                totalQuestions: subSection.questions.length
            };
        })
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SubSectionResultsList);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(151);

var _reduxThunk = __webpack_require__(450);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _answers = __webpack_require__(451);

var _answers2 = _interopRequireDefault(_answers);

var _score = __webpack_require__(452);

var _score2 = _interopRequireDefault(_score);

var _tracker = __webpack_require__(453);

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

exports.default = function () {
  var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    answers: _answers2.default,
    scores: _score2.default,
    tracker: _tracker2.default
  }), composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));

  return store;
};

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Pure function
// Never alter state or action directly
var answersDefaultState = {
    "core": {
        "11": {
            "111": "",
            "112": "",
            "113": "",
            "114": "",
            "115": "",
            "116": ""
        },
        "12": {
            "121": "",
            "122": "",
            "123": "",
            "124": ""
        }
    },
    "finance": {
        "21": {
            "211": "",
            "212": "",
            "213": "",
            "214": "",
            "215": ""
        }
    },
    "operations": {
        "31": {
            "311": "",
            "312": "",
            "313": "",
            "314": ""
        },
        "32": {
            "321": "",
            "322": "",
            "323": "",
            "324": "",
            "325": ""
        },
        "33": {
            "331": "",
            "332": "",
            "333": "",
            "334": ""
        },
        "34": {
            "341": "",
            "342": "",
            "343": "",
            "344": ""
        },
        "35": {
            "351": "",
            "352": "",
            "353": "",
            "354": ""
        },
        "36": {
            "361": "",
            "362": "",
            "363": ""
        }
    },
    "staff": {
        "41": {
            "411": "",
            "412": "",
            "413": ""
        },
        "42": {
            "421": "",
            "422": "",
            "423": "",
            "424": ""
        }
    },
    "patient": {
        "51": {
            "511": "",
            "512": "",
            "513": "",
            "514": "",
            "515": ""
        },
        "52": {
            "521": "",
            "522": "",
            "523": ""
        }
    }
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : answersDefaultState;
    var action = arguments[1];

    switch (action.type) {
        case 'SET_ANSWER':
            return _extends({}, state, _defineProperty({}, action.secId, _extends({}, state[action.secId], _defineProperty({}, action.subSecId, _extends({}, state[action.secId][action.subSecId], action.answer)))));
        default:
            return state;
    }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Pure function
// Never alter state or action directly

var scoreDefaultState = {
    subSections: {
        "11": {
            score: null,
            section: "core",
            title: "Need for Telehealth",
            weight: 0.5
        },
        "12": {
            score: null,
            section: "core",
            title: "Organizational Leadership Buy-In",
            weight: 0.5
        },
        "21": {
            score: null,
            section: "finance",
            title: undefined,
            weight: 1
        },
        "31": {
            score: null,
            section: "operations",
            title: "Telehealth Roles",
            weight: 0.125
        },
        "32": {
            score: null,
            section: "operations",
            title: "Scheduling and Workflow",
            weight: 0.25
        },
        "33": {
            score: null,
            section: "operations",
            title: "Operational Requirements",
            weight: 0.125
        },
        "34": {
            score: null,
            section: "operations",
            title: "Assessment Approach",
            weight: 0.125
        },
        "35": {
            score: null,
            section: "operations",
            title: "Technology",
            weight: 0.25
        },
        "36": {
            score: null,
            section: "operations",
            title: "Physical Space",
            weight: 0.125
        },
        "41": {
            score: null,
            section: "staff",
            title: "Education and Awareness",
            weight: 0.5
        },
        "42": {
            score: null,
            section: "staff",
            title: "Innovators and Champions",
            weight: 0.5
        },
        "51": {
            score: null,
            section: "patient",
            title: "Patient Engagement",
            weight: 0.5
        },
        "52": {
            score: null,
            section: "patient",
            title: "Health Literacy",
            weight: 0.5
        }
    },
    sections: {}
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : scoreDefaultState;
    var action = arguments[1];

    switch (action.type) {
        case 'SET_SUBSECTION_SCORE':
            return _extends({}, state, {
                subSections: _extends({}, state.subSections, _defineProperty({}, action.subSecId, _extends({}, state.subSections[action.subSecId], {
                    score: action.score
                })))
            });
        case 'SET_SECTION_SCORE':
            return _extends({}, state, {
                sections: _extends({}, state.sections, _defineProperty({}, action.secId, action.score))
            });
        default:
            return state;
    }
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Pure function
// Never alter state or action directly

var trackerDefaultState = {
    core: {
        "11": {
            completed: false,
            firstQuestion: "111",
            subSecId: "11",
            totalQuestions: 6
        },
        "12": {
            completed: false,
            firstQuestion: "121",
            subSecId: "12",
            totalQuestions: 4
        }
    },
    finance: {
        "21": {
            completed: false,
            firstQuestion: "211",
            subSecId: "21",
            totalQuestions: 5
        }
    },
    operations: {
        "31": {
            completed: false,
            firstQuestion: "311",
            subSecId: "31",
            totalQuestions: 4
        },
        "32": {
            completed: false,
            firstQuestion: "321",
            subSecId: "32",
            totalQuestions: 5
        },
        "33": {
            completed: false,
            firstQuestion: "331",
            subSecId: "33",
            totalQuestions: 4
        },
        "34": {
            completed: false,
            firstQuestion: "341",
            subSecId: "34",
            totalQuestions: 4
        },
        "35": {
            completed: false,
            firstQuestion: "351",
            subSecId: "35",
            totalQuestions: 4
        },
        "36": {
            completed: false,
            firstQuestion: "361",
            subSecId: "36",
            totalQuestions: 3
        }
    },
    staff: {
        "41": {
            completed: false,
            firstQuestion: "411",
            subSecId: "41",
            totalQuestions: 3
        },
        "42": {
            completed: false,
            firstQuestion: "421",
            subSecId: "42",
            totalQuestions: 4
        }
    },
    patient: {
        "51": {
            completed: false,
            firstQuestion: "511",
            subSecId: "51",
            totalQuestions: 5
        },
        "52": {
            completed: false,
            firstQuestion: "521",
            subSecId: "52",
            totalQuestions: 3
        }
    }
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trackerDefaultState;
    var action = arguments[1];

    switch (action.type) {
        case 'SET_LATEST_QUESTION':
            return _extends({}, state, _defineProperty({}, action.secId, _extends({}, state[action.secId], _defineProperty({}, action.subSecId, _extends({}, state[action.secId][action.subSecId], {
                latestQuestion: action.qId
            })))));
        case 'SET_COMPLETED':
            return _extends({}, state, _defineProperty({}, action.secId, _extends({}, state[action.secId], _defineProperty({}, action.subSecId, _extends({}, state[action.secId][action.subSecId], {
                completed: true
            })))));
        default:
            return state;
    }
};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js